webpackJsonp([1],{

/***/ "+VzE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+yEE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('div',{staticClass:"nav-bg container-fluid"},[_c('navigation')],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('h1',[_vm._v("Confirmation Form")]),_vm._v(" "),_c('b-form',[(_vm.step === 1)?_c('div',[_c('h2',[_vm._v("Registration")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              Your conference registration will come from the Student\n              Volunteer Program. Please do "),_c('strong',[_vm._v("NOT")]),_vm._v(" register for\n              SIGGRAPH on your own.\n            ")])]),_vm._v(" "),_c('h2',[_vm._v("Passport")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              Select your current passport status (Please be sure to check the\n              expiration date!)\n            ")]),_vm._v(" "),_c('b-form-radio-group',{staticClass:"radio",attrs:{"id":"passport-status","name":"passportStatus","stacked":""},model:{value:(_vm.form.passportStatus),callback:function ($$v) {_vm.$set(_vm.form, "passportStatus", $$v)},expression:"form.passportStatus"}},[_c('b-form-radio',{attrs:{"value":"noPassport"}},[_vm._v("I do not require a passport to volunteer at SIGGRAPH 2024 in\n                Denver.")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"havePassport"}},[_vm._v("I have a current passport valid through at least September\n                2024.")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"needPassport"}},[_vm._v("I will acquire a valid passport by 30 June\n                2024.")])],1)],1),_vm._v(" "),_c('h2',[_vm._v("Visa Information")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              If you require a letter of invitation to travel to SIGGRAPH 2024\n              in Denver, you will hear from registration in the following\n              few weeks for next steps. To learn more, please visit the\n              "),_c('a',{attrs:{"href":"https://s2024.siggraph.org/international-resources-center/"}},[_vm._v("International Resource Center.")])])]),_vm._v(" "),_c('h2',[_vm._v("Health and Safety")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              SIGGRAPH 2024 follows Colorado laws relating to health and\n              safety. As of November 2023, there are no mandates related to\n              vaccinations, masking or COVID-19 testing.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              These requirements are subject to change based on city, state\n              and national requirements. Check back\n              "),_c('a',{attrs:{"href":"https://s2024.siggraph.org/health-safety"}},[_vm._v("here")]),_vm._v(" for\n              the latest health and safety information.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Laws around international travel to the USA vary by location and\n              it is recommended you familiarize yourself with any travel\n              restrictions specific to your situation.\n            ")])]),_vm._v(" "),_c('h2',[_vm._v("Email Consent")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              From time to time, SIGGRAPH conference, SIGGRAPH contractors,\n              ACM SIGGRAPH Standing Committees or Sponsors might send emails\n              to Student Volunteers such as:\n            ")]),_vm._v(" "),_c('ul',{staticStyle:{"list-style-type":"square","padding-left":"15px"}},[_c('li',[_vm._v("\n                Announcements about upcoming deadlines related to the Student\n                Volunteer Program or other SIGGRAPH conference programs.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Information about professional development opportunities (e.g.\n                Portfolio / Reel Review by S3 Committee) or other activities\n                organized by ACM SIGGRAPH committees.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Where we have the consent of Student Volunteers, emails\n                targeted at this specific groups. Only ACM SIGGRAPH related\n                staff or volunteers can create and support email distribution\n                lists with data from Student Volunteers.\n              ")])]),_vm._v(" "),_c('p',[_vm._v("\n              The SIGGRAPH Student Volunteer Program, or any other ACM\n              SIGGRAPH related entity does not sell, rent, or exchange email\n              addresses of its Student Volunteers. If at any time you decide\n              that you no longer wish to receive any of the emails described\n              above, you may do so by using the \"unsubscribe\" instructions set\n              out at the bottom of each email, or by informing the\n              corresponding party.\n            ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.emailConsent),callback:function ($$v) {_vm.$set(_vm.form, "emailConsent", $$v)},expression:"form.emailConsent"}},[_vm._v("I consent")])],1),_vm._v(" "),_c('h2',[_vm._v("Photo and Video Consent")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              Photos and videos can be taken in the course of the conference\n              and any other audio-visual material can be produced.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              By participating at SIGGRAPH you agree that photos, videos and\n              any other audio-visual material of the event are taken on which\n              you are visible but wherein your person is not the central point\n              of focus. We have a legitimate interest in using such photos,\n              videos and other audio-visual material for the promotion and\n              experience of our Student Volunteer Program and other SIGGRAPH\n              related activities.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              Pictures and other audio-visual material wherein you are the\n              central point of focus can also be taken. We have a legitimate\n              interest to use these photos and audio-visual material in\n              brochures, posters, general marketing material and on the\n              SIGGRAPH website for the promotion of the conference and the\n              future editions of it. You have the right to request the removal\n              of these photos. You can do so by sending an e-mail to\n              "),_c('a',{attrs:{"href":"mailto:sv-s2024@siggraph.org"}},[_vm._v("sv-s2024@siggraph.org")]),_vm._v("\n              with your surname, name and the indication of the photo or video\n              in question.\n            ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.photoConsent),callback:function ($$v) {_vm.$set(_vm.form, "photoConsent", $$v)},expression:"form.photoConsent"}},[_vm._v("I consent")])],1),_vm._v(" "),_c('h2',[_vm._v("ACM SIGGRAPH Student Membership")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              We are offering ACM SIGGRAPH Student Memberships to accepted\n              Student Volunteers. Do you want to receive this membership?\n            ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.wantsMembership),callback:function ($$v) {_vm.$set(_vm.form, "wantsMembership", $$v)},expression:"form.wantsMembership"}},[_vm._v("I would like to recieve an ACM SIGGRAPH Student\n              Membership.")])],1),_vm._v(" "),_c('h2',[_vm._v("Additional Information")]),_vm._v(" "),_c('b-form-group',[_c('p',[_vm._v("\n              Is there any additional information you would like to share with\n              the Student Volunteer Subcommittee? Is there any information we\n              should know when assigning you to conference program shifts?\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              This can regard medical or mental conditions, fears, or any\n              other information that can help us make your experience as an SV\n              more comfortable. All answers will remain confidential.\n            ")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"additional-info","rows":4},model:{value:(_vm.form.additionalInfo),callback:function ($$v) {_vm.$set(_vm.form, "additionalInfo", $$v)},expression:"form.additionalInfo"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',[_c('h2',[_vm._v("Special Shift Requests")]),_vm._v(" "),_c('p',[_vm._v("\n            There are over 70 different types of Student Volunteer shifts.\n            Many shifts are general customer service roles like monitoring\n            doors and providing information for attendees. However, there are\n            several shifts which require more focused skills and interests\n            (i.e., writing, foreign language skills, software demonstrations,\n            social media, etc.); these shifts are outlined below.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            If you are interested in any of the shifts listed below, please\n            read through the descriptions and fill out the questions in this\n            form.\n            "),_c('strong',[_vm._v("Please note that shift assignments to your preferences are not\n              guaranteed")]),_vm._v(". Special shifts will be assigned alongside other shifts prior to\n            the conference.\n          ")]),_vm._v(" "),_c('b-tabs',{attrs:{"pills":"","vertical":"","card":""}},[_c('b-tab',{attrs:{"title":"Pre-Conference Shifts ('Setup')","active":""}},[_c('p',[_vm._v("\n                Are you planning to arrive in Los Angeles earlier than August\n                5th?\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                If so, you can take advantage of our pre-conference shifts\n                which will allow you to fulfill some of your hour commitment\n                prior to the start of SIGGRAPH. Pre-conference shifts will\n                start the morning of Friday, August 4th.\n              ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.preconfShifts),callback:function ($$v) {_vm.$set(_vm.form, "preconfShifts", $$v)},expression:"form.preconfShifts"}},[_vm._v("I'm interested and guarantee that I WILL arrive early in LA\n                to work my assigned pre-conference shifts")]),_vm._v(" "),(_vm.form.preconfShifts)?_c('b-form-group',[_c('label',{attrs:{"for":"preconfStart"}},[_vm._v("Which day are you able to start?")]),_vm._v(" "),_c('b-form-radio-group',{staticClass:"radio",attrs:{"id":"preconf-start","name":"preconfStart"},model:{value:(_vm.form.preconfStart),callback:function ($$v) {_vm.$set(_vm.form, "preconfStart", $$v)},expression:"form.preconfStart"}},[_c('b-form-radio',{attrs:{"value":"friday"}},[_vm._v("Friday, August 4th")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"saturday"}},[_vm._v("Saturday, August 5th")])],1)],1):_vm._e(),_vm._v(" "),(_vm.form.preconfShifts)?_c('b-form-group',[_c('p',[_vm._v("\n                  If you are flying, please make sure that you factor in\n                  travel time from the airport to the Los Angeles Convention\n                  Center (LACC). Also note all times are Pacific Standard Time\n                  (PST).\n                ")]),_vm._v(" "),_c('label',{attrs:{"for":"preconfStartTime"}},[_vm._v("What time will you be able to start a shift?")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"name":"preconfStartTime","id":"preconf-start-time","options":_vm.startTimes},model:{value:(_vm.form.preconfStartTime),callback:function ($$v) {_vm.$set(_vm.form, "preconfStartTime", $$v)},expression:"form.preconfStartTime"}})],1):_vm._e()],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Art Gallery"}},[_c('p',[_vm._v("\n                The Art Gallery is a selectively curated showcase of the most\n                thought-provoking and innovative art made by technologists,\n                engineers, and fine artists in the SIGGRAPH community and\n                across the world.\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                Students Volunteers in the Art Gallery get to work directly\n                with artists explaining and sharing the works with conference\n                attendees. We are looking for students with excellent and\n                enthusiastic communication skills (especially those who have a\n                talent for explaining abstract concepts to others) and are\n                interested in fine art, mixed media, and curation or museum\n                studies.\n              ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.artGallery),callback:function ($$v) {_vm.$set(_vm.form, "artGallery", $$v)},expression:"form.artGallery"}},[_vm._v("I'm interested")])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Emerging Technologies"}},[_c('p',[_vm._v("\n                Emerging Technologies, or E-Tech, is comprised of a series of\n                interactive demonstrations of innovative technologies in a\n                broad range of applications, including displays, robotics,\n                input devices, and interaction techniques.\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                Demos are available for attendees to try out and discuss with\n                the creators. If you are interested in working with some of\n                the leading researchers in the industry and helping them\n                demonstrate their technology to the SIGGRAPH community, this\n                is for you!\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                We are looking for students with excellent communication\n                skills (especially those who have a talent for explaining\n                concepts to others) and are interested in robotics, haptics,\n                and displays.\n              ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.etech),callback:function ($$v) {_vm.$set(_vm.form, "etech", $$v)},expression:"form.etech"}},[_vm._v("I'm interested")])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Labs"}},[_c('p',[_vm._v("\n                Labs presentations will be in-person at the conference and\n                should allow participants to get their hands dirty with the\n                subject being presented. Potential submissions include (but\n                are not limited to): working details from the Technical\n                Papers, Art Papers, or other SIGGRAPH 2024 programs;\n                discussions about prototyping and design in practice;\n                technology overviews from experts in their field; use of AR/VR\n                design tools; adaptive technology; high-speed imaging systems;\n                motion-capture systems; stop-motion animation software;\n                rapid-prototyping machines; interactive drawing tools;\n                physical computing devices or objects; and exploratory\n                platforms. We are looking for students who are interested in\n                demonstrating new technologies and interested in encouraging\n                attendees to participate.\n              ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.labs),callback:function ($$v) {_vm.$set(_vm.form, "labs", $$v)},expression:"form.labs"}},[_vm._v("I'm interested")])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"VR Theater"}},[_c('p',[_vm._v("\n                The VR Theater is a world-class showcase of exemplary virtual\n                reality storytelling that celebrates the early evolution of\n                the medium. The main program is a showcase of the best VR\n                narrative content experienced in a high-end, seated,\n                panoramic, multi-viewer immersive space, running approximately\n                one hour from start to finish. We are looking for students who\n                are comfortable interacting with and guiding attendees -\n                helping to put on and take off VR headsets and expressing\n                verbal communications to guide attendee experience. All SVs\n                who will be assigned at VR Theater will go through one hour\n                training before the shifts start. The training hour will be\n                included as part of the hour commitment.\n              ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.vrtheater),callback:function ($$v) {_vm.$set(_vm.form, "vrtheater", $$v)},expression:"form.vrtheater"}},[_vm._v("I'm interested")])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Immersive Pavillion"}},[_c('p',[_vm._v("\n                The SIGGRAPH 2024 Immersive Pavilion gathers outstanding\n                content in virtual reality, augmented reality, mixed reality,\n                and beyond! This year's in-person event is a place for\n                contributors and participants to engage in critical discourse\n                on the latest interactive breakthroughs. We are looking for\n                students who help manage the attendees in a formal way to test\n                out the experiences. Additionally, students might need to\n                periodically help contributors get attendees in and out of\n                their stations, organize the attendees in lines (logistics),\n                or provide attendees information about how we are keeping\n                things sanitized.\n              ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.pavillion),callback:function ($$v) {_vm.$set(_vm.form, "pavillion", $$v)},expression:"form.pavillion"}},[_vm._v("I'm interested")])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Attendee Service"}},[_c('p',[_vm._v("\n                Are you energetic? Do you have a friendly smile, enjoy helping\n                people, and possess good communication skills? We have\n                different shifts where you will be in direct contact with\n                attendees helping monitor a room, inviting them to interact\n                with other attendees or speakers, or supporting the selling of\n                merchandise.\n              ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.greeter),callback:function ($$v) {_vm.$set(_vm.form, "greeter", $$v)},expression:"form.greeter"}},[_vm._v("I'm interested")])],1)],1),_vm._v(" "),_c('h2',[_vm._v("Shift Preference")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',{attrs:{"for":"firstChoice"}},[_vm._v("First Choice")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"name":"firstChoice","id":"first-choice","options":_vm.shifts},model:{value:(_vm.form.firstChoice),callback:function ($$v) {_vm.$set(_vm.form, "firstChoice", $$v)},expression:"form.firstChoice"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{attrs:{"for":"secondChoice"}},[_vm._v("Second Choice")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"name":"secondChoice","id":"second-choice","options":_vm.shifts},model:{value:(_vm.form.secondChoice),callback:function ($$v) {_vm.$set(_vm.form, "secondChoice", $$v)},expression:"form.secondChoice"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{attrs:{"for":"thirdChoice"}},[_vm._v("Third Choice")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"name":"thirdChoice","id":"third-choice","options":_vm.shifts},model:{value:(_vm.form.thirdChoice),callback:function ($$v) {_vm.$set(_vm.form, "thirdChoice", $$v)},expression:"form.thirdChoice"}})],1)]),_vm._v(" "),_c('p',[_vm._v("\n            By confirming your position, you are committing to be an in-person\n            Student Volunteer at SIGGRAPH 2024 during the week of July 28 - August 1, 2024.\n          ")])],1):_vm._e(),_vm._v(" "),_c('b-form-group',[(_vm.step === 1)?_c('button',{staticClass:"btn arrow-btn-primary float-right",attrs:{"type":"submit"},on:{"click":_vm.nextStep}},[_vm._v("\n            Next Step\n          ")]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('button',{staticClass:"btn left-arrow-btn-primary float-left",attrs:{"type":"submit"},on:{"click":_vm.previousStep}},[_vm._v("\n            Previous Step\n          ")]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('button',{staticClass:"btn arrow-btn-primary float-right",attrs:{"disabled":_vm.disabled,"type":"submit"},on:{"click":_vm.submitConfirmation}},[_vm._v("\n            Submit\n          ")]):_vm._e()])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/rtg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yyi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__ = __webpack_require__("9JZb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5c16eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__ = __webpack_require__("nUbs");
function injectStyle (ssrContext) {
  __webpack_require__("TJmm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c5c16eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5c16eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "01PZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stepTwo"}},[(_vm.isLoading)?_c('h3',[_vm._v("Getting your application...")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('b-form',[_c('h2',[_vm._v("Student Volunteer Questions")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Question 1")]),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"essay1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('h6',[_vm._v("Tell us about your motivation to be a Student Volunteer. What would make you a great fit for the role?")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"essay1","rows":10,"max-rows":100},on:{"input":function($event){return _vm.wordCount('essay1', 250)}},model:{value:(_vm.essay1),callback:function ($$v) {_vm.essay1=$$v},expression:"essay1"}}),_vm._v(" "),_c('p',{class:_vm.essay1WordLimitClass},[_vm._v(_vm._s(_vm.essay1WordCount))])],1)])]),_vm._v(" "),_c('h3',[_vm._v("Question 2")]),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"essay2"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('h6',[_vm._v("Tell us about a time when you interacted with individuals from a different background than your own. What did you learn from your experience?")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"essay2","rows":10,"max-rows":100},on:{"input":function($event){return _vm.wordCount('essay2', 250)}},model:{value:(_vm.essay2),callback:function ($$v) {_vm.essay2=$$v},expression:"essay2"}}),_vm._v(" "),_c('p',{class:_vm.essay2WordLimitClass},[_vm._v(_vm._s(_vm.essay2WordCount))])],1)])]),_vm._v(" "),_c('h3',[_vm._v("Question 3")]),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"essay3"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('h6',[_vm._v("Tell us about a stressful or unexpected situation involving others that YOU specifically took the initiative to resolve. What was your contribution and how did you work towards a resolution? What was the final outcome? What did you learn and how would you apply it to the future?")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"essay3","rows":10,"max-rows":100},on:{"input":function($event){return _vm.wordCount('essay3', 250)}},model:{value:(_vm.essay3),callback:function ($$v) {_vm.essay3=$$v},expression:"essay3"}}),_vm._v(" "),_c('p',{class:_vm.essay3WordLimitClass},[_vm._v(_vm._s(_vm.essay3WordCount))])],1)])]),_vm._v(" "),_c('b-form-group',[_c('button',{staticClass:"btn left-arrow-btn-primary btn-sm float-sm-left",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.previousStep}},[_vm._v("Previous Step")]),_vm._v(" "),_c('button',{staticClass:"btn arrow-btn-primary btn-sm float-sm-right",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.nextStep}},[_vm._v("Save and Continue")])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0EqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('div',{staticClass:"nav-bg container-fluid"},[_c('navigation')],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('p',[_c('em',[_vm._v("Last Updated: "+_vm._s(_vm.lastRefreshDate))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.refreshPage}},[_c('em',[_vm._v("Refresh")])])],1),_vm._v(" "),_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Txq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Shift Swap Requests")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',[_vm._v("Out of consideration for SVs and the conference, online shift swapping has been disabled.")]),_vm._v(" "),_c('p',[_vm._v("Shift swaps will only be accepted at the SV Office or by email: "),_c('a',{attrs:{"href":"mailto:sv-2018@siggraph.org"}},[_vm._v("sv-2018@siggraph.org")]),_vm._v(".\n        Confirmation must be received from both parties.")]),_vm._v(" "),_c('p',[_vm._v("We "),_c('strong',[_vm._v("WILL NOT")]),_vm._v(" accept swap requests without a SV to swap with.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0l+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListShiftSwapRequests_vue__ = __webpack_require__("rF0G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0740a984_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListShiftSwapRequests_vue__ = __webpack_require__("0Txq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListShiftSwapRequests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0740a984_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListShiftSwapRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0rXc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/MW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_pdf_icon_64__ = __webpack_require__("GSlc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_SelectLists__ = __webpack_require__("rydV");









var appStatus = ['Accepted', 'Confirmed', 'Rejected', 'Declined'];

var initState = function initState() {
  return {
    isLoading: false,
    isLoaded: false,
    isSaving: false,
    isNew: false,
    step: 1,
    stepEntered: 1,
    completed: false,
    teamLeader: false,
    financialAid: false,
    signedUrlPost: '',
    data: {
      step: 1,
      proofOfEnrollment: {
        dataURL: '',
        name: '',
        size: 0,
        type: ''
      },
      schoolName: '',
      schoolCity: '',
      schoolState: '',
      schoolCountry: '',
      closeProximity: false,
      expectedGraduationMonth: '',
      expectedGraduationYear: '',
      // interestAnimation: false,
      // interestProductionDesign: false,
      // interestTechnical: false,
      // interestWeb: false,
      // interestDesign: false,
      // interestMarketing: false,
      // interestGaming: false,
      // otherInterests: '',
      haveNotAttended: false,
      haveAttended: false,
      haveVolunteered: false,
      yearsVolunteered: [],
      haveAttendedAsia: false,
      haveVolunteeredAsia: false,
      yearsVolunteeredAsia: [],
      // firstChoice: '',
      // secondChoice: '',
      // timeZone: '',
      firstReferenceType: '',
      firstReferenceFirstName: '',
      firstReferenceLastName: '',
      firstReferenceEmail: '',
      secondReferenceType: '',
      secondReferenceFirstName: '',
      secondReferenceLastName: '',
      secondReferenceEmail: '',
      // knowledgeFinalCutPro: '',
      // knowledgeAdobePremiere: '',
      // knowledgeAdobeAfterEffects: '',
      // knowledgeAdobePhotoshop: '',
      // knowledgeAdobeIllustrator: '',
      // knowledgeCanva: '',
      // knowledgeClosedCaptioningVideos: '',
      // shirtSize: '',
      // diet: [],
      // otherDiet: '',
      essay1: '',
      essay2: '',
      essay3: '',
      financialAidSummary: '',
      primaryTransport: '',
      airportCode: '',
      financialAidExpenses: '',
      estimatedTravelCost: '',
      fundedTravel: false,
      teamLeaderEssay1: '',
      teamLeaderEssay2: '',
      otherComments: '',
      acceptedTerms: false,
      acceptedMediaRelease: false,
      acceptedPrivacy: false
    },
    statusId: null,
    TLAppDeadline: '2024-01-19T22:00Z'
  };
};

var fieldNames = {
  proofOfEnrollment: 'Proof Of Enrollment',
  schoolName: 'School Name',
  schoolCity: 'School City',
  schoolState: 'School State',
  schoolCountry: 'School Country',
  expectedGraduationMonth: 'Expected Month of Graduation',
  expectedGraduationYear: 'Expected Year of Graduation',
  firstReferenceType: 'First Reference Type',
  firstReferenceFirstName: 'First Reference First Name',
  firstReferenceLastName: 'First Reference Last Name',
  firstReferenceEmail: 'First Reference Email',
  secondReferenceType: 'Second Reference Type',
  secondReferenceFirstName: 'Second Reference First Name',
  secondReferenceLastName: 'Second Reference Last Name',
  secondReferenceEmail: 'Second Reference Email',
  knowledgeFinalCutPro: 'Technical Knowledge - Final Cut Pro',
  knowledgeAdobePremiere: 'Technical Knowledge - Adobe Premiere',
  knowledgeAdobeAfterEffects: 'Technical Knowledge - Adobe After Effects',
  knowledgeAdobePhotoshop: 'Technical Knowledge - Adobe Photoshop',
  knowledgeAdobeIllustrator: 'Technical Knowledge - Adobe Illustrator',
  knowledgeCanva: 'Technical Knowledge - Canva',
  knowledgeClosedCaptioningVideos: 'Technical Knowledge - Closed Captioning Videos',
  essay1: 'First Essay',
  essay2: 'Second Essay',
  essay3: 'Third Essay',
  financialAidSummary: 'Financial Aid Summary',
  primaryTransport: 'Primary Mode of Transportation',
  airportCode: 'Airport Code',
  financialAidExpenses: 'List of Travel Expenses',
  estimatedTravelCost: 'Estimated Travel Cost',
  teamLeaderEssay1: 'First Team Leader Essay',
  teamLeaderEssay2: 'Second Team Leader Essay',
  otherComments: 'Additional Comments',
  acceptedTerms: 'Acceptance of Terms',
  acceptedMediaRelease: 'Acceptance of Media Release Agreement',
  acceptedPrivacy: 'Acceptance of ACM Privacy Policy',
  shirtSize: 'T-Shirt Size'
};

var application = {
  namespaced: true,
  state: initState(),
  mutations: {
    loading: function loading(state) {
      state.isLoading = true;
    },
    appLoaded: function appLoaded(state, _ref) {
      var data = _ref.data,
          step = _ref.step,
          completed = _ref.completed,
          teamLeader = _ref.teamLeader,
          financialAid = _ref.financialAid,
          statusId = _ref.statusId,
          status = _ref.status;

      state.isLoading = false;
      state.isLoaded = true;
      state.step = step;
      state.completed = completed;
      state.teamLeader = teamLeader;
      state.financialAid = financialAid;
      state.statusId = statusId;
      state.status = status;
      state.data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(initState().data, data);
    },
    saving: function saving(state) {
      state.isSaving = true;
    },
    appSaved: function appSaved(state) {
      state.isSaving = false;
    },
    appLoadedInit: function appLoadedInit(state) {
      state.isLoading = false;
      state.isLoaded = true;
      state.isNew = true;
    },
    signedUrlPost: function signedUrlPost(state, url) {
      state.signedUrlPost = url;
    },
    fileUploaded: function fileUploaded(state, file) {
      state.data.proofOfEnrollment = file;
    },
    appClearData: function appClearData(state) {
      var init = initState();
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
        state[key] = init[key];
      });
    },
    updateField: function updateField(state, _ref2) {
      var name = _ref2.name,
          value = _ref2.value;

      state.data[name] = value;
    },
    removeProofOfEnrollment: function removeProofOfEnrollment(state) {
      var init = initState().data.proofOfEnrollment;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
        state.data.proofOfEnrollment[key] = init[key];
      });
    },
    updateFinancialAid: function updateFinancialAid(state, value) {
      state.financialAid = value;
    },
    updateTeamLeader: function updateTeamLeader(state, value) {
      state.teamLeader = value;
    },
    stepEntered: function stepEntered(state, step) {
      state.stepEntered = step;
    },
    updateStep: function updateStep(state, step) {
      state.step = step;
      state.data.step = step;
    },
    complete: function complete(state) {
      state.data.acceptedTerms = true;
      state.data.acceptedMediaRelease = true;
      state.completed = true;
    },
    disableTeamLeader: function disableTeamLeader(state) {
      state.teamLeader = false;
    }
  },
  getters: {
    getProgress: function getProgress(state) {
      if (state.completed) return 100;
      return Math.round(state.step * 100 / 5);
    },
    isNewApp: function isNewApp(state) {
      return state.isLoaded === true && state.isNew === true;
    },
    isNotNewApp: function isNotNewApp(state) {
      return state.isLoaded === true && state.isNew === false;
    },
    getDataURL: function getDataURL(state) {
      if (state.data.proofOfEnrollment.dataURL !== '') {
        return state.data.proofOfEnrollment.dataURL;
      }
      return __WEBPACK_IMPORTED_MODULE_5__util_pdf_icon_64__["a" /* default */];
    },
    proofOfEnrollmentExists: function proofOfEnrollmentExists(state) {
      return state.data.proofOfEnrollment.name !== '';
    },
    proofOfEnrollmentFileSize: function proofOfEnrollmentFileSize(state) {
      return Math.round(state.data.proofOfEnrollment.size / 1000000 * 100) / 100;
    },
    getExpectedGraduationMonth: function getExpectedGraduationMonth(state) {
      return __WEBPACK_IMPORTED_MODULE_7__util_SelectLists__["f" /* months */].find(function (row) {
        return row.value === state.data.expectedGraduationMonth;
      });
    },
    getExpectedGraduationYear: function getExpectedGraduationYear(state) {
      return state.data.expectedGraduationYear;
    },
    getYearsVolunteered: function getYearsVolunteered(state) {
      return state.data.yearsVolunteered;
    },
    getYearsVolunteeredAsia: function getYearsVolunteeredAsia(state) {
      return state.data.yearsVolunteeredAsia;
    },
    financialAidAndFlying: function financialAidAndFlying(state) {
      return state.financialAid && state.data.primaryTransport === 'plane';
    },
    getVolunteerTypePrefFirst: function getVolunteerTypePrefFirst(state) {
      return state.data.firstChoice;
    },
    getVolunteerTypePrefSecond: function getVolunteerTypePrefSecond(state) {
      return state.data.secondChoice;
    },
    getTimeZone: function getTimeZone(state) {
      return state.data.timeZone;
    },
    invalidFields: function invalidFields(state) {
      var init = initState();
      var invalidFields = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(init.data).filter(function (key) {
        switch (key) {
          case 'step':
          case 'closeProximity':
          case 'interestAnimation':
          case 'interestProductionDesign':
          case 'interestTechnical':
          case 'interestWeb':
          case 'interestDesign':
          case 'interestMarketing':
          case 'interestGaming':
          case 'otherInterests':
          case 'haveNotAttended':
          case 'haveAttended':
          case 'haveVolunteered':
          case 'yearsVolunteered':
          case 'haveAttendedAsia':
          case 'haveVolunteeredAsia':
          case 'yearsVolunteeredAsia':
          case 'acceptedTerms':
          case 'acceptedMediaRelease':
          case 'acceptedPrivacy':
          case 'otherComments':
          case 'diet':
          case 'fundedTravel':
            return false;
          case 'proofOfEnrollment':
            return init.data[key].name === state.data[key].name;
          case 'financialAidSummary':
          case 'primaryTransport':
          case 'financialAidExpenses':
          case 'estimatedTravelCost':
            return state.financialAid && init.data[key] === state.data[key];
          case 'airportCode':
            return state.financialAid && state.primaryTransport === 'plane' && init.data[key] === state.data[key];
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && init.data[key] === state.data[key];
          default:
            return init.data[key] === state.data[key];
        }
      });
      var fields = [];
      invalidFields.forEach(function (key) {
        fields.push(fieldNames[key]);
      });
      return fields;
    },
    isValid: function isValid(state) {
      var init = initState();
      var invalidFields = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(init.data).filter(function (key) {
        switch (key) {
          case 'step':
          case 'closeProximity':
          case 'interestAnimation':
          case 'interestProductionDesign':
          case 'interestTechnical':
          case 'interestWeb':
          case 'interestDesign':
          case 'interestMarketing':
          case 'interestGaming':
          case 'otherInterests':
          case 'haveNotAttended':
          case 'haveAttended':
          case 'haveVolunteered':
          case 'yearsVolunteered':
          case 'haveAttendedAsia':
          case 'haveVolunteeredAsia':
          case 'yearsVolunteeredAsia':
          case 'diet':
          case 'otherDiet':
          case 'acceptedTerms':
          case 'acceptedMediaRelease':
          case 'acceptedPrivacy':
          case 'otherComments':
          case 'fundedTravel':
            return false;
          /* case 'timeZone':
            return (state.data.firstChoice === 'Virtual' || state.data.secondChoice === 'Virtual') && state.data[key] === init.data[key]
          case 'shirtSize':
            return (state.data.firstChoice === 'In-person' || state.data.secondChoice === 'In-person') && state.data[key] === init.data[key] */
          case 'financialAidSummary':
          case 'primaryTransport':
          case 'financialAidExpenses':
          case 'estimatedTravelCost':
            return state.financialAid && init.data[key] === state.data[key];
          case 'airportCode':
            return state.financialAid && state.primaryTransport === 'plane' && init.data[key] === state.data[key];
          case 'proofOfEnrollment':
            return init.data[key].name === state.data[key].name;
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && init.data[key] === state.data[key];
          default:
            return init.data[key] === state.data[key];
        }
      });
      console.log(invalidFields);
      return invalidFields.length === 0;
    },
    isOverWordCount: function isOverWordCount(state) {
      var init = initState();
      var invalidFields = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(init.data).filter(function (key) {
        switch (key) {
          case 'financialAidSummary':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 80;
          case 'financialAidExpenses':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 30;
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && state.data[key].trim().split(/\s+/).length > 250;
          case 'essay1':
          case 'essay2':
          case 'essay3':
            return state.data[key].trim().split(/\s+/).length > 250;
          default:
            return false;
        }
      });
      console.log(invalidFields);
      return invalidFields.length !== 0;
    },
    overWordCount: function overWordCount(state) {
      var init = initState();
      var invalidFields = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(init.data).filter(function (key) {
        switch (key) {
          case 'financialAidSummary':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 80;
          case 'financialAidExpenses':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 30;
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && state.data[key].trim().split(/\s+/).length > 250;
          case 'essay1':
          case 'essay2':
          case 'essay3':
            return state.data[key].trim().split(/\s+/).length > 250;
          default:
            return false;
        }
      });
      console.log(invalidFields);
      var fields = [];
      invalidFields.forEach(function (key) {
        fields.push(fieldNames[key]);
      });
      return fields;
    },
    pastTLAppDeadline: function pastTLAppDeadline(state) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()().utc().isAfter(state.TLAppDeadline);
    },
    isPending: function isPending(state) {
      return state.statusId === null;
    },
    isOffered: function isOffered(state) {
      return state.statusId === 1;
    },
    isAccepted: function isAccepted(state) {
      return state.statusId === 2;
    },
    isDeclined: function isDeclined(state) {
      return state.statusId === 4;
    },
    isRejected: function isRejected(state) {
      return state.statusId === 3;
    }
  },
  actions: {
    load: function load(_ref3) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('loading');
        fetch('https://api.siggraphsv.org/' + 'application/' + rootState.user.profile.id, {
          headers: {
            'Authorization': rootState.user.session.accessToken
          }
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (response.status === 200 && payload.success) {
              var appData = {
                data: payload.data.data,
                step: payload.data.data.step,
                completed: payload.data.completed,
                teamLeader: payload.data.team_leader,
                financialAid: payload.data.financial_aid,
                statusId: payload.data.sv.application_status_id,
                status: payload.data.sv.application_status_id === null ? 'Pending' : appStatus[payload.data.sv.application_status_id - 1]
              };
              commit('appLoaded', appData);
              resolve();
            } else if (response.status === 404 && !payload.success) {
              commit('appLoadedInit');
              resolve();
            } else {
              commit('error', { message: 'Unable to load application' }, { root: true });
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    save: function save(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('saving');
        var appData = {
          sv_id: rootState.user.profile.id,
          data: state.data,
          completed: state.completed,
          team_leader: state.teamLeader,
          financial_aid: state.financialAid
        };
        fetch('https://api.siggraphsv.org/' + 'application/save', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(appData)
        }).then(function (response) {
          commit('appSaved');
          resolve();
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    getSignedUrl: function getSignedUrl(_ref5, _ref6) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;
      var fileType = _ref6.fileType;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'files/upload', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            user_id: rootState.user.profile.svid,
            file_type: fileType
          })
        }).then(function (response) {
          response.json().then(function (payload) {
            commit('signedUrlPost', payload.data.url);
            resolve(payload.data.url);
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
        });
      });
    },
    finish: function finish(_ref7) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('complete');
      dispatch('save').then(function () {
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (application);

/***/ }),

/***/ "1uel":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2B/m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hu/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Applications")]),_vm._v(" "),(_vm.isLoadingList)?_c('div',[_c('div',{staticClass:"loader"},[_vm._v("Loading...")]),_vm._v(" "),_c('p',[_vm._v("Loading list of applications...")])]):_c('div',[_c('h5',[_vm._v("You have been assigned "+_vm._s(_vm.listAssignments.length)+" applications to review. Click on an application to score.")]),_vm._v(" "),_c('b-progress',{staticClass:"w-50 mb-2",attrs:{"value":_vm.numberOfScored,"max":_vm.listAssignments.length,"show-value":""}}),_vm._v(" "),_c('b-button-group',{staticClass:"mb-4"},[_c('b-button',{staticClass:"jury-btn",attrs:{"pressed":_vm.isNotFiltered},on:{"click":function($event){return _vm.filterAssignments('all')}}},[_vm._v("All")]),_vm._v(" "),_c('b-button',{staticClass:"jury-btn",attrs:{"pressed":_vm.isFilteredByScored},on:{"click":function($event){return _vm.filterAssignments('scored')}}},[_vm._v("Scored")]),_vm._v(" "),_c('b-button',{staticClass:"jury-btn",attrs:{"pressed":_vm.isFilteredByUnscored},on:{"click":function($event){return _vm.filterAssignments('unscored')}}},[_vm._v("Unscored")])],1)],1),_vm._v(" "),_c('b-list-group',_vm._l((_vm.listFilteredAssignments),function(assignment){return _c('b-list-group-item',{key:assignment.i,staticClass:"application-item",attrs:{"button":""},on:{"click":function($event){return _vm.scoreApp(assignment.student_volunteer_id)}}},[_c('h4',[_vm._v("Application "+_vm._s(assignment.i))]),_vm._v(" "),(assignment.isScored)?_c('div',{staticClass:"scores"},[_c('span',[_vm._v("Essay 1 Score: "),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(assignment.essay1))])],1),_vm._v(" "),_c('span',[_vm._v("Essay 2 Score: "),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(assignment.essay2))])],1),_vm._v(" "),_c('span',[_vm._v("Essay 3 Score: "),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(assignment.essay3))])],1),_vm._v(" "),_c('span',[_vm._v("Overall Approval: "),_c('b-badge',{attrs:{"variant":assignment.overall ? 'success' : 'warning'}},[_vm._v(_vm._s(assignment.overall ? 'Yes' : 'No'))])],1),_vm._v(" "),_c('span',[_vm._v("Red flag: "),_c('b-badge',{attrs:{"variant":assignment.red_flag ? 'danger' : 'success'}},[_vm._v(_vm._s(assignment.red_flag ? 'Yes' : 'No'))])],1)]):_c('div',{staticClass:"scores"},[_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Not Scored")])],1)])}),1),_vm._v(" "),_c('b-modal',{ref:"scoreModal",attrs:{"id":"scoreModal","title":_vm.getTitle,"size":"lg","ok-only":"","ok-title":"Close","ok-variant":"secondary"}},[(_vm.isLoadingApp)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]):_c('div',{staticClass:"content",staticStyle:{"margin":"5px"}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Essay 1","active":""}},[_c('h5',{staticClass:"essay-question"},[_vm._v(" Tell us why you would be a great Student Volunteer. ")]),_vm._v(" "),_c('div',{staticClass:"essay-text"},[_c('p',[_vm._v(_vm._s(_vm.activeApp.essay1Content))])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Essay 2"}},[_c('h5',{staticClass:"essay-question"},[_vm._v(" Tell us about a time when you interacted with individuals from a different background than your own. What did you learn from your experience? ")]),_vm._v(" "),_c('div',{staticClass:"essay-text"},[_c('p',[_vm._v(_vm._s(_vm.activeApp.essay2Content))])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Essay 3"}},[_c('h5',{staticClass:"essay-question"},[_vm._v("Tell us about a stressful situation involving others that YOU specifically took the initiative to resolve. Explain in detail the technique(s) you used to work towards a resolution. What was the final outcome? How will you take what you learned and apply it to the future?")]),_vm._v(" "),_c('div',{staticClass:"essay-text"},[_c('p',[_vm._v(_vm._s(_vm.activeApp.essay3Content))])])])],1),_vm._v(" "),_c('b-form',{attrs:{"inline":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveScores($event)}}},[_c('b-form-group',{staticClass:"essay-input",attrs:{"label":"Essay 1"}},[_c('b-form-select',{staticClass:"mb-1",attrs:{"id":"essay1-score","options":_vm.scores,"required":""},model:{value:(_vm.activeApp.essay1Score),callback:function ($$v) {_vm.$set(_vm.activeApp, "essay1Score", $$v)},expression:"activeApp.essay1Score"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"essay-input",attrs:{"label":"Essay 2"}},[_c('b-form-select',{staticClass:"mb-1",attrs:{"id":"essay2-score","options":_vm.scores,"required":""},model:{value:(_vm.activeApp.essay2Score),callback:function ($$v) {_vm.$set(_vm.activeApp, "essay2Score", $$v)},expression:"activeApp.essay2Score"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"essay-input",attrs:{"label":"Essay 3"}},[_c('b-form-select',{staticClass:"mb-1",attrs:{"id":"essay3-score","options":_vm.scores,"required":""},model:{value:(_vm.activeApp.essay3Score),callback:function ($$v) {_vm.$set(_vm.activeApp, "essay3Score", $$v)},expression:"activeApp.essay3Score"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"essay-input",attrs:{"label":"Overall Approval"}},[_c('b-form-select',{staticClass:"mb-1",attrs:{"id":"overall-score","options":_vm.overall,"required":""},model:{value:(_vm.activeApp.overall),callback:function ($$v) {_vm.$set(_vm.activeApp, "overall", $$v)},expression:"activeApp.overall"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"essay-input",attrs:{"label":"Red flag"}},[_c('b-form-select',{staticClass:"mb-1",attrs:{"id":"red_flag","options":_vm.red_flag,"required":""},model:{value:(_vm.activeApp.red_flag),callback:function ($$v) {_vm.$set(_vm.activeApp, "red_flag", $$v)},expression:"activeApp.red_flag"}})],1),_vm._v(" "),_c('b-form-group',{staticStyle:{"margin-left":"3px"},attrs:{"label":"Confirm"}},[_c('b-button',{attrs:{"type":"submit","disabled":_vm.isSaving,"variant":"primary"}},[_vm._v("Save")]),_vm._v(" "),(_vm.isSaving)?_c('div',{staticClass:"loader"},[_vm._v("Saving...")]):_vm._e()],1)],1),_vm._v(" "),(_vm.showModalMessage)?_c('div',{staticClass:"alert alert-success",attrs:{"id":"modal-alert","role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.modalMessage))])]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"footer-left"},[_c('b-button',{attrs:{"disabled":_vm.isFirstApp,"variant":"info"},on:{"click":_vm.previousApp}},[_vm._v("Previous App")]),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.isLastApp,"variant":"info"},on:{"click":_vm.nextApp}},[_vm._v("Next App")])],1),_vm._v(" "),_c('div',{staticClass:"footer-right"},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":_vm.closeModal}},[_vm._v("Close")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4MzS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('div',{staticClass:"nav-bg container-fluid"},[_c('navigation')],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),_c('h1',[_vm._v("Student Volunteer Profile "),_c('span',{attrs:{"className":"text-muted"}},[_vm._v("(SV ID "+_vm._s(_vm.profile.svid)+")")])]),_vm._v(" "),_c('b-form',[_c('label',{attrs:{"for":"firstName"}},[_vm._v("Legal First Name"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"text","id":"firstName"},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_vm._v(" "),_c('label',{attrs:{"for":"lastName"}},[_vm._v("Last Name"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"text","id":"lastName"},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_vm._v(" "),_c('label',{attrs:{"for":"nickname"}},[_vm._v("\n          Name if different than legal name\n        ")]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"text","id":"nickname"},model:{value:(_vm.nickname),callback:function ($$v) {_vm.nickname=$$v},expression:"nickname"}})],1),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("Email"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"email","id":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('label',{attrs:{"for":"birthday"}},[_vm._v("Date of Birth"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"date","id":"birthday"},model:{value:(_vm.birthdate),callback:function ($$v) {_vm.birthdate=$$v},expression:"birthdate"}})],1),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0px"},attrs:{"for":"gender"}},[_vm._v("With which gender identity(s) do you identify?"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox-group',{attrs:{"options":_vm.genderOptions,"name":"gender","stacked":""},model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}}),_vm._v(" "),(_vm.isGenderOther)?_c('b-form-input',{attrs:{"name":"genderIdentity","type":"text"},model:{value:(_vm.genderIdentity),callback:function ($$v) {_vm.genderIdentity=$$v},expression:"genderIdentity"}}):_vm._e()],1),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0px"},attrs:{"for":"underrepresented"}},[_vm._v("Which of the following best represents your racial and ethnic heritage?"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox-group',{attrs:{"options":_vm.raceOptions,"name":"underrepresented","stacked":""},model:{value:(_vm.underrepresented),callback:function ($$v) {_vm.underrepresented=$$v},expression:"underrepresented"}}),_vm._v(" "),(_vm.isUnderrepresentedOther)?_c('b-form-input',{attrs:{"name":"underrepresentedGroup","type":"text"},model:{value:(_vm.underrepresentedGroup),callback:function ($$v) {_vm.underrepresentedGroup=$$v},expression:"underrepresentedGroup"}}):_vm._e()],1),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0px"},attrs:{"for":"disability"}},[_vm._v("\n          We are committed to meeting the needs of people with disabilities or special requirements accepted into our program. "),_c('br'),_vm._v("\n          If you require additional support and/or specific accommodations, please let us know and we will reach out to you. "),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-radio-group',{staticClass:"radio",attrs:{"id":"disability","name":"disability"},model:{value:(_vm.disability),callback:function ($$v) {_vm.disability=$$v},expression:"disability"}},[_c('b-form-radio',{staticStyle:{"margin-bottom":"8px"},attrs:{"value":"no"}},[_vm._v("No")]),_c('br'),_vm._v(" "),_c('b-form-radio',{staticStyle:{"margin-bottom":"8px"},attrs:{"value":"yes"}},[_vm._v("Yes, I require additional support and/or specific accommodations regarding: "),_c('b-form-input',{attrs:{"size":"sm","disabled":_vm.disability !== 'yes',"name":"disabilityType","type":"text","placeholder":"optional"},model:{value:(_vm.disabilityType),callback:function ($$v) {_vm.disabilityType=$$v},expression:"disabilityType"}})],1),_c('br')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"address1"}},[_vm._v("Address Line 1"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"text","id":"address1"},model:{value:(_vm.address1),callback:function ($$v) {_vm.address1=$$v},expression:"address1"}})],1),_vm._v(" "),_c('label',{attrs:{"for":"address2"}},[_vm._v("Address Line 2 ")]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text","id":"address2"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}})],1),_vm._v(" "),_c('label',{attrs:{"for":"city"}},[_vm._v("City"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"text","id":"city"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"region"}},[_vm._v("State/Province/Region"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"text","id":"region"},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"country"}},[_vm._v("Country"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-select',{staticClass:"mb-3",attrs:{"required":"","id":"country","options":_vm.countries},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"postalCode"}},[_vm._v("Zip/Postal Code"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"required":"","type":"text","id":"postalCode"},model:{value:(_vm.postalCode),callback:function ($$v) {_vm.postalCode=$$v},expression:"postalCode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-12"},[_c('b-form-group',{attrs:{"label":"Languages","label-for":"languages","description":"Only select languages you are comfortable communicating in on a daily basis."}},[_c('multiselect',{attrs:{"id":"languages","track-by":"value","label":"text","options":_vm.languageList,"value":_vm.getLanguages,"searchable":true,"multiple":true,"close-on-select":false,"hide-selected":true},on:{"input":_vm.updateLanguages},scopedSlots:_vm._u([{key:"tag",fn:function(props){return [_c('span',{staticClass:"custom__tag"},[_c('span',[_vm._v(_vm._s(props.option.text))]),_c('span',{staticClass:"custom__remove",on:{"click":function($event){return props.remove(props.option)}}},[_vm._v("❌")])])]}}])})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-12"},[_c('label',{attrs:{"for":"phoneNumber"}},[_vm._v("Phone Number"),_c('span',{staticClass:"ml-2 required"},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-group',{attrs:{"description":"Include International Dialing Code if outside U.S.","label-for":"phoneNumber"}},[_c('b-form-input',{attrs:{"required":"","type":"tel","id":"phoneNumber"},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})],1)],1)]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{model:{value:(_vm.canText),callback:function ($$v) {_vm.canText=$$v},expression:"canText"}},[_vm._v("I can receive text messages in the U.S.")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.canCall),callback:function ($$v) {_vm.canCall=$$v},expression:"canCall"}},[_vm._v("I can receive phone calls in the U.S.")])],1),_vm._v(" "),_c('b-form-group',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn left-arrow-btn-primary float-md-left",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.backHome}},[_vm._v("Back to Dashboard")])]),_vm._v(" "),(_vm.isMessage)?_c('div',{staticClass:"col col-md-6"},[_c('alert',{attrs:{"type":"primary"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn arrow-btn-primary float-md-right",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.updateProfile}},[_vm._v("Update Profile")])])])])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4zQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepFour_vue__ = __webpack_require__("gUjJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f38d1fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepFour_vue__ = __webpack_require__("SEa2");
function injectStyle (ssrContext) {
  __webpack_require__("WSyM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepFour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f38d1fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepFour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ild":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "60s+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('div',{staticClass:"nav-bg container-fluid"},[_c('navigation')],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6RXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepThree_vue__ = __webpack_require__("pM0v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a382bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepThree_vue__ = __webpack_require__("DW5w");
function injectStyle (ssrContext) {
  __webpack_require__("0rXc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepThree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a382bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepThree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7HzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SvDashboard_vue__ = __webpack_require__("Hgbv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6e973c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SvDashboard_vue__ = __webpack_require__("rUfr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SvDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6e973c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SvDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Zsy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7dMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewApp_vue__ = __webpack_require__("bT2M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_875285a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewApp_vue__ = __webpack_require__("G641");
function injectStyle (ssrContext) {
  __webpack_require__("ayWp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_875285a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7myE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Countdown',
  data: function data() {
    return {
      now: new Date().getTime(),
      launchDate: new Date('Nov 18, 2019 00:00:00')
    };
  },

  computed: {
    countdownDays: function countdownDays() {
      var distance = this.launchDate - this.now;
      return Math.floor(distance / (1000 * 60 * 60 * 24));
    },
    countdownHours: function countdownHours() {
      var distance = this.launchDate - this.now;
      return Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    },
    countdownMinutes: function countdownMinutes() {
      var distance = this.launchDate - this.now;
      return Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    },
    countdownSeconds: function countdownSeconds() {
      var distance = this.launchDate - this.now;
      return Math.floor(distance % (1000 * 60) / 1000);
    }
  },
  created: function created() {
    var self = this;
    setInterval(function () {
      self.$data.now = new Date().getTime();
    }, 1000);
  }
});

/***/ }),

/***/ "8nFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchAppStatus_vue__ = __webpack_require__("pkez");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3cf24e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchAppStatus_vue__ = __webpack_require__("E2vk");
function injectStyle (ssrContext) {
  __webpack_require__("+VzE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchAppStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3cf24e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchAppStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "91so":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__("uL8o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Application',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage'])),
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_3__components_Nav__["a" /* default */]
  }
});

/***/ }),

/***/ "9BHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9JZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Schedule',
  data: function data() {
    return {
      upcomingShift: {}
    };
  },

  methods: {
    nextShiftDay: function nextShiftDay(day) {
      // if (moment().tz('America/Los_Angeles').isSame(moment.tz(moment(day).utc().format('YYYY-MM-DD'), 'America/Los_ANgele'), 'day')) {
      //   return 'Today'
      // } else {
      // return moment(day).utc().format('ddd MMM Do')
      // }
      console.log(day);
      return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(day).utc().format('ddd MMM Do');
    },
    goToSchedule: function goToSchedule() {
      if (this.isTeamLeader) {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/schedule/tl');
      } else {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/schedule/sv');
      }
    },
    goToShiftSwapRequests: function goToShiftSwapRequests() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/schedule/swap/list');
    },
    formattedDay: function formattedDay(day) {
      return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(day).utc().format('ddd MMM Do');
    },
    refreshPage: function refreshPage() {
      location.reload();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('schedule', ['isLoading', 'isLoaded', 'shiftSwapRequestsLoaded', 'shiftSwapRequests', 'lastRefreshDate']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['isTeamLeader']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('schedule', ['nextShift', 'isScheduled', 'nextShifts', 'currentShifts', 'hasCreatedRequests', 'hasAssignedRequests', 'hasShiftRequests', 'hasOpenRequests', 'getQualifyingOpenRequests']), {
    hasCreatedRequestNotifications: function hasCreatedRequestNotifications() {
      if (this.hasCreatedRequests) {
        var has = this.shiftSwapRequests.createdRequests.find(function (r) {
          return r.accepted !== null;
        });
        if (has !== undefined) {
          return true;
        }
        return false;
      }
      return false;
    },
    hasAssignedRequestNotifications: function hasAssignedRequestNotifications() {
      if (this.hasAssignedRequests) {
        var has = this.shiftSwapRequests.assignedRequests.find(function (r) {
          return r.accepted === null;
        });
        if (has !== undefined) {
          return true;
        }
        return false;
      }
      return false;
    }
  }),
  created: function created() {
    if (!this.$store.state.schedule.isLoaded) {
      this.$store.dispatch('schedule/load');
    }
  }
});

/***/ }),

/***/ "9PAy":
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"TemporaryPassword":{"shape":"Sm"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S12"},"SourceUser":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2x"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sm"},"ProposedPassword":{"shape":"Sm"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sm"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"Schema":{"shape":"S5h"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"Sz"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"ClientId":{"shape":"S1i"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4f"}},"NextToken":{}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4j"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1i"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1i"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2x"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S7p"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Si"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S7p"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sm":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1d":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Si"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{}},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1d"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2x":{"type":"map","key":{},"value":{}},"S30":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3p":{"type":"string","sensitive":true},"S3r":{"type":"structure","members":{"EncodedData":{}}},"S40":{"type":"map","key":{},"value":{}},"S41":{"type":"map","key":{},"value":{}},"S43":{"type":"list","member":{}},"S46":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4a":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4f":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"S4j":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4r":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"}}}}},"S4u":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{}}},"S4v":{"type":"list","member":{}},"S4x":{"type":"list","member":{}},"S4z":{"type":"list","member":{}},"S54":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S59":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5a":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{}}},"S5c":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S5d":{"type":"map","key":{},"value":{}},"S5e":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5h":{"type":"list","member":{"shape":"S4"}},"S5i":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5l":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5h"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"S5s":{"type":"list","member":{}},"S5u":{"type":"list","member":{}},"S5w":{"type":"list","member":{}},"S5x":{"type":"list","member":{}},"S5z":{"type":"list","member":{}},"S60":{"type":"list","member":{}},"S62":{"type":"list","member":{}},"S64":{"type":"structure","required":["ApplicationId","RoleArn","ExternalId"],"members":{"ApplicationId":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S67":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1i"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"S6r":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"},"LastModifiedDate":{"type":"timestamp"}}},"S6s":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S6x":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S6z"},"NoActionEmail":{"shape":"S6z"},"MfaEmail":{"shape":"S6z"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S73"},"MediumAction":{"shape":"S73"},"HighAction":{"shape":"S73"}}}}},"S6z":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S73":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S76":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S7p":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S81":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S8b":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5c"}}},"S8c":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S9c":{"type":"list","member":{"shape":"Ss"}}}}

/***/ }),

/***/ "9Zrb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Schedule")]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.isLoaded)?_c('div',{staticClass:"col-md-6 col-sm-12"},[(_vm.nextShift)?_c('div',[_c('h3',[_vm._v("Next Shift")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.formattedDay(_vm.nextShift.day))+" - "+_vm._s(_vm.nextShift.start_time))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.nextShift.venue.name))]),_vm._v(" "),_c('p',[_vm._v("Start: "+_vm._s(_vm.nextShift.start_time)),_c('br'),_vm._v(" End Time: "+_vm._s(_vm.nextShift.end_time))]),_vm._v(" "),_c('h4',[_vm._v("Team Leaders")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.nextShift.venue.teamLeaders),function(tl){return _c('div',{staticClass:"col-6"},[_vm._v(_vm._s(tl.name))])}),0)]):_vm._e(),_vm._v(" "),_c('hr')]):_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('h3',[_vm._v("Loading Schedule...")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-form-group',{attrs:{"label":"Date","label-for":"date"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"date","options":_vm.days},model:{value:(_vm.selectedDay),callback:function ($$v) {_vm.selectedDay=$$v},expression:"selectedDay"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.selectedDay === '2023-08-04')?_c('h2',[_vm._v("Friday 04 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-05')?_c('h2',[_vm._v("Saturday 05 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-06')?_c('h2',[_vm._v("Sunday 06 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-07')?_c('h2',[_vm._v("Monday 07 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-08')?_c('h2',[_vm._v("Tuesday 08 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-09')?_c('h2',[_vm._v("Wednesday 09 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-10')?_c('h2',[_vm._v("Thursday 10 Aug 2023")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.dayShifts),function(shift){return _c('div',[_c('div',{staticClass:"row shift",on:{"click":function($event){return _vm.selectShift(shift)}}},[_c('div',{staticClass:"col"},[_c('p',[_vm._v("\n              "+_vm._s(shift.start_time)+" - "+_vm._s(shift.end_time)+"\n              "),_c('br'),_vm._v("\n              "+_vm._s(shift.venue.name)+"\n              "),_c('br'),_vm._v("\n              "+_vm._s(shift.special)+"\n            ")])])])])}),_vm._v(" "),(_vm.isLoaded && _vm.dayShifts.length === 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.selectedDay === '2023-08-04')?_c('h3',[_vm._v("No shifts for Friday 04 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-05')?_c('h3',[_vm._v("No shifts for Saturday 05 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-06')?_c('h3',[_vm._v("No shifts for Sunday 06 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-07')?_c('h3',[_vm._v("No shifts for Monday 07 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-08')?_c('h3',[_vm._v("No shifts for Tuesday 08 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-09')?_c('h3',[_vm._v("No shifts for Wednesday 09 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-10')?_c('h3',[_vm._v("No shifts for Thursday 10 Aug 2023")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"shiftModal",attrs:{"id":"shift-modal","title":_vm.selectedShift.venue.name}},[_c('h4',[_vm._v(_vm._s(_vm.formattedDay(_vm.selectedShift.day))+" "+_vm._s(_vm.selectedShift.start_time)+" - "+_vm._s(_vm.selectedShift.end_time))]),_vm._v(" "),_c('h4',[_vm._v("Team Leaders")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.selectedShift.venue.teamLeaders),function(teamLeader){return _c('span',{key:teamLeader},[(teamLeader.id !== 1)?_c('div',{staticClass:"col"},[_vm._v("\n              "+_vm._s(teamLeader.name)+"\n            ")]):_vm._e()])}),0),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"footer-left"}),_vm._v(" "),_c('div',{staticClass:"footer-right"},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":_vm.closeModal}},[_vm._v("Close")])],1)])])],2)]),_vm._v(" "),_c('div',{staticStyle:{"width":"150px"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AGrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shift_vue__ = __webpack_require__("bK1N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12238ae4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shift_vue__ = __webpack_require__("lb81");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shift_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12238ae4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shift_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CPfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"auth-flow"},[(_vm.isRegistering)?_c('div',{staticClass:"register"},[_c('register'),_vm._v(" "),_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn btn-link sign-in-toggle",staticStyle:{"margin-right":"0px"},on:{"click":_vm.signUpToggle}},[_vm._v("Already registered? Sign In")])])],1):_vm._e(),_vm._v(" "),(_vm.forgotPasswordForm)?_c('div',[_c('b-form',{on:{"submit":_vm.handleForgotPasswordSubmit}},[_c('h3',{style:({ marginTop: '11px'})},[_vm._v("Reset your password")]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#000302","margin-top":"15px","margin-bottom":"20px"}}),_vm._v(" "),_c('p',[_vm._v("Enter your email address to reset your password.")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"email"}},[_c('b-form-input',{attrs:{"type":"text","id":"email","placeholder":"you@example.com","required":""},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn arrow-btn-primary btn-inverse text-right",staticStyle:{"margin":"5px 15px 5px 0px"},attrs:{"disabled":_vm.form.email === '' || _vm.isSendingEmail,"type":"submit"}},[_vm._v("Send Password Reset")])])],1),_vm._v(" "),_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn btn-link",staticStyle:{"margin-right":"0px"},on:{"click":_vm.toggleForgotPasswordForm}},[_vm._v("Sign In Instead")])])],1):_vm._e(),_vm._v(" "),(_vm.forgotPassword)?_c('div',[_c('b-form',{on:{"submit":_vm.handleChangePasswordSubmit}},[_c('h3',{style:({ marginTop: '11px'})},[_vm._v("Change your password")]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#000302","margin-top":"15px","margin-bottom":"20px"}}),_vm._v(" "),_c('p',[_vm._v("Create a new password.")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Password","label-for":"password"}},[_c('b-form-input',{attrs:{"type":"password","id":"password","required":""},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Retype Password","label-for":"password"}},[_c('b-form-input',{attrs:{"type":"password","id":"password-retype","required":""},model:{value:(_vm.form.retypePassword),callback:function ($$v) {_vm.$set(_vm.form, "retypePassword", $$v)},expression:"form.retypePassword"}})],1),_vm._v(" "),_c('b-form-group',[_c('button',{staticClass:"btn arrow-btn-primary btn-inverse",attrs:{"disabled":!_vm.isSamePassword,"type":"submit"}},[_vm._v("Send Password Reset")])])],1)],1):_vm._e(),_vm._v(" "),(!_vm.isRegistering && !_vm.forgotPasswordForm && !_vm.forgotPassword)?_c('div',{staticClass:"login"},[_c('b-form',{staticClass:"login-content",on:{"submit":_vm.handleSubmit}},[_c('h3',{style:({ marginTop: '11px'})},[_vm._v("Returning? Sign in")]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#000302","margin-top":"15px","margin-bottom":"20px"}}),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"email"}},[_c('b-form-input',{attrs:{"type":"text","id":"email","placeholder":"you@example.com","required":""},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Password","label-for":"password"}},[_c('b-form-input',{attrs:{"type":"password","id":"password","required":""},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn arrow-btn-primary btn-inverse text-right",staticStyle:{"margin":"5px 15px 5px 0px"},attrs:{"disabled":_vm.disabled,"type":"submit"}},[_vm._v("Login")]),_vm._v(" "),(_vm.isLoggingIn)?_c('p',{staticClass:"text-right mt-2"},[_vm._v("Logging In...")]):_vm._e()]),_vm._v(" "),_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn btn-link",staticStyle:{"margin-right":"0px"},attrs:{"type":"button"},on:{"click":_vm.toggleForgotPasswordForm}},[_vm._v("Forgot your password?")])])],1)],1):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cbbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Register',
  data: function data() {
    return {
      isRegistering: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        accept: false
      }
    };
  },

  computed: {
    disabled: function disabled() {
      if (this.form.firstName === '' || this.form.lastName === '' || this.form.email === '' || this.form.password === '' || this.form.password.length < 6 || !this.form.accept || this.isRegistering) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleSubmit: function handleSubmit(e) {
      var _this = this;

      e.preventDefault();
      this.isRegistering = true;
      this.$store.dispatch('user/register', this.form).catch(function (err) {
        _this.isRegistering = false;
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ "CwFJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cwdy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cwj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stepOne"}},[(_vm.isLoading)?_c('h3',[_vm._v("Getting your application...")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('b-form',[_c('b-form-group',[_c('h2',[_vm._v("Academic Information")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Applicants must be/have been enrolled as a full-time high school, undergraduate, or graduate students for at least one semester between June 2023 and September 2024.")]),_vm._v(" "),_c('p',[_vm._v("Applicants must be 18 years of age or older (on or before 15 May 2024).")])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"University / School / Institution Name","label-for":"schoolName"}},[_c('b-form-input',{attrs:{"type":"text","id":"schoolName"},model:{value:(_vm.schoolName),callback:function ($$v) {_vm.schoolName=$$v},expression:"schoolName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"City","label-for":"schoolCity"}},[_c('b-form-input',{attrs:{"type":"text","id":"schoolCity"},model:{value:(_vm.schoolCity),callback:function ($$v) {_vm.schoolCity=$$v},expression:"schoolCity"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"State","label-for":"schoolState"}},[_c('b-form-input',{attrs:{"type":"text","id":"schoolState"},model:{value:(_vm.schoolState),callback:function ($$v) {_vm.schoolState=$$v},expression:"schoolState"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Country","label-for":"schoolCountry"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"schoolCountry","options":_vm.countries},model:{value:(_vm.schoolCountry),callback:function ($$v) {_vm.schoolCountry=$$v},expression:"schoolCountry"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-3"},[_c('b-form-group',{attrs:{"label":"Expected Graduation Month","label-for":"expectedGraduationMonth"}},[_c('multiselect',{staticClass:"mb-3",attrs:{"placeholder":"Please Select","track-by":"value","label":"text","value":_vm.getExpectedGraduationMonth,"options":_vm.months,"searchable":false},on:{"input":_vm.updateExpectedGraduationMonth}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col col-md-3"},[_c('b-form-group',{attrs:{"label":"Expected Graduation Year","label-for":"expectedGraduationYear"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"expectedGraduationYear","label":"Year","options":_vm.years},model:{value:(_vm.expectedGraduationYear),callback:function ($$v) {_vm.expectedGraduationYear=$$v},expression:"expectedGraduationYear"}})],1)],1)]),_vm._v(" "),(_vm.proofOfEnrollmentExists)?_c('b-form-group',{attrs:{"label":"Proof of Enrollment"}},[_c('div',{staticClass:"row dz-preview"},[_c('div',{staticClass:"dz-image col col-md-3"},[_c('img',{attrs:{"alt":_vm.proofOfEnrollment.name,"src":_vm.getDataURL}})]),_vm._v(" "),_c('div',{staticClass:"dz-info col col-md-3"},[_c('div',{staticClass:"filename"},[_vm._v("Filename: "+_vm._s(_vm.proofOfEnrollment.name))]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v("File Size: "+_vm._s(_vm.proofOfEnrollmentFileSize)+" MB")]),_vm._v(" "),_c('button',{staticClass:"btn arrow-btn-primary btn-sm",attrs:{"type":"button"},on:{"click":_vm.removeProofOfEnrollment}},[_vm._v("Remove File")])])])]):_c('b-form-group',{attrs:{"label":"Proof of Enrollment","description":"Drag and Drop file to upload. (File Types: PDF, JPEG) (Max Size: 4MB)"}},[_c('div',{staticClass:"dz"},[_c('vue-dropzone',{ref:"proofOfEnrollment",attrs:{"id":"proofOfEnrollment","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.addedFile,"vdropzone-removed-file":_vm.removedFile,"vdropzone-sending":_vm.sendingEvent,"vdropzone-success":_vm.uploadSuccessful}})],1)]),_vm._v(" "),_c('b-form-group',[_c('h2',[_vm._v("Professional References")]),_vm._v(" "),_c('p',[_vm._v("References will be contacted after applications close.")]),_vm._v(" "),_c('h3',[_vm._v("First Professional Reference")])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference Type","label-for":"firstReferenceType"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"firstReferenceType","options":_vm.referenceTypes},model:{value:(_vm.firstReferenceType),callback:function ($$v) {_vm.firstReferenceType=$$v},expression:"firstReferenceType"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference First Name","label-for":"firstReferenceFirstName"}},[_c('b-form-input',{attrs:{"type":"text","id":"firstReferenceFirstName"},model:{value:(_vm.firstReferenceFirstName),callback:function ($$v) {_vm.firstReferenceFirstName=$$v},expression:"firstReferenceFirstName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference Last Name","label-for":"firstReferenceLastName"}},[_c('b-form-input',{attrs:{"type":"text","id":"firstReferenceLastName"},model:{value:(_vm.firstReferenceLastName),callback:function ($$v) {_vm.firstReferenceLastName=$$v},expression:"firstReferenceLastName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference Email","label-for":"firstReferenceEmail"}},[_c('b-form-input',{attrs:{"type":"text","id":"firstReferenceEmail"},model:{value:(_vm.firstReferenceEmail),callback:function ($$v) {_vm.firstReferenceEmail=$$v},expression:"firstReferenceEmail"}})],1),_vm._v(" "),_c('b-form-group',[_c('h3',[_vm._v("Second Professional Reference")])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference Type","label-for":"secondReferenceType"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"secondReferenceType","options":_vm.referenceTypes},model:{value:(_vm.secondReferenceType),callback:function ($$v) {_vm.secondReferenceType=$$v},expression:"secondReferenceType"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference First Name","label-for":"secondReferenceFirstName"}},[_c('b-form-input',{attrs:{"type":"text","id":"secondReferenceFirstName"},model:{value:(_vm.secondReferenceFirstName),callback:function ($$v) {_vm.secondReferenceFirstName=$$v},expression:"secondReferenceFirstName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference Last Name","label-for":"secondReferenceLastName"}},[_c('b-form-input',{attrs:{"type":"text","id":"secondReferenceLastName"},model:{value:(_vm.secondReferenceLastName),callback:function ($$v) {_vm.secondReferenceLastName=$$v},expression:"secondReferenceLastName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reference Email","label-for":"secondReferenceEmail"}},[_c('b-form-input',{attrs:{"type":"text","id":"secondReferenceEmail"},model:{value:(_vm.secondReferenceEmail),callback:function ($$v) {_vm.secondReferenceEmail=$$v},expression:"secondReferenceEmail"}})],1),_vm._v(" "),_c('b-form-group',[_c('h2',[_vm._v("SIGGRAPH Experience")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{model:{value:(_vm.haveAttended),callback:function ($$v) {_vm.haveAttended=$$v},expression:"haveAttended"}},[_vm._v("I was an attendee at a SIGGRAPH North America conference before")])],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{model:{value:(_vm.haveAttendedAsia),callback:function ($$v) {_vm.haveAttendedAsia=$$v},expression:"haveAttendedAsia"}},[_vm._v("I was an attendee at a SIGGRAPH Asia conference before")])],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{model:{value:(_vm.haveVolunteered),callback:function ($$v) {_vm.haveVolunteered=$$v},expression:"haveVolunteered"}},[_vm._v("I was a Student Volunteer at a SIGGRAPH North America conference before")])],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{model:{value:(_vm.haveVolunteeredAsia),callback:function ($$v) {_vm.haveVolunteeredAsia=$$v},expression:"haveVolunteeredAsia"}},[_vm._v("I was a Student Volunteer at a SIGGRAPH Asia conference before")])],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{model:{value:(_vm.haveNotAttended),callback:function ($$v) {_vm.haveNotAttended=$$v},expression:"haveNotAttended"}},[_vm._v("I have never attended a SIGGRAPH Conference")])],1),_vm._v(" "),(_vm.haveVolunteered)?_c('b-form-group',{attrs:{"label":"Please select which years in which you have been a SIGGRAPH North America Student Volunteer.","label-for":"yearsVolunteered"}},[_c('multiselect',{attrs:{"options":_vm.previousSvYears,"value":_vm.getYearsVolunteered,"searchable":false,"multiple":true,"close-on-select":false,"allow-empty":true,"hide-selected":true},on:{"input":_vm.updateYearsVolunteered},scopedSlots:_vm._u([{key:"tag",fn:function(props){return [_c('span',{staticClass:"custom__tag"},[_c('span',[_vm._v(_vm._s(props.option))]),_c('span',{staticClass:"custom__remove",on:{"click":function($event){return props.remove(props.option)}}},[_vm._v("❌")])])]}}],null,false,3428483234)})],1):_vm._e(),_vm._v(" "),(_vm.haveVolunteeredAsia)?_c('b-form-group',{attrs:{"label":"Please select which years in which you have been a SIGGRAPH Asia Student Volunteer.","label-for":"yearsVolunteered"}},[_c('multiselect',{attrs:{"options":_vm.previousSvYears,"value":_vm.getYearsVolunteeredAsia,"searchable":false,"multiple":true,"close-on-select":false,"allow-empty":true,"hide-selected":true},on:{"input":_vm.updateYearsVolunteeredAsia},scopedSlots:_vm._u([{key:"tag",fn:function(props){return [_c('span',{staticClass:"custom__tag"},[_c('span',[_vm._v(_vm._s(props.option))]),_c('span',{staticClass:"custom__remove",on:{"click":function($event){return props.remove(props.option)}}},[_vm._v("❌")])])]}}],null,false,3428483234)})],1):_vm._e(),_vm._v(" "),_c('b-form-group',[_c('button',{staticClass:"btn arrow-btn-primary btn-sm float-sm-right",staticStyle:{"margin-top":"8px"},attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.nextStep}},[_vm._v("Save and Continue")])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DW5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stepThree"}},[(_vm.isLoading)?_c('h3',[_vm._v("Getting your application...")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('b-form',[_c('h2',[_vm._v("Financial Assistance")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Travel assistance may be provided based on the Student Volunteer Program's availability of funds and on eligibility, which is determined on a case-by-case basis based solely on financial need. Assistance goes through a blind jury process. It is not based on nationality or country/location of residence, anyone can apply and everyone will be considered equally. Funds are limited and assistance is not guaranteed. Travel assistance, if awarded, will be communicated upon acceptance.")]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"id":"financialAid"},model:{value:(_vm.financialAid),callback:function ($$v) {_vm.financialAid=$$v},expression:"financialAid"}},[_vm._v("\n          I would like to apply for financial assistance\n        ")])],1),_vm._v(" "),(_vm.financialAid)?_c('b-form-group',{attrs:{"label":"Explain why you require financial assistance","label-for":"financialAidSummary"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('b-form-textarea',{attrs:{"id":"financialAidSummary","rows":6,"max-rows":100},on:{"input":function($event){return _vm.wordCount('financialAidSummary', 80)}},model:{value:(_vm.financialAidSummary),callback:function ($$v) {_vm.financialAidSummary=$$v},expression:"financialAidSummary"}}),_vm._v(" "),_c('p',{class:_vm.financialAidSummaryWordLimitClass},[_vm._v(_vm._s(_vm.financialAidSummaryWordCount))])],1)])]):_vm._e(),_vm._v(" "),(_vm.financialAid)?_c('b-form-group',{attrs:{"label":"Provide a breakdown of your estimated travel expenses in US Dollars in a list format (travel, lodging, food, daily transportation to the conference, etc.)","label-for":"financialAidExpenses"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('b-form-textarea',{attrs:{"id":"financialAidExpenses","rows":6,"max-rows":100},on:{"input":function($event){return _vm.wordCount('financialAidExpenses', 30)}},model:{value:(_vm.financialAidExpenses),callback:function ($$v) {_vm.financialAidExpenses=$$v},expression:"financialAidExpenses"}}),_vm._v(" "),_c('p',{class:_vm.financialAidExpensesWordLimitClass},[_vm._v(_vm._s(_vm.financialAidExpensesWordCount))])],1)])]):_vm._e(),_vm._v(" "),(_vm.financialAid)?_c('b-form-group',{attrs:{"label":"Provide an estimate of your total travel expenses in US Dollars (sum of the breakdown you previously provided)","label-for":"estimatedTravelCost"}},[_c('b-form-input',{attrs:{"type":"text","id":"estimatedTravelCost"},model:{value:(_vm.estimatedTravelCost),callback:function ($$v) {_vm.estimatedTravelCost=$$v},expression:"estimatedTravelCost"}})],1):_vm._e(),_vm._v(" "),(_vm.financialAid)?_c('b-form-group',{attrs:{"label":"Primary Mode of Transportation to the Conference's City","label-for":"primaryTransport"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"primaryTransport","options":_vm.primaryTransportList},model:{value:(_vm.primaryTransport),callback:function ($$v) {_vm.primaryTransport=$$v},expression:"primaryTransport"}})],1):_vm._e(),_vm._v(" "),(_vm.financialAidAndFlying)?_c('b-form-group',{attrs:{"label":"If Flying, 3-letter Code for Nearest Airport","label-for":"airportCode"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-2"},[_c('b-form-input',{attrs:{"type":"text","id":"airportCode"},model:{value:(_vm.airportCode),callback:function ($$v) {_vm.airportCode=$$v},expression:"airportCode"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.financialAid)?_c('b-form-group',[_c('b-form-checkbox',{attrs:{"id":"fundedTravel"},model:{value:(_vm.fundedTravel),callback:function ($$v) {_vm.fundedTravel=$$v},expression:"fundedTravel"}},[_vm._v("\n          Funding for my travel will be fully or partially covered by outside sources (such as university funding, etc.).\n        ")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("Team Leader Questions")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.pastTLAppDeadline)?_c('p',[_vm._v("The deadline for Team Leader applications has passed")]):_c('div',[_c('p',[_vm._v("Only SIGGRAPH Student Volunteers with at least 1 year of prior SV experience are eligible for Team Leader positions. Team Leaders (TLs) are Student Volunteers (SVs) selected to serve as liaisons to Venue and Program Chairs across the different areas of the conference.")]),_vm._v(" "),_c('p',[_vm._v("TLs have more responsibility and a more demanding workload than a regular SV. TLs serve in a supervisory role as they help train SVs to perform different duties, and resolve more complex attendee, contributor and volunteer questions and issues. TLs also volunteer approximately 60 hours either in pre-conference shifts or during the SIGGRAPH  week in addition to several pre-conference training sessions.")]),_vm._v(" "),_c('p',[_vm._v("Please keep in mind the TL application process is very competitive. TL applicants not selected for the role will still be considered for a position as SV.")])]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"id":"teamLeader","disabled":_vm.pastTLAppDeadline},model:{value:(_vm.teamLeader),callback:function ($$v) {_vm.teamLeader=$$v},expression:"teamLeader"}},[_vm._v("\n        I would like to apply for a Team Leader position\n      ")])],1),_vm._v(" "),(_vm.teamLeader)?_c('b-form-group',{attrs:{"label":"Tell us about your motivation to be a Team Leader.","label-for":"teamLeaderEssay1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('b-form-textarea',{attrs:{"id":"teamLeaderEssay1","rows":6,"max-rows":100},on:{"input":function($event){return _vm.wordCount('teamLeaderEssay1', 250)}},model:{value:(_vm.teamLeaderEssay1),callback:function ($$v) {_vm.teamLeaderEssay1=$$v},expression:"teamLeaderEssay1"}}),_vm._v(" "),_c('p',{class:_vm.teamLeaderEssay1WordLimitClass},[_vm._v(_vm._s(_vm.teamLeaderEssay1WordCount))])],1)])]):_vm._e(),_vm._v(" "),(_vm.teamLeader)?_c('b-form-group',{attrs:{"label":"Tell us about the qualities and experiences that make you a great fit for the role. Include any relevant leadership and/or mentorship experience.","label-for":"teamLeaderEssay2"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('b-form-textarea',{attrs:{"id":"teamLeaderEssay2","rows":6,"max-rows":100},on:{"input":function($event){return _vm.wordCount('teamLeaderEssay2', 250)}},model:{value:(_vm.teamLeaderEssay2),callback:function ($$v) {_vm.teamLeaderEssay2=$$v},expression:"teamLeaderEssay2"}}),_vm._v(" "),_c('p',{class:_vm.teamLeaderEssay2WordLimitClass},[_vm._v(_vm._s(_vm.teamLeaderEssay2WordCount))])],1)])]):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("Additional Comments")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Is there anything else you'd like the Student Volunteer Subcomittee to know?","label-for":"otherComments"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('b-form-textarea',{attrs:{"id":"otherComments","rows":6,"max-rows":100},model:{value:(_vm.otherComments),callback:function ($$v) {_vm.otherComments=$$v},expression:"otherComments"}})],1)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-group',[_c('button',{staticClass:"btn left-arrow-btn-primary btn-sm float-sm-left",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.previousStep}},[_vm._v("Previous Step")]),_vm._v(" "),_c('button',{staticClass:"btn arrow-btn-primary btn-sm float-sm-right",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.nextStep}},[_vm._v("Save and Continue")])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E2vk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumb}}),_vm._v(" "),_c('h1',[_vm._v("Search Applications by Status")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('b-form',{attrs:{"inline":""}},[_c('div',{staticClass:"filter-group"},[_c('label',[_vm._v("Completed Filter")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"enableCompletedFilter"},model:{value:(_vm.enableCompletedFilter),callback:function ($$v) {_vm.enableCompletedFilter=$$v},expression:"enableCompletedFilter"}},[_vm._v("\n            Enabled\n          ")]),_vm._v(" "),_c('b-form-select',{attrs:{"disabled":_vm.enabledCompletedFilter,"id":"completedFilter","options":_vm.bool},model:{value:(_vm.completed),callback:function ($$v) {_vm.completed=$$v},expression:"completed"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-group"},[_c('label',[_vm._v("Team Leader Filter")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"enableTeamLeaderFilter"},model:{value:(_vm.enableTeamLeaderFilter),callback:function ($$v) {_vm.enableTeamLeaderFilter=$$v},expression:"enableTeamLeaderFilter"}},[_vm._v("\n            Enabled\n          ")]),_vm._v(" "),_c('b-form-select',{attrs:{"disabled":_vm.enabledTeamLeaderFilter,"id":"teamLeaderFilter","options":_vm.bool},model:{value:(_vm.teamLeader),callback:function ($$v) {_vm.teamLeader=$$v},expression:"teamLeader"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-group"},[_c('label',[_vm._v("Financial Aid Filter")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"enableFinancialAidFilter"},model:{value:(_vm.enableFinancialAidFilter),callback:function ($$v) {_vm.enableFinancialAidFilter=$$v},expression:"enableFinancialAidFilter"}},[_vm._v("\n            Enabled\n          ")]),_vm._v(" "),_c('b-form-select',{attrs:{"disabled":_vm.enabledFinancialAidFilter,"id":"financialAidFilter","options":_vm.bool},model:{value:(_vm.financialAid),callback:function ($$v) {_vm.financialAid=$$v},expression:"financialAid"}})],1),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.isFiltering,"size":"sm","variant":"primary"},on:{"click":_vm.filterApps}},[_vm._v("Filter")])],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"exportModal",attrs:{"id":"export-modal","title":"Export to CSV","ok-title":"Cancel","ok-variant":"danger","ok-only":""},on:{"ok":_vm.cancelDownload}},[_c('b-progress',{attrs:{"max":_vm.exportData.total,"show-progress":"","animated":""}},[_c('b-progress-bar',{attrs:{"value":_vm.exportData.progress}},[_c('strong',[_vm._v(_vm._s(_vm.exportData.progress)+" / "+_vm._s(_vm.exportData.total))])])],1),_vm._v(" "),_c('p',{staticClass:"my-4"},[_vm._v("Downloading data for CSV...")])],1),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.filteredApps},scopedSlots:_vm._u([{key:"completed",fn:function(data){return [(data.item.completed)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"})]}},{key:"teamLeader",fn:function(data){return [(data.item.teamLeader)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"})]}},{key:"financialAid",fn:function(data){return [(data.item.financialAid)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"})]}},{key:"view",fn:function(data){return [_c('router-link',{attrs:{"to":{ name: 'ViewApp', params: { username: data.item.username } }}},[_vm._v("\n        View App\n      ")])]}}])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('b-pagination',{attrs:{"size":"md","total-rows":_vm.appPagination.total,"per-page":_vm.appPagination.limit},on:{"input":_vm.changePage},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('b-button',{staticClass:"export",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.exportApps}},[_vm._v("Export to CSV")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.withData),callback:function ($$v) {_vm.withData=$$v},expression:"withData"}},[_vm._v("With App Data")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.withScores),callback:function ($$v) {_vm.withScores=$$v},expression:"withScores"}},[_vm._v("With Essay Score Averages")]),_vm._v(" "),(_vm.isFiltering)?_c('div',{staticClass:"loader"},[_vm._v("Loading...")]):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EVuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'JuryAssignments',
  data: function data() {
    return {
      breadcrumb: [{
        text: 'Dashboard',
        to: { name: 'Home' }
      }, {
        text: 'Jury Assignments',
        to: { name: 'JuryAssignments' }
      }],
      TLsPerSVApp: 3,
      TLs: 22,
      isAssigning: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    assignmentsPerTL: function assignmentsPerTL() {
      if (this.appStatistics.completed !== 0) {
        var appsPerTL = (this.appStatistics.completed - this.TLs) * this.TLsPerSVApp / this.TLs;
        return 'This will assign ' + Math.floor(appsPerTL) + ' apps per TL.';
      } else {
        return '';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('admin', ['appStatistics'])),
  methods: {
    assignJury: function assignJury() {
      var _this = this;

      this.isAssigning = true;
      this.$store.dispatch('admin/assignSVAppsToTLs', this.TLsPerSVApp).then(function () {
        _this.isAssigning = false;
      }).catch(function (err) {
        _this.isAssigning = false;
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ "Ednz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/twitter.23b96df.png";

/***/ }),

/***/ "EoOQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/R5_s2024_Logo_Reverse_HiRes_Medium.0a57497.png";

/***/ }),

/***/ "EyCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header-tag":"header"}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Student Volunteer Application")]),_vm._v(" "),(_vm.isLoading)?_c('h4',[_vm._v("Getting your application...")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('div',{staticClass:"card-text"},[(_vm.isNewApp)?_c('div',{staticClass:"row"},[(_vm.isTeamLeader)?_c('div',{staticClass:"col"}):_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Applications Have Closed")]),_vm._v(" "),_c('p',[_vm._v("The deadline for submissions has passed and we are now processing completed applications.")])])]):_vm._e(),_vm._v(" "),(_vm.completed)?_c('div',{staticClass:"row"},[(_vm.isAccepted && !_vm.isTeamLeader)?_c('div',{staticClass:"col"},[_c('h2',{staticClass:"mb-2"},[_vm._v("Welcome to the SIGGRAPH SV Family!")]),_vm._v(" "),_c('p',[_vm._v("Congratulations on being accepted as a Student Volunteer for this year's conference!")]),_vm._v(" "),_c('p',[_vm._v("This page will be your Dashboard where you can access Scheduling features in the near future.")]),_vm._v(" "),_c('p',[_vm._v("If for some reason you are unable to attend, you can decline your position.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-block",attrs:{"type":"button"},on:{"click":_vm.declineAcceptance}},[_vm._v("Decline\n          Position")])]):_vm._e(),_vm._v(" "),(_vm.isTeamLeader)?_c('div',{staticClass:"col"},[_c('h2',{staticClass:"mb-2"},[_vm._v("Welcome to the SIGGRAPH SV Family!")]),_vm._v(" "),_c('p',[_vm._v("Congratulations on being accepted as a Team Leader for this year's conference!")]),_vm._v(" "),_c('p',[_vm._v("This page will be your Team Leader Dashboard where you can access Jury and Scheduling features.")])]):_vm._e(),_vm._v(" "),(_vm.isOffered && !_vm.isTeamLeader)?_c('div',{staticClass:"col"},[(_vm.isAfterConfirmationDeadline)?_c('div',[_c('h2',[_vm._v("The confirmation deadline has passed.")]),_vm._v(" "),_c('p',[_vm._v("The acceptance confirmation deadline for first round acceptances was "),_c('strong',[_vm._v("June 29th, 22:00 UTC/GMT")]),_vm._v(". If you have questions please email "),_c('a',{attrs:{"href":"mailto:sv-s2024@siggraph.org"}},[_vm._v("sv-s2024@siggraph.org")]),_vm._v(".")])]):_c('div',[_c('h2',[_vm._v("Congratulations!"),_c('br'),_vm._v("You've been accepted as a Student Volunteer!")]),_vm._v(" "),_c('p',[_vm._v("Now that you've been accepted, we need your confirmation of attendence.")]),_vm._v(" "),_c('p',[_vm._v("Please spend some time on this confirmation form so we know that you're able to come.\n            This will also help us better accomodate you and make sure you have a great experience at SIGGRAPH.")]),_vm._v(" "),_c('p',[_vm._v("Please confirm or decline your position no later than "),_c('strong',[_vm._v("June 29th, 22:00 UTC/GMT")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"btn btn-lg btn-block",attrs:{"type":"button"},on:{"click":_vm.goToConfirmationForm}},[_vm._v("Confirm")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"btn btn-lg btn-block",attrs:{"type":"button"},on:{"click":_vm.declineAcceptance}},[_vm._v("Decline")])])])])]):_vm._e(),_vm._v(" "),(_vm.isDeclined)?_c('div',{staticClass:"col"},[_c('h2',{staticClass:"mb-2"},[_vm._v("Sorry you aren't able to make it!")]),_vm._v(" "),_c('p',[_vm._v("You've declined the invitation to be a Student Volunteer. If this is a mistake, please contact us immediately\n          at "),_c('a',{attrs:{"href":"mailto:sv-s2024@siggraph.org"}},[_vm._v("sv-s2024@siggraph.org")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("The deadline for confirmations was "),_c('strong',[_vm._v("Thursday, June 20th")]),_vm._v(".")])]):_vm._e(),_vm._v(" "),(_vm.isPending && !_vm.isTeamLeader)?_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Thank You For Applying!")]),_vm._v(" "),_c('p',[_vm._v("You have successfully applied to the SIGGRAPH Student Volunteer Program.")]),_vm._v(" "),_c('p',[_vm._v("The deadline for submissions has passed and we are now processing completed applications.")]),_vm._v(" "),_c('h3',[_vm._v("Notification of Acceptance")]),_vm._v(" "),_c('p',[_vm._v("You should hear from us around the following time:")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("May 2024")])]),_vm._v(" "),_c('h3',[_vm._v("Professional References")]),_vm._v(" "),_c('p',[_vm._v("References will be contacted shortly after applications close. Please allow a few days for forms to be sent.\n        ")])]):_vm._e()]):_c('div',[_c('div',{staticClass:"row"},[(_vm.isTeamLeader)?_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Welcome to the SIGGRAPH SV Family!")]),_vm._v(" "),_c('p',[_vm._v("Congratulations on being accepted as a Team Leader for this year's conference!")]),_vm._v(" "),_c('p',[_vm._v("This page will be your Team Leader Dashboard where you can access Jury and Scheduling features.")])]):(!_vm.isNewApp)?_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Applications Have Closed")]),_vm._v(" "),_c('p',[_vm._v("The deadline for submissions has passed.")]),_vm._v(" "),_c('p',[_vm._v("We begin processing completed applications immediately and we cannot accept late submissions.")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",style:({ 'margin-top': '40px' })},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Resources")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://s2024.siggraph.org","target":"_blank"}},[_vm._v("SIGGRAPH 2024")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://s2024.siggraph.org/program/student-volunteers/","target":"_blank"}},[_vm._v("Frequently Asked\n            Questions")])])]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://www.facebook.com/SIGGRAPHStudentVolunteers","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("p8ve"),"width":"30px"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://twitter.com/siggraphsv","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("Ednz"),"width":"30px"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FGb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Jury',
  data: function data() {
    return {
      isLoadingList: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['juryDeadline']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('jury', ['assignments']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('jury', ['listAssignments']), {
    juryDeadlineFormat: function juryDeadlineFormat() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.juryDeadline).format('MMMM Do');
    },
    assignmentsScored: function assignmentsScored() {
      return this.listAssignments.filter(function (a) {
        return a.isScored;
      });
    }
  }),
  created: function created() {
    var _this = this;

    if (this.$store.state.jury.assignments.length === 0) {
      this.isLoadingList = true;
      this.$store.dispatch('jury/getTLAssignments').then(function () {
        _this.isLoadingList = false;
      }).catch(function (err) {
        console.log(err);
        _this.isLoadingList = false;
      });
    }
  }
});

/***/ }),

/***/ "FV1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateShiftSwapRequest_vue__ = __webpack_require__("yniD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76edbb40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShiftSwapRequest_vue__ = __webpack_require__("W55A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateShiftSwapRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76edbb40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShiftSwapRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FjnX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav__ = __webpack_require__("uL8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Countdown__ = __webpack_require__("KgB8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_Login__ = __webpack_require__("KQvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_1__Nav__["a" /* default */],
    Countdown: __WEBPACK_IMPORTED_MODULE_2__Countdown__["a" /* default */],
    Login: __WEBPACK_IMPORTED_MODULE_3__user_Login__["a" /* default */]
  },
  data: function data() {
    return {
      isRegistering: false
    };
  },

  methods: {
    toggleRegister: function toggleRegister() {
      this.isRegistering = !this.isRegistering;
    },
    formattedDate: function formattedDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).tz('UTC').format('D MMMM YYYY');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])(['applicationLaunchDate', 'applicationTlEndDate', 'applicationEndDate', 'acceptanceDate']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isAfterLaunchDate', 'isBeforeDeadline', 'isAfterDeadline', 'isAfterSchedulesOut']))
});

/***/ }),

/***/ "G641":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('h1',[_vm._v("Loading App...")]):_c('h1',[_vm._v(_vm._s(_vm.appFullName)+" - "+_vm._s(_vm.activeApp.svId))]),_vm._v(" "),(_vm.activeApp.isLoaded)?_c('div',[_c('b-form',{attrs:{"inline":""}},[_c('label',{staticClass:"mr-sm-2",attrs:{"for":"app-status"}},[_vm._v("Application Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"app-status","options":_vm.statusOptions,"size":"sm"},model:{value:(_vm.statusId),callback:function ($$v) {_vm.statusId=$$v},expression:"statusId"}}),_vm._v(" "),_c('b-button',{staticClass:"inline-btn",attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.updateProcessingStatus}},[_vm._v("Update")])],1),_vm._v(" "),(_vm.activeApp.completed)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Completed")]):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("In Progress")]),_vm._v(" "),(_vm.activeApp.teamLeader)?_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v("Team Leader Applicant")]):_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v("Not a Team Leader Applicant")]),_vm._v(" "),(_vm.activeApp.financialAid)?_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v("Financial Aid Applicant")]):_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v("Not a Financial Aid Applicant")]),_vm._v(" "),_c('b-tabs',[_c('b-tab',{attrs:{"title":"General"}},[_c('h3',[_vm._v("Academic Information")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("School")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.activeApp.data.schoolName))])]),_vm._v(" "),_c('b-list-group-item',[_c('h5',[_vm._v("School City")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.activeApp.data.schoolCity))])]),_vm._v(" "),_c('b-list-group-item',[_c('h5',[_vm._v("School State")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.activeApp.data.schoolState))])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("School Country")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.activeApp.data.schoolCountry))])]),_vm._v(" "),_c('b-list-group-item',[_c('h5',[_vm._v("Proximity to Conference")]),_vm._v(" "),(_vm.activeApp.data.closeProximity)?_c('span',{staticClass:"list-value"},[_vm._v("Within 50 miles")]):_c('span',{staticClass:"list-value"},[_vm._v("Further than 50 miles")])]),_vm._v(" "),_c('b-list-group-item',[_c('h5',[_vm._v("Expected Graduation Date")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.appExpectedGraduation))])])],1)],1)]),_vm._v(" "),_c('h3',[_vm._v("Proof of Enrollment")]),_vm._v(" "),(_vm.appProofOfEnrollmentIsLoaded)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.appProofOfEnrollmentIsPDF)?_c('iframe',{staticClass:"proof-of-enrollment",attrs:{"src":_vm.activeApp.proofOfEnrollmentUrl}}):_vm._e(),_vm._v(" "),(_vm.appProofOfEnrollmentIsImage)?_c('img',{staticClass:"proof-of-enrollment",attrs:{"src":_vm.activeApp.proofOfEnrollmentUrl}}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Areas of Interest")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('b-list-group',[_c('b-list-group-item',[(_vm.activeApp.data.interestArt)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v(" "),_c('span',[_vm._v("Art / Animation ")])]),_vm._v(" "),_c('b-list-group-item',[(_vm.activeApp.data.interestProductionDesign)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v(" "),_c('span',[_vm._v("Production / Design ")])]),_vm._v(" "),_c('b-list-group-item',[(_vm.activeApp.data.interestTechnical)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v(" "),_c('span',[_vm._v("Technical Development ")])]),_vm._v(" "),_c('b-list-group-item',[(_vm.activeApp.data.interestWeb)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v(" "),_c('span',[_vm._v("Web Technology ")])]),_vm._v(" "),_c('b-list-group-item',[(_vm.activeApp.data.interestGraphicDesign)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v(" "),_c('span',[_vm._v("Graphic Design ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('b-card',{attrs:{"header":"Other Interests"}},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.otherInterests))])])],1)]),_vm._v(" "),_c('h3',[_vm._v("SIGGRAPH Experience")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("SIGGRAPH North America")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[(_vm.activeApp.data.haveAttended)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v("\n                  Attended\n                ")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[(_vm.activeApp.data.haveVolunteered)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v("\n                  Volunteered\n                ")])]),_vm._v(" "),(_vm.activeApp.data.haveVolunteered)?_c('b-list-group-item',[_c('h5',[_vm._v("Years Volunteered")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.appYearsVolunteered))])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("SIGGRAPH Asia")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[(_vm.activeApp.data.haveAttendedAsia)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v("\n                  Attended\n                ")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[(_vm.activeApp.data.haveVolunteeredAsia)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v("\n                  Volunteered\n                ")])]),_vm._v(" "),(_vm.activeApp.data.haveVolunteeredAsia)?_c('b-list-group-item',[_c('h5',[_vm._v("Years Volunteered")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.appYearsVolunteeredAsia))])]):_vm._e()],1)],1)]),_vm._v(" "),_c('h3',[_vm._v("Reference")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("Reference Name")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.activeApp.data.referenceFirstName)+" "+_vm._s(_vm.activeApp.data.referenceLastName))])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("Reference Type")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.activeApp.data.referenceType))])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("Reference Email")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v(_vm._s(_vm.activeApp.data.referenceEmail))])])],1)],1)])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Essays"}},[_c('h3',[_vm._v("Student Volunteer Essays")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":"Essay 1 - Interest"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.essay1))])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":"Essay 2 - Interaction"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.essay2))])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":"Essay 3 - Initiative"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.essay3))])])])])],1)])]),_vm._v(" "),(_vm.activeApp.financialAid)?_c('b-tab',{attrs:{"title":"Financial Aid"}},[_c('h3',[_vm._v("Financial Assistance")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":"Financial Aid Summary"}},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.financialAidSummary))])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("Primary Transport")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v("\n                  "+_vm._s(_vm.activeApp.data.primaryTransport)+"\n                ")]),_c('br'),_vm._v(" "),(_vm.appFinancialAidAndFlying)?_c('span',{staticClass:"list-value"},[_vm._v("\n                  Airport Code: "+_vm._s(_vm.activeApp.data.airportCode)+"\n                ")]):_vm._e()])],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h5',[_vm._v("Estimated Travel Cost")]),_vm._v(" "),_c('span',{staticClass:"list-value"},[_vm._v("\n                  "+_vm._s(_vm.activeApp.data.estimatedTravelCost)),_c('br'),_vm._v(" "),(_vm.activeApp.data.fundedTravel)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"}),_vm._v("\n                  Partially or Fully Funded\n                ")])])],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.activeApp.teamLeader)?_c('b-tab',{attrs:{"title":"Team Leader"}},[_c('h3',[_vm._v("Team Leader Application")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":"Essay 1 - Qualification"}},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.teamLeaderEssay1))])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":"Essay 2 - Motivation"}},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.teamLeaderEssay2))])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":"Essay 3 - Awareness"}},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.activeApp.data.teamLeaderEssay3))])])],1)])]):_vm._e()],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GSlc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('data:image/png;base64,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');

/***/ }),

/***/ "HM6l":
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),

/***/ "HWsJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepOne_vue__ = __webpack_require__("z9Kd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cfd331_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepOne_vue__ = __webpack_require__("Cwj6");
function injectStyle (ssrContext) {
  __webpack_require__("oOEi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepOne_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cfd331_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepOne_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hgbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LiveAppStatus__ = __webpack_require__("eYOA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppStatus__ = __webpack_require__("lV3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Jury__ = __webpack_require__("j8Rg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Schedule__ = __webpack_require__("/yyi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SvDashboard',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isConfirmedSv']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAfterDeadline']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['isTeamLeader']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['profile']), {
    isBeforeAcceptances: function isBeforeAcceptances() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()().tz('UTC').isBefore(this.$store.state.acceptanceDate);
    }
  }),
  components: {
    LiveAppStatus: __WEBPACK_IMPORTED_MODULE_2__LiveAppStatus__["a" /* default */],
    AppStatus: __WEBPACK_IMPORTED_MODULE_3__AppStatus__["a" /* default */],
    Jury: __WEBPACK_IMPORTED_MODULE_4__Jury__["a" /* default */],
    Schedule: __WEBPACK_IMPORTED_MODULE_5__Schedule__["a" /* default */]
  }
});

/***/ }),

/***/ "IFye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainAdmin_vue__ = __webpack_require__("YYjt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd5ab5de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainAdmin_vue__ = __webpack_require__("LYCZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd5ab5de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__("wMq3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__application__ = __webpack_require__("1/MW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__admin__ = __webpack_require__("M8t8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jury__ = __webpack_require__("mIRV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__schedule__ = __webpack_require__("VugP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    application: __WEBPACK_IMPORTED_MODULE_3__application__["a" /* default */],
    admin: __WEBPACK_IMPORTED_MODULE_4__admin__["a" /* default */],
    jury: __WEBPACK_IMPORTED_MODULE_5__jury__["a" /* default */],
    schedule: __WEBPACK_IMPORTED_MODULE_6__schedule__["a" /* default */]
  },
  state: {
    error: '',
    message: '',
    applicationLaunchDate: '2023-12-08T08:00Z',
    applicationTlEndDate: '2024-02-05T22:00Z',
    applicationEndDate: '2024-03-04T22:00Z',
    juryDeadline: '2024-04-26T22:00Z',
    acceptanceDate: '2024-05-20T22:00Z',
    confirmationDeadline: '2024-06-29T22:00Z',
    schedulesOutDate: '2024-08-04T22:00Z'
  },
  getters: {
    isError: function isError(state) {
      return state.error.length > 0;
    },
    isMessage: function isMessage(state) {
      return state.message.length > 0;
    },
    isAfterLaunchDate: function isAfterLaunchDate(state) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()().tz('UTC').isAfter(state.applicationLaunchDate);
    },
    isAfterDeadline: function isAfterDeadline(state) {
      return true; // moment().tz('UTC').isAfter(state.applicationEndDate)
    },
    isBeforeDeadline: function isBeforeDeadline(state) {
      return false; // moment().tz('UTC').isBefore(state.applicationEndDate)
    },
    pastTLAppDeadline: function pastTLAppDeadline(state) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()().tz('UTC').isAfter(state.applicationTlEndDate);
    },
    isAfterSchedulesOut: function isAfterSchedulesOut(state) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()().tz('UTC').isAfter(state.schedulesOutDate);
    },
    isAfterConfirmationDeadline: function isAfterConfirmationDeadline(state) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()().tz('UTC').isAfter(state.confirmationDeadline);
    }
  },
  mutations: {
    error: function error(state, _ref) {
      var message = _ref.message;

      if (message === 'Failed to fetch') {
        state.error = 'Unable to complete request. If this continues to persist, email sv-s2024@siggraph.org';
      } else {
        state.error = message;
      }
    },
    clearError: function clearError(state) {
      state.error = '';
    },
    message: function message(state, _ref2) {
      var message = _ref2.message;

      state.message = message;
    },
    clearMessage: function clearMessage(state) {
      state.message = '';
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "K5SK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header-tag":"header"}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Student Volunteer Application Stats")]),_vm._v(" "),(_vm.isLoadingStats)?_c('h3',[_vm._v("Loading...")]):_vm._e(),_vm._v(" "),(_vm.appStatistics.isLoaded)?_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Starts")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.appStatistics.started))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Completed")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.appStatistics.completed))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Team Leader")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.appStatistics.teamLeader))])])])]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h3',[_vm._v("Applications")])]),_vm._v(" "),_c('b-list-group-item',{attrs:{"to":{ name: 'SearchApps'}}},[_vm._v("\n          Search Applications by User\n        ")]),_vm._v(" "),_c('b-list-group-item',{attrs:{"to":{ name: 'SearchAppsByStatus'}}},[_vm._v("\n          Search Applications by Status\n        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-list-group',[_c('b-list-group-item',[_c('h3',[_vm._v("Jury")])]),_vm._v(" "),_c('b-list-group-item',{attrs:{"to":{ name: 'JuryAssignments'}}},[_vm._v("\n          Jury Assignments\n        ")]),_vm._v(" "),_c('b-list-group-item',{attrs:{"disabled":true,"to":{ name: 'SearchAppsByStatus'}}},[_vm._v("\n          View Jury Statistics\n        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KGNE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var generateVuexSetters = function generateVuexSetters(fields) {
  var computed = {};
  fields.forEach(function (field) {
    computed[field] = {
      get: function get() {
        return this.$store.state.application.data[field];
      },
      set: function set(value) {
        this.$store.commit('application/updateField', { name: field, value: value });
      }
    };
  });
  return computed;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppStepTwo',
  data: function data() {
    return {
      essay1WordCount: '250 words remaining',
      essay1WordLimitClass: 'under-limit',
      essay2WordCount: '250 words remaining',
      essay2WordLimitClass: 'under-limit',
      essay3WordCount: '250 words remaining',
      essay3WordLimitClass: 'under-limit',
      disabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, generateVuexSetters(['essay1', 'essay2', 'essay3']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('application', ['isLoaded', 'isLoading'])),
  methods: {
    wordCount: function wordCount(field, limit) {
      var words = this[field].trim().split(/\s+/);
      var wordCount = words.length === 1 && words[0] === '' ? 0 : words.length;
      var remaining = limit - wordCount;
      this[field + 'WordCount'] = remaining < 0 ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining';
      this[field + 'WordLimitClass'] = remaining < 0 ? 'over-limit' : 'under-limit';
    },
    nextStep: function nextStep(e) {
      var _this = this;

      e.preventDefault();
      this.disabled = true;
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/dashboard');
      } else {
        this.$store.commit('application/updateStep', 3);
        this.$store.dispatch('application/save').then(function () {
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'stepThree' });
          _this.disabled = true;
        }).catch(function (err) {
          console.log(err.message);
          _this.disabled = true;
        });
      }
    },
    previousStep: function previousStep(e) {
      var _this2 = this;

      e.preventDefault();
      this.disabled = true;
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/dashboard');
      } else {
        this.$store.commit('application/updateStep', 1);
        this.$store.dispatch('application/save').then(function () {
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'stepOne' });
          _this2.disabled = false;
        }).catch(function (err) {
          console.log(err.message);
          _this2.disabled = false;
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(function () {
        if (_this3.$store.getters['pastTLAppDeadline'] && _this3.$store.state.application.teamLeader) {
          _this3.$store.commit('application/disableTeamLeader');
        }
        if (_this3.$store.state.application.completed) {
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/dashboard');
        } else if (_this3.$store.state.application.isNew) {
          _this3.$store.dispatch('application/save');
        } else if (_this3.$store.state.application.step !== 2) {
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/application/' + _this3.$store.state.application.step.toString());
        }
      });
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader');
    }
    if (this.$store.state.application.completed) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/dashboard');
    }
  },
  mounted: function mounted() {
    this.wordCount('essay1', 250);
    this.wordCount('essay2', 250);
    this.wordCount('essay3', 250);
  }
});

/***/ }),

/***/ "KQbN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KQvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("vpE9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a52bfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("CPfn");
function injectStyle (ssrContext) {
  __webpack_require__("1uel")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a52bfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KgB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown_vue__ = __webpack_require__("7myE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a3037e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown_vue__ = __webpack_require__("hIjy");
function injectStyle (ssrContext) {
  __webpack_require__("ir3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a3037e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LYCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('navigation'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LvjE":
/***/ (function(module, exports) {

module.exports = {"version":"2019b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),

/***/ "M8t8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var admin = {
  namespaced: true,
  state: {
    isLoadingStats: false,
    appStatistics: {
      isLoaded: false,
      started: 0,
      completed: 0,
      teamLeader: 0
    },
    filteredApps: [],
    appPagination: {
      total: 0,
      limit: 20,
      pages: 1,
      page: 1
    },
    activeApp: {
      firstName: '',
      lastName: '',
      email: '',
      svId: '',
      username: '',
      data: {
        expectedGraduationMonth: '01',
        expectedGraduationYear: '2024',
        yearsVolunteered: [],
        yearsVolunteeredAsia: [],
        proofOfEnrollment: {
          type: ''
        }
      },
      proofOfEnrollmentUrl: '',
      completed: false,
      teamLeader: false,
      financialAid: false,
      isLoaded: false
    },
    exportData: {
      progress: 0,
      total: 1,
      cancelDownload: false
    }
  },
  mutations: {
    loadingStats: function loadingStats(state) {
      state.isLoadingStats = true;
    },
    setAppStatistics: function setAppStatistics(state, _ref) {
      var total = _ref.total,
          completed = _ref.completed,
          team_leader = _ref.team_leader;

      state.isLoadingStats = false;
      state.appStatistics.isLoaded = true;
      state.appStatistics.started = total;
      state.appStatistics.completed = completed;
      state.appStatistics.teamLeader = team_leader; // eslint-disable-line camelcase
    },
    setFilteredApps: function setFilteredApps(state, apps) {
      state.filteredApps = apps;
    },
    setPagination: function setPagination(state, _ref2) {
      var limit = _ref2.limit,
          pages = _ref2.pages,
          page = _ref2.page,
          total = _ref2.total;

      state.appPagination.total = total;
      state.appPagination.limit = limit;
      state.appPagination.pages = pages;
      state.appPagination.page = page;
    },
    loadApp: function loadApp(state, data) {
      data.isLoaded = true;
      state.activeApp = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, data);
    },
    loadProofOfEnrollment: function loadProofOfEnrollment(state, url) {
      state.activeApp.proofOfEnrollmentUrl = url;
    },
    deactivateApp: function deactivateApp(state) {
      state.activeApp = {
        firstName: '',
        lastName: '',
        email: '',
        svId: '',
        username: '',
        data: {
          expectedGraduationMonth: '01',
          expectedGraduationYear: '2018',
          yearsVolunteered: [],
          yearsVolunteeredAsia: [],
          proofOfEnrollment: {
            type: ''
          }
        },
        proofOfEnrollmentUrl: '',
        completed: false,
        teamLeader: false,
        financialAid: false,
        isLoaded: false
      };
    },
    cancelDownload: function cancelDownload(state) {
      state.exportData.cancelDownload = true;
    },
    setExportData: function setExportData(state, _ref3) {
      var total = _ref3.total,
          addProgress = _ref3.addProgress;

      state.exportData.total = total;
      if (state.exportData.progress + addProgress > total) {
        state.exportData.progress = total;
      } else {
        state.exportData.progress += addProgress;
      }
    },
    resetExportData: function resetExportData(state) {
      state.exportData.total = 0;
      state.exportData.progress = 0;
    },
    updateProcessingStatus: function updateProcessingStatus(state, value) {
      state.activeApp.statusId = value;
    }
  },
  getters: {
    appFullName: function appFullName(state) {
      return state.activeApp.firstName + ' ' + state.activeApp.lastName;
    },
    appExpectedGraduation: function appExpectedGraduation(state) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.activeApp.data.expectedGraduationMonth + '-01-' + state.activeApp.data.expectedGraduationYear).format('MMMM YYYY');
    },
    appYearsVolunteered: function appYearsVolunteered(state) {
      return state.activeApp.data.yearsVolunteered.join(', ');
    },
    appYearsVolunteeredAsia: function appYearsVolunteeredAsia(state) {
      if (state.activeApp.data.hasOwnProperty('yearsVolunteeredAsia')) {
        return state.activeApp.data.yearsVolunteeredAsia.join(', ');
      } else {
        return '';
      }
    },
    appFinancialAidAndFlying: function appFinancialAidAndFlying(state) {
      return state.activeApp.data.financialAid && state.activeApp.data.primaryTransport === 'plane';
    },
    appProofOfEnrollmentIsLoaded: function appProofOfEnrollmentIsLoaded(state) {
      return state.activeApp.proofOfEnrollmentUrl !== '';
    },
    appProofOfEnrollmentIsImage: function appProofOfEnrollmentIsImage(state) {
      return state.activeApp.data.proofOfEnrollment.type.split('/')[0] === 'image';
    },
    appProofOfEnrollmentIsPDF: function appProofOfEnrollmentIsPDF(state) {
      return state.activeApp.data.proofOfEnrollment.type === 'application/pdf';
    }
  },
  actions: {
    getAppStatistics: function getAppStatistics(_ref4) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState;

      commit('loadingStats');
      fetch('https://api.siggraphsv.org/' + 'application/statistics', {
        headers: {
          'Authorization': rootState.user.session.accessToken.jwtToken
        }
      }).then(function (response) {
        response.json().then(function (payload) {
          commit('setAppStatistics', payload.data);
        });
      });
    },
    searchApplications: function searchApplications(_ref5, filterData) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'application/search', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filterData)
        }).then(function (response) {
          response.json().then(function (payload) {
            if (response.statusCode === 500) {
              commit('error', { message: payload.data.message }, { root: true });
              reject(payload.data.error);
            } else {
              var apps = payload.data.applications.map(function (app) {
                var attributes = {};
                app.sv.Attributes.forEach(function (attr) {
                  attributes[attr.Name] = attr.Value;
                });
                return {
                  firstName: attributes.given_name,
                  lastName: attributes.family_name,
                  email: attributes.email,
                  svId: attributes['custom:svid'],
                  completed: app.completed,
                  teamLeader: app.team_leader,
                  financialAid: app.financial_aid,
                  username: app.sv.Username
                };
              });
              commit('setFilteredApps', apps);
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    sendFilterByStatusRequest: function sendFilterByStatusRequest(_ref6, _ref7) {
      var commit = _ref6.commit,
          state = _ref6.state,
          rootState = _ref6.rootState;
      var queryString = _ref7.queryString,
          checkCancel = _ref7.checkCancel,
          returnArray = _ref7.returnArray,
          withData = _ref7.withData,
          withScores = _ref7.withScores;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (checkCancel && state.exportData.cancelDownload) {
          resolve({
            canceled: true
          });
        } else {
          fetch('https://api.siggraphsv.org/' + 'application/search' + queryString, {
            headers: {
              'Authorization': rootState.user.session.accessToken.jwtToken
            }
          }).then(function (response) {
            response.json().then(function (payload) {
              if (response.statusCode === 500) {
                commit('error', { message: payload.data.message }, { root: true });
                reject(payload.data.error);
              } else {
                var apps = payload.data.apps.map(function (app) {
                  var attributes = {
                    given_name: 'N/A',
                    family_name: 'N/A',
                    email: 'N/A',
                    'custom:svid': 'N/A'
                  };
                  var username = app.sv_id;
                  if (app.sv !== undefined) {
                    app.sv.UserAttributes.forEach(function (attr) {
                      attributes[attr.Name] = attr.Value;
                    });
                    username = app.sv.Username;
                  }
                  if (returnArray) {
                    var appReturn = [attributes.given_name, attributes.family_name, attributes.email, attributes['custom:svid'], app.completed, app.team_leader, app.financial_aid, username];
                    if (withData) {
                      appReturn.push(app.data);
                    }
                    if (withScores) {
                      appReturn.push(app.totalavg);
                    }
                    return appReturn;
                  } else {
                    return {
                      firstName: attributes.given_name,
                      lastName: attributes.family_name,
                      email: attributes.email,
                      svId: attributes['custom:svid'],
                      completed: app.completed,
                      teamLeader: app.team_leader,
                      financialAid: app.financial_aid,
                      username: username
                    };
                  }
                });
                resolve({
                  apps: apps,
                  total: parseInt(payload.data.total),
                  limit: payload.data.limit,
                  pages: payload.data.pages,
                  page: payload.data.page,
                  canceled: false
                });
              }
            });
          });
        }
      });
    },
    filterApps: function filterApps(_ref8, filters) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch,
          rootState = _ref8.rootState;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var queryParams = [];
        if (filters.filterCompleted) {
          var completedValue = filters.completed ? 'true' : 'false';
          queryParams.push('completed=' + completedValue);
        }
        if (filters.filterTeamLeader) {
          var teamLeaderValue = filters.teamLeader ? 'true' : 'false';
          queryParams.push('teamLeader=' + teamLeaderValue);
        }
        if (filters.filterFinancialAid) {
          var financialAidValue = filters.financialAid ? 'true' : 'false';
          queryParams.push('financialAid=' + financialAidValue);
        }
        if (filters.page > 1) {
          queryParams.push('page=' + filters.page.toString());
        }
        var queryString = '?' + queryParams.join('&');
        dispatch('sendFilterByStatusRequest', {
          queryString: queryString,
          checkCancel: false,
          returnArray: false,
          withData: false
        }).then(function (responseData) {
          commit('setFilteredApps', responseData.apps);
          commit('setPagination', {
            total: responseData.total,
            limit: responseData.limit,
            pages: responseData.pages,
            page: responseData.page
          });
          resolve();
        });
      });
    },
    exportApps: function exportApps(_ref9, filters) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch,
          rootState = _ref9.rootState;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var queryParams = [];
        if (filters.filterCompleted) {
          var completedValue = filters.completed ? 'true' : 'false';
          queryParams.push('completed=' + completedValue);
        }
        if (filters.filterTeamLeader) {
          var teamLeaderValue = filters.teamLeader ? 'true' : 'false';
          queryParams.push('teamLeader=' + teamLeaderValue);
        }
        if (filters.filterFinancialAid) {
          var financialAidValue = filters.financialAid ? 'true' : 'false';
          queryParams.push('financialAid=' + financialAidValue);
        }
        if (filters.withData) {
          queryParams.push('withData=true');
          // Data can contain cause the body to be too long. Decrease the default limit
          queryParams.push('limit=10');
        }
        if (filters.withScores) {
          queryParams.push('withScores=true');
        }
        var queryString = '?' + queryParams.join('&');
        dispatch('sendFilterByStatusRequest', {
          queryString: queryString,
          checkCancel: true,
          returnArray: true,
          withData: filters.withData,
          withScores: filters.withScores
        }).then(function (responseData) {
          if (responseData.canceled) {
            commit('resetExportData');
          } else {
            commit('setExportData', {
              addProgress: responseData.total < responseData.limit ? responseData.total : responseData.limit,
              total: responseData.total
            });
            var apps = responseData.apps;
            var download = __webpack_require__("sJst");
            if (responseData.pages > 1) {
              var asyncLoop = function asyncLoop(o) {
                var loop = function loop(page, cancelDownload) {
                  if (cancelDownload) {
                    // Check to see if the user canceled the export
                    commit('resetExportData');
                    resolve();
                    return;
                  }
                  if (page === false) {
                    o.callback();
                    return;
                  }
                  o.functionToLoop(loop, page);
                };
                loop(2); // init
              };
              var pageParameter = 'page=';
              if (queryParams.length > 0) {
                pageParameter = '&' + pageParameter;
              }
              var nextPageRequest = function nextPageRequest(nextPage) {
                return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  dispatch('sendFilterByStatusRequest', {
                    queryString: queryString + pageParameter + nextPage.toString(),
                    checkCancel: true,
                    returnArray: true,
                    withData: filters.withData,
                    withScores: filters.withScores
                  }).then(function (nextResponseData) {
                    if (!nextResponseData.canceled) {
                      commit('setExportData', {
                        addProgress: nextResponseData.total < nextResponseData.limit ? nextResponseData.total : nextResponseData.limit,
                        total: nextResponseData.total
                      });
                    }
                    resolve(nextResponseData);
                  });
                });
              };
              // Use an asynchronous loop to go through each page
              asyncLoop({
                functionToLoop: function functionToLoop(loop, page) {
                  nextPageRequest(page).then(function (nextApps) {
                    if (!nextApps.canceled) {
                      apps = apps.concat(nextApps.apps);
                    }
                    if (responseData.pages > page) {
                      loop(page + 1, nextApps.canceled);
                    } else {
                      loop(false, nextApps.canceled);
                    }
                  });
                },
                callback: function callback() {
                  // apps is now a full array of results
                  // convert array to CSV
                  var csv = "First Name,Last Name,Email,SV ID,Completed,Team Leader,Financial Aid,Username"; // eslint-disable-line quotes
                  if (filters.withData) {
                    // Use the keys from the application to populate the CSV
                    csv += ',';
                    var dataKeys = [];
                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rootState.application.data).forEach(function (key) {
                      if (key !== 'proofOfEnrollment' && key !== 'step' && key !== 'acceptedTerms') {
                        dataKeys.push(key);
                      }
                    });
                    csv += dataKeys.join();
                    if (filters.withScores) {
                      csv += ",Average Essay Score"; // eslint-disable-line quotes
                      apps.sort(function (a, b) {
                        if (a[9] < b[9]) {
                          return 1;
                        }
                        if (a[9] > b[9]) {
                          return -1;
                        }
                        return 0;
                      });
                    }
                    csv += "\n"; // eslint-disable-line quotes
                    apps.forEach(function (app) {
                      var score = '';
                      if (filters.withScores) {
                        score = app.pop(); // eslint-disable-line no-unused-vars
                      }
                      var appData = app.pop();
                      csv += app.join() + ',';
                      var formatAppData = [];
                      dataKeys.forEach(function (keyName) {
                        switch (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(appData[keyName])) {
                          case 'string':
                            // Replace double quotes with single quotes and new lines with spaces
                            var value = appData[keyName].replace(/"/g, '\'').replace(/\n/g, '  ');
                            formatAppData.push('"' + value + '"');
                            break;
                          case 'boolean':
                            formatAppData.push('"' + appData[keyName] + '"');
                            break;
                          case 'object':
                            formatAppData.push('"' + appData[keyName].join() + '"');
                            break;
                          case 'undefined':
                            formatAppData.push('""');
                        }
                      });
                      csv += formatAppData.join();
                      if (filters.withScores) {
                        csv += "," + score; // eslint-disable-line no-undef, quotes
                      }
                      csv += "\n"; // eslint-disable-line quotes
                    });
                  } else {
                    if (filters.withScores) {
                      csv += ",Average Essay Score"; // eslint-disable-line quotes
                      apps.sort(function (a, b) {
                        if (a[8] < b[8]) {
                          return 1;
                        }
                        if (a[8] > b[8]) {
                          return -1;
                        }
                        return 0;
                      });
                    }
                    csv += "\n"; // eslint-disable-line quotes
                    apps.forEach(function (app) {
                      csv += app.join() + "\n"; // eslint-disable-line quotes
                    });
                  }
                  download(csv, 'filtered-sv-apps.csv', 'text/csv');
                  resolve();
                  commit('resetExportData');
                }
              });
            } else {
              // Only one page to begin with so convert to csv
              var csv = "First Name,Last Name,Email,SV ID,Completed,Team Leader,Financial Aid,Username"; // eslint-disable-line quotes
              if (filters.withData) {
                // Use the keys from the application to populate the CSV
                csv += ',';
                var dataKeys = [];
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rootState.application.data).forEach(function (key) {
                  if (key !== 'proofOfEnrollment' && key !== 'step' && key !== 'acceptedTerms') {
                    dataKeys.push(key);
                  }
                });
                csv += dataKeys.join();
                if (filters.withScores) {
                  csv += ",Average Essay Score"; // eslint-disable-line quotes
                  apps.sort(function (a, b) {
                    if (a[9] < b[9]) {
                      return 1;
                    }
                    if (a[9] > b[9]) {
                      return -1;
                    }
                    return 0;
                  });
                }
                csv += "\n"; // eslint-disable-line quotes
                apps.forEach(function (app) {
                  if (filters.withScores) {
                    var _score = app.pop(); // eslint-disable-line no-unused-vars
                  }
                  var appData = app.pop();
                  csv += app.join() + ',';
                  var formatAppData = [];
                  dataKeys.forEach(function (keyName) {
                    switch (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(appData[keyName])) {
                      case 'string':
                      case 'boolean':
                        formatAppData.push('"' + appData[keyName] + '"');
                        break;
                      case 'object':
                        formatAppData.push('"' + appData[keyName].join() + '"');
                        break;
                      case 'undefined':
                        formatAppData.push('""');
                    }
                  });
                  csv += formatAppData.join();
                  if (filters.withScores) {
                    csv += "," + score; // eslint-disable-line no-undef, quotes
                  }
                  csv += "\n"; // eslint-disable-line quotes
                });
              } else {
                if (filters.withScores) {
                  csv += ",Average Essay Score"; // eslint-disable-line quotes
                  apps.sort(function (a, b) {
                    if (a[8] < b[8]) {
                      return 1;
                    }
                    if (a[8] > b[8]) {
                      return -1;
                    }
                    return 0;
                  });
                }
                csv += "\n"; // eslint-disable-line quotes
                apps.forEach(function (app) {
                  csv += app.join() + "\n"; // eslint-disable-line quotes
                });
              }
              download(csv, 'filtered-sv-apps.csv', 'text/csv');
              resolve();
              commit('resetExportData');
            }
          }
        });
      });
    },
    getApp: function getApp(_ref10, username) {
      var commit = _ref10.commit,
          rootState = _ref10.rootState;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'application/' + username, {
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          }
        }).then(function (response) {
          response.json().then(function (payload) {
            if (response.status === 200 && payload.success) {
              var attributes = {};
              payload.data.sv.UserAttributes.forEach(function (attr) {
                attributes[attr.Name] = attr.Value;
              });
              var app = {
                firstName: attributes.given_name,
                lastName: attributes.family_name,
                email: attributes.email,
                svId: attributes['custom:svid'],
                data: payload.data.data,
                completed: payload.data.completed,
                teamLeader: payload.data.team_leader,
                financialAid: payload.data.financial_aid,
                username: payload.data.sv.Username,
                statusId: payload.data.status_id
              };
              commit('loadApp', app);
              // Get Proof of Enrollment URL
              fetch('https://api.siggraphsv.org/' + 'files/' + username, {
                headers: {
                  'Authorization': rootState.user.session.accessToken.jwtToken
                }
              }).then(function (response) {
                response.json().then(function (payload) {
                  if (response.status === 200 && payload.success) {
                    commit('loadProofOfEnrollment', payload.data);
                    resolve();
                  } else {
                    commit('error', { message: 'Unable to load application' }, { root: true });
                    resolve();
                  }
                });
              }).catch(function (err) {
                commit('error', { message: err.message }, { root: true });
                reject(err);
              });
            } else if (response.status === 404 && !payload.success) {
              commit('appLoadedInit');
              resolve();
            } else {
              commit('error', { message: 'Unable to load application' }, { root: true });
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    assignSVAppsToTLs: function assignSVAppsToTLs(_ref11, tlsPerApp) {
      var commit = _ref11.commit,
          rootState = _ref11.rootState;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'jury/assign-jury', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ TLsPerApp: tlsPerApp })
        }).then(function (response) {
          response.json().then(function (payload) {
            if (response.status === 200 && payload.success) {
              commit('message', { message: payload.data.message }, { root: true });
              resolve();
            } else {
              commit('error', { message: payload.data.message }, { root: true });
              reject(payload.data.error);
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    updateProcessingStatus: function updateProcessingStatus(_ref12) {
      var commit = _ref12.commit,
          state = _ref12.state,
          rootState = _ref12.rootState;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'application/status/' + state.activeApp.username, {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ statusId: state.activeApp.statusId })
        }).then(function (response) {
          response.json().then(function (payload) {
            if (response.status === 200 && payload.success) {
              commit('message', { message: 'Updated application status' }, { root: true });
              resolve();
            } else {
              commit('error', { message: payload.data.message }, { root: true });
              reject(payload.data.error);
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (admin);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e93df7f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KQbN");
function injectStyle (ssrContext) {
  __webpack_require__("5ild")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e93df7f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MdWr":
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),

/***/ "N4Cn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_mq__ = __webpack_require__("iKms");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'bootstrap/dist/css/bootstrap.css'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_mq__["a" /* default */], {
  breakpoints: {
    mobile: 800,
    desktop: Infinity
  }
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NxiE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Nav__ = __webpack_require__("uL8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_SelectLists__ = __webpack_require__("rydV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Confirmation',
  data: function data() {
    return {
      form: {
        passportStatus: null,
        needsVisa: false,
        wantsMembership: false,
        additionalInfo: '',
        preconfShifts: false,
        preconfStart: 'friday',
        preconfStartTime: '12:00',
        artGallery: false,
        etech: false,
        labs: false,
        vrtheater: false,
        greeter: false,
        pavillion: false,
        firstChoice: 'none',
        secondChoice: 'none',
        thirdChoice: 'none',
        emailConsent: false,
        photoConsent: false
      },
      step: 1,
      startTimes: __WEBPACK_IMPORTED_MODULE_5__util_SelectLists__["k" /* startTimes */],
      shifts: __WEBPACK_IMPORTED_MODULE_5__util_SelectLists__["j" /* shifts */],
      disabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage'])),
  methods: {
    nextStep: function nextStep(e) {
      e.preventDefault();
      if (this.form.passportStatus === null) {
        this.$store.commit('error', {
          message: 'Please select a passport status.'
        });
      } else if (!this.form.photoConsent) {
        this.$store.commit('error', {
          message: 'Please consent to the photo and video policy.'
        });
      } else if (!this.form.emailConsent) {
        this.$store.commit('error', {
          message: 'Please consent to the email policy.'
        });
      } else {
        this.$store.commit('clearError');
        this.step++;
      }
      window.scrollTo(0, 0);
    },
    previousStep: function previousStep(e) {
      e.preventDefault();
      this.step = 1;
      window.scrollTo(0, 0);
    },
    submitConfirmation: function submitConfirmation(e) {
      var _this = this;

      e.preventDefault();
      this.disabled = true;
      this.$store.dispatch('user/submitConfirmation', { data: this.form }).then(function () {
        // Reload application again to get the new status
        _this.$store.dispatch('application/load');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
        _this.disabled = false;
      }).catch(function (e) {
        _this.disabled = false;
      });
    }
  },
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_3__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_4__components_Nav__["a" /* default */]
  },
  created: function created() {
    if (!this.$store.state.user.loadedAttributes) {
      this.$store.dispatch('user/loadAttributes');
    }
    if (this.$store.state.application.data.haveVolunteered) {
      this.form.priorSv = true;
    }
  }
});

/***/ }),

/***/ "OpFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('div',{staticClass:"nav-bg container-fluid"},[_c('navigation')],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P0Wh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SvSchedule_vue__ = __webpack_require__("pVNG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28beccb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SvSchedule_vue__ = __webpack_require__("9Zrb");
function injectStyle (ssrContext) {
  __webpack_require__("WzCT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SvSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28beccb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SvSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q6FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navigation',
  data: function data() {
    return {};
  },

  methods: {
    logout: function logout(e) {
      e.preventDefault();
      this.$store.dispatch('user/logout');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['isTeamLeader', 'isAuthenticated']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('application', ['statusId']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAfterSchedulesOut', 'isAfterDeadline']), {
    isBeforeAcceptances: function isBeforeAcceptances() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()().isBefore(this.$store.state.acceptanceDate);
    }
  })
});

/***/ }),

/***/ "QD3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.alert, _vm.alertType, _vm.alertDismissible],attrs:{"id":"alert","role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.dismiss}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),(_vm.isError)?_c('span',[_vm._v(_vm._s(_vm.error))]):_vm._e(),(_vm.isMessage)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QiJN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JuryAssignments_vue__ = __webpack_require__("EVuR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768a47b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JuryAssignments_vue__ = __webpack_require__("XWIh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JuryAssignments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768a47b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JuryAssignments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SEa2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stepFour"}},[(_vm.isLoading)?_c('h3',[_vm._v("Getting your application...")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('b-form',[_c('div',{staticClass:"container"},[_c('h2',[_vm._v("Confirmation of Responsibilities")]),_vm._v(" "),_c('p',[_vm._v("Please Take a minute to read the Student Volunteer Eligibility Requirements and Responsibilities below:")])]),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"eligibility"}},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Eligibility")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Age")]),_vm._v(" "),_c('p',[_vm._v("Applicants must be 18 years of age or older (on or before 15 May 2024).")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Full Time Student Status")]),_vm._v(" "),_c('p',[_vm._v("Applicants must be/have been enrolled as a full-time high school, undergraduate, or graduate students for at least one semester between June 2023 and September 2024.")])])])]),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"expectations"}},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Expectations")])])])]),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_vm._v("Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer Program after accepting a position.")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteers and Team Leaders will serve the conference in-person shifts (on-site at SIGGRAPH 2024 in Denver).")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteers commit to volunteering about 25 hours to provide operational support for SIGGRAPH 2024 in pre-conference shifts or the in-person conference. In exchange for their service and enthusiasm, Student Volunteers receive the highest level of registration for the conference, networking opportunities, and a number of exclusive Student Volunteer-only benefits.")]),_vm._v(" "),_c('p',[_vm._v("Team Leaders are expected to volunteer about 60 hours to provide operational and logistical support for SIGGRAPH 2024 pre-conference shifts or the in-person conference. In exchange for their service and enthusiasm, Team Leaders receive the highest level of registration for the conference, networking opportunities, and a number of exclusive Student Volunteer-only benefits.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("For In-person Volunteers")]),_vm._v(" "),_c('ul',{staticStyle:{"list-style-type":"square","padding-left":"15px"}},[_c('li',[_vm._v("You are expected to participate in SIGGRAPH 2024 all day from July 28 - August 1 2024 in Denver.")]),_vm._v(" "),_c('li',[_vm._v("DO NOT plan to depart the Colorado Convention Center earlier than 6 pm (GMT-8) on 1 August 2024.")]),_vm._v(" "),_c('li',[_vm._v("No housing or accommodation will be provided to Team Leaders or Student Volunteers.")]),_vm._v(" "),_c('li',[_vm._v("Student Volunteers and Team Leaders can opt for financial assistance on their application form. You will be notified if you are awarded financial aid and the amount with the result of your student volunteer application.")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_vm._v("More details on what involves being a Student Volunteer will be provided during the upcoming months.")]),_vm._v(" "),_c('p',[_vm._v("If you have any questions regarding the program and processes, please email "),_c('a',{attrs:{"href":"mailto:sv-s2024@siggraph.org"}},[_vm._v("sv-s2024@siggraph.org")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Attend Mandatory Orientation")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer Program after accepting a position.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_c('b',[_vm._v("IMPORTANT.")]),_vm._v(" More details on what involves being a in-person Student Volunteer will be provided upon acceptance. We encourage you to visit our  "),_c('a',{attrs:{"href":"https://s2024.siggraph.org/program/student-volunteers/"}},[_vm._v("FAQs")]),_vm._v(" section to stay abreast of the latest updates regarding the Student Volunteer Program.")])])])]),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"benefits"}},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Benefits")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Full Conference Registration")]),_vm._v(" "),_c('p',[_vm._v("Enjoy all of the latest and greatest this amazing conference has to offer! SIGGRAPH offers many opportunities to explore the latest innovations when you are off-shift.")]),_vm._v(" "),_c('h3',[_vm._v("Student Volunteer Special Sessions")]),_vm._v(" "),_c('p',[_vm._v("Hear top professionals in the industry and academia (some of them former Student Volunteers) speak about tips, tricks, and job opportunities at exclusive “Student Volunteers-only” sessions before SIGGRAPH 2024!")]),_vm._v(" "),_c('h3',[_vm._v("S3 Résumé and Reel Review Sessions")]),_vm._v(" "),_c('p',[_vm._v("Polish your reel and résumé, and get some professional feedback (virtually and in-person) to land your dream job! Space is limited. This program is made possible by the SIGGRAPH Student Services Committee (S3).")]),_vm._v(" "),_c('h3',[_vm._v("Professional Development")]),_vm._v(" "),_c('p',[_vm._v("Expand your knowledge outside the classroom through leadership, mentoring, and diversity & inclusion sessions tailored specially for student volunteers.")]),_vm._v(" "),_c('h3',[_vm._v("Networking")]),_vm._v(" "),_c('p',[_vm._v("Participate in the many events and get-togethers we will organize prior to and during the conference. Meet students from all over the globe who share your passion for computer graphics and interactive techniques!")])])])]),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"deadlines"}},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Deadlines")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("Please comply with the submission deadlines and ensure you submit your application by the appropriate day and time. We will not accept any late applications or make any exceptions for students due to miscalculation of the application deadline. Thank you for your understanding.")]),_vm._v(" "),_c('p',[_vm._v("Please adjust your spam filter so messages with the ‘siggraph.org’ domain will not be placed in your junk-mail folder.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v(_vm._s(_vm.formattedDate(_vm.applicationTlEndDate))+":")]),_vm._v(" Team Leader Applications Deadline")]),_vm._v(" "),_c('p',[_vm._v("Only open to students who have previously served as Student Volunteers. Please complete the regular Student Volunteer application and the Team Leader essays on the application by 22:00 UTC/GMT.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v("Mid-February 2024:")]),_vm._v(" Team Leader Acceptance Notification")]),_vm._v(" "),_c('p',[_vm._v("Team Leader application results will be sent in mid-February 2024. You will receive an email notification at the address you provided in your application. Applicants who are not accepted as Team Leaders will still be considered for Student Volunteer positions.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v(_vm._s(_vm.formattedDate(_vm.applicationEndDate))+":")]),_vm._v(" Student Volunteer Application Deadline")]),_vm._v(" "),_c('p',[_vm._v("The Student Volunteer application must be completed by 22:00 UTC/GMT  (convert to your time zone).  Please note you will be required to upload proof of full-time student status (e.g., transcript, proof of enrollment, etc.). We recommend you allow ample time to gather this information from your institution before the due date. Without this documentation, your application will be marked as incomplete.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v("Late April 2024:")]),_vm._v(" Student Volunteer Acceptance Notification")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteer application results will be sent in late April 2024. You will receive an email notification at the address you provided in your application.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Professional References")]),_vm._v(" "),_c('p',[_vm._v("References will be contacted after applications close.")])])])]),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"questions"}},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Questions")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_vm._v("We encourage you to visit our "),_c('a',{attrs:{"href":"https://s2024.siggraph.org/program/student-volunteers/"}},[_vm._v("FAQ")]),_vm._v(" to stay abreast of the latest updates regarding the Student Volunteer Program.")]),_vm._v(" "),_c('p',[_vm._v("If your question is not in the FAQs, send us an email to "),_c('a',{attrs:{"href":"mailto:sv-s2024@siggraph.org"}},[_vm._v("sv-s2024@siggraph.org")])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h2',[_vm._v("Terms and Responsibilities Agreement")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("I have read and understood the Student Volunteer Eligibility Requirements and Responsibilities. I certify that I am eligible to volunteer and willing to comply with the responsibilities described.")]),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4"},[_c('b-form-checkbox',{attrs:{"id":"acceptedTerms"},model:{value:(_vm.acceptedTerms),callback:function ($$v) {_vm.acceptedTerms=$$v},expression:"acceptedTerms"}},[_vm._v("\n          I Agree\n        ")])],1),_vm._v(" "),_c('h2',[_vm._v("Privacy Policy Agreement")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("I have read and accept the "),_c('a',{attrs:{"href":"https://www.acm.org/about-acm/privacy-policy"}},[_vm._v("ACM Privacy Policy")])]),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4"},[_c('b-form-checkbox',{attrs:{"id":"acceptedPrivacy"},model:{value:(_vm.acceptedPrivacy),callback:function ($$v) {_vm.acceptedPrivacy=$$v},expression:"acceptedPrivacy"}},[_vm._v("\n          I Agree\n        ")])],1),_vm._v(" "),_c('h2',[_vm._v("Media Release Agreement")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("I agree permission for ACM/SIGGRAPH and its agents or employees to take and use photographs and/or video taken of me for use in promotional and educational electronic, video, and print materials for the SIGGRAPH organization.\n        Furthermore, I authorize the use of my name, likeness, and voice for all SIGGRAPH Conference and organization promotion deemed appropriate and necessary by ACM/SIGGRAPH.")]),_vm._v(" "),_c('p',[_vm._v("I hereby waive any right of privacy and the right to inspect or approve the finished photographs or video that may be used in conjunction with such use now or in the future, whether that use is known to me or unknown.\n        I also waive any right to royalties or other compensation arising from or related to the use of said photographs/video created for this purpose.")]),_vm._v(" "),_c('p',[_vm._v("I have read this release before accepting the conditions below, and I fully understand the contents, meaning, and impact of this release.\n        I understand that I am free to address any specific questions regarding this release by submitting those questions in writing prior to signing, and I agree that my failure to do so will be interpreted as a free and knowledgeable acceptance of the terms of this release.")]),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4"},[_c('b-form-checkbox',{attrs:{"id":"acceptedMediaRelease"},model:{value:(_vm.mediaReleaseAgreement),callback:function ($$v) {_vm.mediaReleaseAgreement=$$v},expression:"mediaReleaseAgreement"}},[_vm._v("I Agree")])],1),_vm._v(" "),(_vm.isValid&&!_vm.isOverWordCount)?_c('div',{staticStyle:{"border":"#FEE800 10px solid","background":"white","color":"black"}},[_c('h3',{staticStyle:{"color":"red","display":"inline"}},[_vm._v("Notice:")]),_c('h3',{staticStyle:{"display":"inline"}},[_vm._v(" Once you submit, you will no longer be able to edit or change your application.")])]):(!_vm.isOverWordCount)?_c('div',{staticStyle:{"border":"#FEE800 10px solid","background":"white","color":"black"}},[_c('h3',{staticStyle:{"margin-top":"8px"}},[_vm._v("Notice: You have some fields that need to be filled out before you can complete your application.")]),_vm._v(" "),_c('ul',_vm._l((_vm.invalidFields),function(invalid){return _c('li',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(invalid))])}),0)]):_c('div',{staticStyle:{"border":"#FEE800 10px solid","background":"white","color":"black"}},[_c('h3',{staticStyle:{"margin-top":"8px"}},[_vm._v("Notice: the following fields are over the word limit, adjust your responses in order to submit. ")]),_vm._v(" "),_c('ul',_vm._l((_vm.overWordCount),function(invalid){return _c('li',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(invalid))])}),0)]),_vm._v(" "),_c('b-form-group',[_c('button',{staticClass:"btn left-arrow-btn-primary btn-sm float-sm-left",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.previousStep}},[_vm._v("Previous Step")]),_vm._v(" "),_c('button',{staticClass:"btn arrow-btn-primary btn-sm float-sm-right",attrs:{"type":"submit","disabled":_vm.disabledFinish},on:{"click":_vm.nextStep}},[_vm._v("Save and Finish")])])],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SKpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authenticated"},[_c('div',{staticClass:"nav-bg container-fluid"},[_c('navigation')],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"application-content"},[(_vm.isError)?_c('alert',{attrs:{"type":"danger"}}):_vm._e(),_vm._v(" "),(_vm.isMessage)?_c('alert',{attrs:{"type":"primary"}}):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"gradient"},[_vm._v("Dashboard")]),_vm._v(" "),(_vm.isAdmin)?_c('adminDashboard'):_c('svDashboard')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TGvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("aEfQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48331a86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("SKpY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48331a86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TJmm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tz0+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SvAppStatus',
  data: function data() {
    return {};
  },

  methods: {
    goToConfirmationForm: function goToConfirmationForm(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/confirmation');
    },
    declineAcceptance: function declineAcceptance(e) {
      var _this = this;

      e.preventDefault();
      this.$store.dispatch('user/declineAcceptance').then(function () {
        // Reload application again to get the new status
        _this.$store.dispatch('application/load');
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isAfterConfirmationDeadline']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('application', ['isNewApp', 'isNotNewApp', 'isPending', 'isAccepted', 'isOffered', 'isDeclined']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('application', ['isLoaded', 'isLoading', 'completed']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['profile', 'isTeamLeader']), {
    TLName: function TLName() {
      if (this.profile.nickname === '') {
        return this.profile.firstName !== '' ? this.profile.firstName : 'Team Leader';
      } else {
        return this.profile.nickname;
      }
    },
    SVName: function SVName() {
      if (this.profile.nickname === '') {
        return this.profile.firstName !== '' ? this.profile.firstName : 'SV';
      } else {
        return this.profile.nickname;
      }
    }
  }),
  created: function created() {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load');
    }
    if (!this.$store.state.user.loadedAttributes) {
      this.$store.dispatch('user/loadAttributes');
    }
  }
});

/***/ }),

/***/ "U9sZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__ = __webpack_require__("NxiE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98cfec3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__ = __webpack_require__("+yEE");
function injectStyle (ssrContext) {
  __webpack_require__("N4Cn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98cfec3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UMBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Schedule")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"label":"Date","label-for":"date"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"date","options":_vm.days},model:{value:(_vm.selectedDay),callback:function ($$v) {_vm.selectedDay=$$v},expression:"selectedDay"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('b-form-group',{attrs:{"label":"Venue","label-for":"venue"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"id":"venue","options":_vm.venueSelect},model:{value:(_vm.selectedVenue),callback:function ($$v) {_vm.selectedVenue=$$v},expression:"selectedVenue"}})],1)],1)]),_vm._v(" "),(_vm.selectedDay === '2023-08-05')?_c('h2',[_vm._v("Saturday 05 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-06')?_c('h2',[_vm._v("Sunday 06 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-07')?_c('h2',[_vm._v("Monday 07 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-08')?_c('h2',[_vm._v("Tuesday 08 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-09')?_c('h2',[_vm._v("Wednesday 09 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.selectedDay === '2023-08-10')?_c('h2',[_vm._v("Thursday 10 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('div',[(_vm.dayVenues.length === 0 && _vm.selectedDay === '2023-08-05')?_c('h3',[_vm._v("No shifts for Saturday 05 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.dayVenues.length === 0 && _vm.selectedDay === '2023-08-06')?_c('h3',[_vm._v("No shifts for Sunday 06 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.dayVenues.length === 0 && _vm.selectedDay === '2023-08-07')?_c('h3',[_vm._v("No shifts for Monday 07 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.dayVenues.length === 0 && _vm.selectedDay === '2023-08-08')?_c('h3',[_vm._v("No shifts for Tuesday 08 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.dayVenues.length === 0 && _vm.selectedDay === '2023-08-09')?_c('h3',[_vm._v("No shifts for Wednesday 09 Aug 2023")]):_vm._e(),_vm._v(" "),(_vm.dayVenues.length === 0 && _vm.selectedDay === '2023-08-10')?_c('h3',[_vm._v("No shifts for Thursday 10 Aug 2023")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cd-schedule"},[_c('div',{staticClass:"events"},[_c('ul',_vm._l((_vm.dayVenues),function(venue){return _c('li',{key:venue.id,staticClass:"events-group",style:(_vm.getVenueWidth(_vm.dayVenues.length))},[_c('div',{staticClass:"top-info"},[_c('span',[_vm._v("\n                "+_vm._s(venue.name)+"\n                ")])]),_vm._v(" "),_c('ul',_vm._l((venue.shifts),function(shift){return _c('li',{key:shift.id,staticClass:"single-event",style:(_vm.getLocation(shift))},[_c('a',{attrs:{"href":'/schedule/shift/' + shift.id},on:{"click":function($event){$event.preventDefault();return _vm.goToShift(shift.id)}}},[_c('span',{staticClass:"event-day"},[_vm._v(_vm._s(_vm.formattedDay(shift.day)))]),_vm._v(" "),_c('em',{staticClass:"event-time"},[_vm._v(_vm._s(shift.start_time)+" - "+_vm._s(shift.end_time))]),_vm._v(" "),_c('p',{staticClass:"event-location"},[_vm._v(_vm._s(shift.venue.location))]),_vm._v(" "),_c('em',{staticClass:"event-notes"},[_vm._v(_vm._s(shift.special))])])])}),0)])}),0)])])]):_c('div',[_c('h2',[_vm._v("Loading Shifts...")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UZhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V0Xf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("i+MZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b0dee8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("K5SK");
function injectStyle (ssrContext) {
  __webpack_require__("FjnX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b0dee8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b0dee8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VjfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("Cbbb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af1d4b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("qDLF");
function injectStyle (ssrContext) {
  __webpack_require__("klTF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af1d4b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VugP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);




var schedule = {
  namespaced: true,
  state: {
    isLoaded: false,
    isLoading: false,
    shifts: [],
    shiftSwapRequestsLoaded: false,
    shiftSwapRequests: {
      createdRequests: [],
      assignedRequests: [],
      shiftRequests: [],
      openRequests: []
    },
    lastRefreshDate: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().format('YYYY-MM-DD hh:mm:ss')
  },
  mutations: {
    loading: function loading(state) {
      state.isLoading = true;
    },
    loadShifts: function loadShifts(state, shifts) {
      state.shifts = shifts;
      state.isLoaded = true;
      state.isLoading = false;
    },
    loadShiftSwapRequests: function loadShiftSwapRequests(state, requests) {
      state.shiftSwapRequests.createdRequests = requests.created_requests;
      state.shiftSwapRequests.assignedRequests = requests.assigned_requests;
      state.shiftSwapRequests.shiftRequests = requests.shift_requests;
      state.shiftSwapRequests.openRequests = requests.open_requests;
      state.shiftSwapRequestsLoaded = true;
    },
    clearSchedule: function clearSchedule(state) {
      state.isLoaded = false;
      state.isLoaded = false;
      state.isLoading = false;
      state.shifts = [];
      state.shiftSwapRequestsLoaded = false;
      state.shiftSwapRequests = {
        createdRequests: [],
        assignedRequests: [],
        shiftRequests: [],
        openRequests: []
      };
      state.lastRefreshDate = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().format('YYYY-MM-DD hh:mm:ss');
    }
  },
  getters: {
    nextShift: function nextShift(state) {
      return state.shifts.find(function (shift) {
        var start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles');
        if (__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isBefore(start)) {
          return true;
        }
        return false;
      });
    },
    nextShifts: function nextShifts(state) {
      var nextShift = state.shifts.find(function (shift) {
        var start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc();
        if (__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isBefore(start)) {
          return true;
        }
        return false;
      });
      if (nextShift !== undefined) {
        return state.shifts.filter(function (shift) {
          return shift.day === nextShift.day && shift.start_time === nextShift.start_time;
        });
      } else return [];
    },
    currentShifts: function currentShifts(state) {
      return state.shifts.filter(function (shift) {
        var start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc();
        var end = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc();
        if (__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isAfter(start) && __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isBefore(end)) {
          return true;
        }
        return false;
      });
    },
    isScheduled: function isScheduled(state) {
      return state.shifts.length > 0;
    },
    getShift: function getShift(state) {
      return function (id) {
        return state.shifts.find(function (shift) {
          return shift.id === parseInt(id);
        });
      };
    },
    hasCreatedRequests: function hasCreatedRequests(state) {
      return state.shiftSwapRequests.createdRequests.length > 0;
    },
    hasAssignedRequests: function hasAssignedRequests(state) {
      return state.shiftSwapRequests.assignedRequests.length > 0;
    },
    hasShiftRequests: function hasShiftRequests(state) {
      return state.shiftSwapRequests.shiftRequests.length > 0;
    },
    hasOpenRequests: function hasOpenRequests(state) {
      return state.shiftSwapRequests.openRequests.length > 0;
    },
    getQualifyingOpenRequests: function getQualifyingOpenRequests(state, getters, rootState) {
      return state.shiftSwapRequests.openRequests.filter(function (request) {
        // No requests made by this user
        var isCreator = request.student_volunteer.username === rootState.user.username;

        // No requests for shifts that conflict
        var start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(request.shift.day).utc().format('Y-MM-DD') + ' ' + request.shift.start_time, 'America/Los_Angeles').utc();
        var end = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(request.shift.day).utc().format('Y-MM-DD') + ' ' + request.shift.end_time, 'America/Los_Angeles').utc();
        var overlap = state.shifts.find(function (shift) {
          var shiftStart = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc();
          var shiftEnd = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc();
          if (start.isBefore(shiftStart) && end.isAfter(shiftStart)) {
            return true;
          }
          if (start.isAfter(shiftStart) && start.isBefore(shiftEnd)) {
            return true;
          }
          return false;
        });

        // No shifts from the past
        var inPast = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isAfter(start);
        if (isCreator || overlap !== undefined || inPast) {
          return false;
        }
        return true;
      });
    },
    qualifyingShiftRequests: function qualifyingShiftRequests(state, getters, rootState) {
      return state.shiftSwapRequests.shiftRequests.filter(function (request) {
        // No requests for shifts that conflict
        var start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(request.swapped_shift.day).utc().format('Y-MM-DD') + ' ' + request.swapped_shift.start_time, 'America/Los_Angeles').utc();
        var end = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(request.swapped_shift.day).utc().format('Y-MM-DD') + ' ' + request.swapped_shift.end_time, 'America/Los_Angeles').utc();
        var overlap = state.shifts.find(function (shift) {
          var shiftStart = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc();
          var shiftEnd = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc();
          if (start.isBefore(shiftStart) && end.isAfter(shiftStart)) {
            return true;
          }
          if (start.isAfter(shiftStart) && start.isBefore(shiftEnd)) {
            return true;
          }
          return false;
        });

        // No shifts from the past
        var inPast = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isAfter(start) || __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(request.shift.day).utc().format('Y-MM-DD') + ' ' + request.shift.start_time, 'America/Los_Angeles').utc());
        if (overlap !== undefined || inPast) {
          return false;
        }
        return true;
      });
    }
  },
  actions: {
    load: function load(_ref) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('loading');
        if (rootState.user.isTeamLeader) {
          fetch('https://api.siggraphsv.org/' + 'schedule/tl/' + rootState.user.profile.id, {
            headers: {
              'Authorization': rootState.user.session.accessToken
            }
          }).then(function (response) {
            return response.json().then(function (payload) {
              if (payload.success) {
                commit('loadShifts', payload.data.shifts);
                resolve();
              } else {
                commit('error', payload.data, { root: true });
                resolve();
              }
            });
          }).catch(function (err) {
            commit('error', { message: err.message }, { root: true });
            reject(err);
          });
        } else {
          fetch('https://api.siggraphsv.org/' + 'schedule/' + rootState.user.profile.id, {
            headers: {
              'Authorization': rootState.user.session.accessToken
            }
          }).then(function (response) {
            return response.json().then(function (payload) {
              if (payload.success) {
                commit('loadShifts', payload.data.shifts);
                resolve();
              } else {
                commit('error', payload.err, { root: true });
                resolve();
              }
            });
          }).catch(function (err) {
            commit('error', { message: err.message }, { root: true });
            reject(err);
          });
        }
      });
    },
    savePerformanceRecords: function savePerformanceRecords(_ref2, records) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState,
          dispatch = _ref2.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // commit('savingPerformanceRecords')
        var performanceRecords = records.map(function (r) {
          return {
            id: r.id,
            shift_id: r.shift_id,
            student_volunteer_id: r.student_volunteer_id,
            check_in: r.check_in === null ? false : r.check_in,
            check_out: r.check_out === null ? false : r.check_out,
            rating: r.rating === null ? 0 : r.rating,
            notes: r.notes === null ? '' : r.notes
          };
        });
        console.log(performanceRecords);
        fetch('https://api.siggraphsv.org/' + 'schedule/pr', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ performance_records: performanceRecords })
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              dispatch('load').then(function () {
                resolve();
              });
            } else {
              console.log(payload);
              commit('error', payload.data, { root: true });
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    loadShiftSwapRequests: function loadShiftSwapRequests(_ref3) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'schedule/swap/' + rootState.user.username, {
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          }
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              commit('loadShiftSwapRequests', payload.data);
              resolve();
            } else {
              commit('error', payload.data, { root: true });
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    getShiftsByDay: function getShiftsByDay(_ref4, day) {
      var commit = _ref4.commit,
          rootState = _ref4.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'schedule/shifts/' + day, {
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          }
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              resolve(payload.data.shifts);
            } else {
              commit('error', payload.data, { root: true });
              reject(payload.data);
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    createRequest: function createRequest(_ref5, request) {
      var commit = _ref5.commit,
          rootState = _ref5.rootState,
          dispatch = _ref5.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        request.svid = rootState.user.username;
        fetch('https://api.siggraphsv.org/' + 'schedule/swap/create', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(request)
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              dispatch('loadShiftSwapRequests').then(function () {
                commit('message', { message: 'Successfully created shift swap request.' }, { root: true });
                resolve();
              });
            } else {
              commit('error', payload.data, { root: true });
              reject(payload.data);
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    acceptRequest: function acceptRequest(_ref6, request) {
      var commit = _ref6.commit,
          rootState = _ref6.rootState,
          dispatch = _ref6.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        request.svid = rootState.user.username;
        fetch('https://api.siggraphsv.org/' + 'schedule/swap/accept', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(request)
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              dispatch('loadShiftSwapRequests').then(function () {
                dispatch('load').then(function () {
                  commit('message', { message: 'Successfully accepted shift swap request. Please check your schedule for updates.' }, { root: true });
                  resolve();
                });
              });
            } else {
              commit('error', payload.data, { root: true });
              reject(payload.data);
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    deleteRequest: function deleteRequest(_ref7, id) {
      var commit = _ref7.commit,
          rootState = _ref7.rootState,
          dispatch = _ref7.dispatch;

      console.log(id);
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'schedule/swap/delete', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken.jwtToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ shift_swap_request_id: id })
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              dispatch('loadShiftSwapRequests').then(function () {
                commit('message', { message: 'Successfully deleted shift swap request.' }, { root: true });
                resolve();
              });
            } else {
              commit('error', payload.data, { root: true });
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (schedule);

/***/ }),

/***/ "W55A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"size":"small","variant":"primary"},on:{"click":_vm.goBack}},[_vm._v("Back to Schedule")]),_vm._v(" "),_c('h1',[_vm._v("Request Shift Swap")]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.isLoaded)?_c('div',{staticClass:"col"},[_c('h3',[_vm._v(_vm._s(_vm.shift.venue.name))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.formattedDay(_vm.shift.day))),_c('br'),_vm._v(_vm._s(_vm.shift.start_time)+" - "+_vm._s(_vm.shift.end_time))]),_vm._v(" "),_c('hr')]):_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Loading Schedule...")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('h3',[_vm._v("Select a Day")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Select a day to pick a shift to swap for.","label-for":"date"}},[_c('b-form-select',{attrs:{"id":"date","options":_vm.days},model:{value:(_vm.selectedDay),callback:function ($$v) {_vm.selectedDay=$$v},expression:"selectedDay"}}),_vm._v(" "),_c('b-button',{attrs:{"variant":"secondary","disabled":_vm.selectedDay === 'none'},on:{"click":_vm.getShifts}},[_vm._v("Select")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('h3',[_vm._v("Select a Venue")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Select which venue to choose from.","label-for":"venue"}},[_c('b-form-select',{attrs:{"id":"venue","disabled":!_vm.shiftsLoaded,"options":_vm.venues},model:{value:(_vm.selectedVenue),callback:function ($$v) {_vm.selectedVenue=$$v},expression:"selectedVenue"}})],1)],1)])])]),_vm._v(" "),(_vm.loadingShifts)?_c('h3',[_vm._v("Searching for shifts...")]):_vm._e(),_vm._v(" "),(_vm.selectedVenue !== 'none')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Select a Shift")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","showEmpty":_vm.qualifyingShifts.length === 0,"fields":_vm.shiftFields,"items":_vm.qualifyingShifts},scopedSlots:_vm._u([{key:"day",fn:function(data){return [_vm._v("\n          "+_vm._s(_vm.formattedDay(data.item.day))+"\n        ")]}},{key:"start_time",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.start_time)+"\n        ")]}},{key:"end_time",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.end_time)+"\n        ")]}},{key:"venue",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.venue.name)+"\n          ")]}},{key:"select",fn:function(row){return [(_vm.isCreating === null)?_c('b-button',{staticClass:"mb-2",attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.createRequest(row.item.id, null)}}},[_vm._v("Swap")]):_vm._e(),_vm._v(" "),(_vm.isCreating === row.item.id)?_c('b-button',{staticClass:"mb-2",attrs:{"disabled":"","variant":"secondary"}},[_vm._v("Creating Swap Request...")]):_vm._e()]}}],null,false,4176767571)},[_c('template',{slot:"empty"},[_vm._v("\n          Unable to find shifts that fit your schedule.\n        ")])],2)],1),_vm._v(" "),_c('b-modal',{ref:"createModal",attrs:{"id":"create-modal","title":"Confirm Request"},on:{"ok":_vm.confirmCreateRequest}},[_c('p',[_vm._v("Are you sure you want to swap?"),_c('br'),_vm._v("Your dashboard will notify you when your request is accepted or declined.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Your Shift")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.shift.venue.name))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.formattedDay(_vm.shift.day))),_c('br'),_vm._v(_vm._s(_vm.shift.start_time)+" - "+_vm._s(_vm.shift.end_time))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Selected Shift")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.selectedShift.venue.name))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.formattedDay(_vm.selectedShift.day))),_c('br'),_vm._v(_vm._s(_vm.selectedShift.start_time)+" - "+_vm._s(_vm.selectedShift.end_time))])])]),_vm._v(" "),(_vm.selectedVolunteer.id !== null)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Selected Student Volunteer")]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.formatName(_vm.selectedVolunteer)))])])]):_vm._e()])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WSyM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WzCT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XWIh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumb}}),_vm._v(" "),_c('h1',[_vm._v("Jury Assignments")]),_vm._v(" "),_c('h2',[_vm._v("Assign New Jury")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_vm._v("Use this to automatically assign completed SV applications to Team Leaders.\n        Once assignments are made, Team Leaders will be able to review applications\n        assigned to them.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('b-form',{attrs:{"inline":""}},[_c('b-form-group',{attrs:{"label":"Team Leaders Per SV App","description":_vm.assignmentsPerTL}},[_c('b-input',{attrs:{"type":"number","id":"apps-per-tl"},model:{value:(_vm.TLsPerSVApp),callback:function ($$v) {_vm.TLsPerSVApp=$$v},expression:"TLsPerSVApp"}}),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.assignModal",modifiers:{"assignModal":true}}],attrs:{"disabled":_vm.isAssigning,"variant":"primary"}},[_vm._v("Assign")]),_vm._v(" "),(_vm.isAssigning)?_c('div',{staticClass:"loader"},[_vm._v("Assigning...")]):_vm._e()],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"assignModal",attrs:{"id":"assignModal","title":"Assign Jury"},on:{"ok":_vm.assignJury}},[_c('p',[_vm._v("This process takes several minutes.")]),_vm._v(" "),_c('p',{staticClass:"my-4"},[_c('strong',[_vm._v("Warning")]),_vm._v(": This will reset assignments and any scoring data will be lost.")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Do not use this if you do not want to lose existing assignment and scoring data.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YETc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTwo_vue__ = __webpack_require__("KGNE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2637421e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTwo_vue__ = __webpack_require__("01PZ");
function injectStyle (ssrContext) {
  __webpack_require__("UZhx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTwo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2637421e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTwo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YYjt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__("uL8o");

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainAdmin',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['isAdmin'])),
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_3__components_Nav__["a" /* default */]
  }
});

/***/ }),

/***/ "YZsC":
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"}}}}},"shapes":{"Sa":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sf":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard__ = __webpack_require__("TGvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Countdown__ = __webpack_require__("KgB8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_Login__ = __webpack_require__("KQvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_user_Profile__ = __webpack_require__("ylCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Confirmation__ = __webpack_require__("U9sZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_application_Application__ = __webpack_require__("dsoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_application_StepOne__ = __webpack_require__("HWsJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_application_StepTwo__ = __webpack_require__("YETc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_application_StepThree__ = __webpack_require__("6RXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_application_StepFour__ = __webpack_require__("4zQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_application_ThankYou__ = __webpack_require__("eJlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_MainAdmin__ = __webpack_require__("IFye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_admin_Search__ = __webpack_require__("oQUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_SearchAppStatus__ = __webpack_require__("8nFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_ViewApp__ = __webpack_require__("7dMY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_JuryAssignments__ = __webpack_require__("QiJN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_jury_Jury__ = __webpack_require__("dCCI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_jury_ListJuryApplications__ = __webpack_require__("gW13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_schedule_Schedule__ = __webpack_require__("oglw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_schedule_SvSchedule__ = __webpack_require__("P0Wh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_schedule_TlSchedule__ = __webpack_require__("xCnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_schedule_Shift__ = __webpack_require__("AGrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_schedule_CreateShiftSwapRequest__ = __webpack_require__("FV1z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_schedule_ListShiftSwapRequests__ = __webpack_require__("0l+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment__);







// import Support from '@/components/Support'























var jwtDecode = __webpack_require__("ytdl");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
    beforeEnter: checkNotAuth
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard__["a" /* default */],
    beforeEnter: checkAuth
  }, {
    path: '/countdown',
    name: 'Countdown',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Countdown__["a" /* default */],
    beforeEnter: checkNotAuth
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_user_Login__["a" /* default */],
    beforeEnter: checkNotAuth
  }, {
    path: '/forgot-password',
    redirect: function redirect(to) {
      console.log(to);
      if (to.query.token === undefined) {
        __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('error', { message: 'Invalid password reset token' });
        return { name: 'Home' };
      }
      var token = to.query.token;
      console.log(token);
      var decoded = jwtDecode(token);
      var exp = __WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(decoded.exp);
      if (__WEBPACK_IMPORTED_MODULE_28_moment___default()().isAfter(exp)) {
        __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('error', { message: 'Token has expired' });
        return '/';
      }
      if (decoded.token_use !== 'password-reset') {
        __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('error', { message: 'Token is not valid' });
        return '/';
      }
      __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('user/setForgottenPasswordToken', token);
      return '/';
    }
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_6__components_user_Profile__["a" /* default */],
    beforeEnter: checkAuth
  },
  // {
  //   path: '/support',
  //   name: 'Support',
  //   component: Support,
  //   beforeEnter: checkAuth
  // },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Confirmation__["a" /* default */]
    // beforeEnter: checkAuth
  }, {
    path: '/application',
    name: 'Application',
    component: __WEBPACK_IMPORTED_MODULE_8__components_application_Application__["a" /* default */],
    beforeEnter: checkAuth,
    children: [{
      path: '1',
      name: 'stepOne',
      component: __WEBPACK_IMPORTED_MODULE_9__components_application_StepOne__["a" /* default */]
    }, {
      path: '2',
      name: 'stepTwo',
      component: __WEBPACK_IMPORTED_MODULE_10__components_application_StepTwo__["a" /* default */]
    }, {
      path: '3',
      name: 'stepThree',
      component: __WEBPACK_IMPORTED_MODULE_11__components_application_StepThree__["a" /* default */]
    }, {
      path: '4',
      name: 'stepFour',
      component: __WEBPACK_IMPORTED_MODULE_12__components_application_StepFour__["a" /* default */]
    }, {
      path: 'thank-you',
      name: 'thankYou',
      component: __WEBPACK_IMPORTED_MODULE_13__components_application_ThankYou__["a" /* default */]
    }]
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_14__components_admin_MainAdmin__["a" /* default */],
    beforeEnter: checkAuth,
    children: [{
      path: 'application/search',
      name: 'SearchApps',
      component: __WEBPACK_IMPORTED_MODULE_15__components_admin_Search__["a" /* default */]
    }, {
      path: 'application/search-status',
      name: 'SearchAppsByStatus',
      component: __WEBPACK_IMPORTED_MODULE_16__components_admin_SearchAppStatus__["a" /* default */]
    }, {
      path: 'application/:username',
      name: 'ViewApp',
      component: __WEBPACK_IMPORTED_MODULE_17__components_admin_ViewApp__["a" /* default */],
      props: true
    }, {
      path: 'jury/assignments',
      name: 'JuryAssignments',
      component: __WEBPACK_IMPORTED_MODULE_18__components_admin_JuryAssignments__["a" /* default */]
    }]
  }, {
    path: '/jury',
    name: 'Jury',
    component: __WEBPACK_IMPORTED_MODULE_19__components_jury_Jury__["a" /* default */],
    beforeEnter: checkAuth,
    children: [{
      path: 'view',
      name: 'ListJuryApplications',
      component: __WEBPACK_IMPORTED_MODULE_20__components_jury_ListJuryApplications__["a" /* default */]
    }]
  }, {
    path: '/schedule',
    name: 'Schedule',
    component: __WEBPACK_IMPORTED_MODULE_21__components_schedule_Schedule__["a" /* default */],
    beforeEnter: checkAuth,
    children: [{
      path: 'sv',
      name: 'SvSchedule',
      component: __WEBPACK_IMPORTED_MODULE_22__components_schedule_SvSchedule__["a" /* default */]
    }, {
      path: 'tl',
      name: 'TlSchedule',
      component: __WEBPACK_IMPORTED_MODULE_23__components_schedule_TlSchedule__["a" /* default */]
    }, {
      path: 'shift/:id',
      name: 'Shift',
      component: __WEBPACK_IMPORTED_MODULE_24__components_schedule_Shift__["a" /* default */],
      props: true
    }, {
      path: 'swap/list',
      name: 'ShiftSwapRequests',
      component: __WEBPACK_IMPORTED_MODULE_26__components_schedule_ListShiftSwapRequests__["a" /* default */]
    }, {
      path: 'swap/:id/create',
      name: 'CreateShiftSwapRequest',
      component: __WEBPACK_IMPORTED_MODULE_25__components_schedule_CreateShiftSwapRequest__["a" /* default */],
      props: true
    }]
  }]
}));

function checkAuth(to, from, next) {
  // Clear any error or messages when navigating to another page
  __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('clearError');
  __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('clearMessage');
  var token = localStorage.getItem('accessToken');
  if (__WEBPACK_IMPORTED_MODULE_28_moment___default()(__WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].state.applicationLaunchDate).diff(__WEBPACK_IMPORTED_MODULE_28_moment___default()()) > 0 && to.path !== '/') {
    console.log('not yet');
    __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].dispatch('user/logout');
    next('/'); // it's not time for applications yet
  } else if (token != null) {
    var decoded = jwtDecode(token);
    var exp = __WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(decoded.exp);
    if (__WEBPACK_IMPORTED_MODULE_28_moment___default()().isAfter(exp)) {
      __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].dispatch('user/logout');
      next('/');
    } else {
      if (__WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].state.user.session.accessToken == null) {
        __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('user/setSession', token);
      }
      if (!__WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].state.user.loadedAttributes) {
        __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].dispatch('user/loadAttributes').then(function () {
          next(); // they are authorized
        }).catch(function (err) {
          // Something went wrong with loading the user's attributes
          console.log(err);
          next();
        });
      } else {
        next();
      }
    }
  } else {
    next('/');
  }
}

function checkNotAuth(to, from, next) {
  // Clear any error or messages when navigating to another page
  __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('clearError');
  __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].commit('clearMessage');
  var token = localStorage.getItem('accessToken');

  if (__WEBPACK_IMPORTED_MODULE_28_moment___default()(__WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].state.applicationLaunchDate).diff(__WEBPACK_IMPORTED_MODULE_28_moment___default()()) > 0 && to.path !== '/') {
    next('/');
  } else if (token != null) {
    var decoded = jwtDecode(token);
    var exp = __WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(decoded.exp);
    if (__WEBPACK_IMPORTED_MODULE_28_moment___default()().isAfter(exp)) {
      __WEBPACK_IMPORTED_MODULE_27__store__["a" /* default */].dispatch('user/logout');
      next();
    } else {
      next('/dashboard'); // they are authorized, so redirect to dashboard
    }
  } else {
    next();
  }
}

/***/ }),

/***/ "ZkVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a0rH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__("uL8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__ = __webpack_require__("rydV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var generateProfileVuexSetters = function generateProfileVuexSetters(fields) {
  var computed = {};
  fields.forEach(function (field) {
    computed[field] = {
      get: function get() {
        return this.$store.state.user.profile[field];
      },
      set: function set(value) {
        this.$store.commit('user/updateProfile', { name: field, value: value });
      }
    };
  });
  return computed;
};

var generateAddressVuexSetters = function generateAddressVuexSetters(fields) {
  var computed = {};
  fields.forEach(function (field) {
    computed[field] = {
      get: function get() {
        return this.$store.state.user.profile.address[field];
      },
      set: function set(value) {
        this.$store.commit('user/updateProfileAddress', { name: field, value: value });
      }
    };
  });
  return computed;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  data: function data() {
    return {
      titles: __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["o" /* titles */],
      suffixes: __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["m" /* suffixes */],
      countries: __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["b" /* countries */],
      languageList: __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["e" /* languageList */],
      disabled: false,
      genderOptions: __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["d" /* genderList */],
      raceOptions: __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["p" /* underrepresentedList */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, generateProfileVuexSetters(['firstName', 'lastName', 'nickname', 'birthdate', 'phoneNumber', 'canText', 'canCall', 'email', 'gender', 'genderIdentity', 'underrepresented', 'underrepresentedGroup', 'disability', 'disabilityType']), generateAddressVuexSetters(['address1', 'address2', 'city', 'region', 'country', 'postalCode']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['getLanguages']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['profile']), {
    isGenderOther: function isGenderOther() {
      return this.gender && this.gender.includes('other');
    },
    isUnderrepresentedOther: function isUnderrepresentedOther() {
      return this.underrepresented && this.underrepresented.includes('other');
    }
  }),
  methods: {
    updateProfile: function updateProfile(e) {
      var _this = this;

      e.preventDefault();
      if (!this.profile.birthdate || !this.profile.firstName || !this.profile.lastName || this.profile.gender.length <= 0 || this.profile.underrepresented.length <= 0 || !this.profile.disability || !this.profile.phoneNumber || !this.profile.address.address1 || !this.profile.address.city || !this.profile.address.region || !this.profile.address.country || !this.profile.address.postalCode) {
        console.log(this.profile);
        this.$store.commit('error', { message: 'Please fill in all required fields' });
        window.scrollTo(0, 0);
      } else {
        this.disabled = true;
        this.$store.dispatch('user/saveAttributes').then(function () {
          _this.disabled = false;
          __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/');
        }).catch(function () {
          _this.disabled = false;
        });
      }
    },
    updateLanguages: function updateLanguages(value) {
      this.$store.commit('user/updateProfile', { name: 'languages', value: value });
    },
    backHome: function backHome(e) {
      e.preventDefault();
      this.disabled = true;
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/');
    }
  },
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_3__components_Nav__["a" /* default */],
    multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  created: function created() {
    if (!this.$store.state.user.loadedAttributes) {
      this.$store.dispatch('user/loadAttributes');
    }
  }
});

/***/ }),

/***/ "a6CN":
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),

/***/ "aEfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__("uL8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SvDashboard__ = __webpack_require__("7HzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard__ = __webpack_require__("V0Xf");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  data: function data() {
    return {
      appBtnDisabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['isAdmin'])),
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_3__components_Nav__["a" /* default */],
    svDashboard: __WEBPACK_IMPORTED_MODULE_4__components_SvDashboard__["a" /* default */],
    adminDashboard: __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard__["a" /* default */]
  }
});

/***/ }),

/***/ "ayWp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bK1N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__("uL8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Shift',
  props: ['id'],
  data: function data() {
    return {
      ratings: [{ value: 0, text: 'Select' }, { value: 1, text: '1' }, { value: 2, text: '2' }, { value: 3, text: '3' }, { value: 4, text: '4' }, { value: 5, text: '5' }],
      fields: [{ key: 'name', sortable: true, label: 'Name' }, { key: 'check_in', label: 'Check In' }, { key: 'check_out', label: 'Check Out' }, { key: 'rating', label: 'Rating' }, { key: 'notes', label: 'Notes' }],
      svs: [],
      isSaving: false
    };
  },

  methods: {
    goBack: function goBack() {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/schedule/tl');
    },
    formattedDay: function formattedDay(day) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(day).utc().format('ddd MMM Do');
    },
    getSvs: function getSvs() {
      var _this = this;

      return this.shift.studentVolunteers.map(function (sv) {
        var name = sv.given_name + ' ' + sv.family_name;
        if (sv.nickname && sv.nickname !== '' && sv.given_name !== sv.nickname) {
          name = sv.given_name + ' "' + sv.nickname + '" ' + sv.family_name;
        }
        var record = {
          id: sv.performance_record.id,
          shift_id: _this.id,
          student_volunteer_id: sv.id,
          name: name,
          check_in: sv.performance_record.check_in,
          check_out: sv.performance_record.check_out,
          rating: sv.performance_record.rating === null ? 0 : sv.performance_record.rating,
          notes: sv.performance_record.notes,
          start_back_to_back: sv.start_back_to_back,
          end_back_to_back: sv.end_back_to_back
        };
        if (sv.performance_record.notes !== '' && sv.performance_record.notes !== null) {
          record._showDetails = true;
        }
        return record;
      });
    },
    savePerformanceRecords: function savePerformanceRecords() {
      var _this2 = this;

      this.isSaving = true;
      this.$store.dispatch('schedule/savePerformanceRecords', this.svs).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/schedule/tl');
      }).catch(function (err) {
        console.log(err);
        _this2.isSaving = false;
      });
    },
    refreshPage: function refreshPage() {
      location.reload();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('schedule', ['shifts', 'isLoaded', 'lastRefreshDate']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['isTeamLeader']), {
    shift: function shift() {
      var _this3 = this;

      var shift = this.shifts.find(function (s) {
        return s.id === parseInt(_this3.id);
      });
      return shift;
    }
  }),
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_3__components_Nav__["a" /* default */]
  },
  created: function created() {
    var _this4 = this;

    if (!this.$store.state.schedule.isLoaded) {
      this.$store.dispatch('schedule/load').then(function () {
        _this4.svs = _this4.getSvs();
      });
    } else {
      this.svs = this.getSvs();
    }
  }
});

/***/ }),

/***/ "bT2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_SelectLists__ = __webpack_require__("rydV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ViewApp',
  props: ['username'],
  data: function data() {
    return {
      isLoading: true,
      statusOptions: __WEBPACK_IMPORTED_MODULE_2__util_SelectLists__["l" /* statuses */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    statusId: {
      get: function get() {
        return this.$store.state.admin.activeApp.statusId;
      },
      set: function set(value) {
        this.$store.commit('admin/updateProcessingStatus', value);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('admin', ['activeApp']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('admin', ['appFullName', 'appExpectedGraduation', 'appYearsVolunteered', 'appYearsVolunteeredAsia', 'appFinancialAidAndFlying', 'appProofOfEnrollmentIsLoaded', 'appProofOfEnrollmentIsPDF', 'appProofOfEnrollmentIsImage'])),
  methods: {
    updateProcessingStatus: function updateProcessingStatus(e) {
      this.$store.dispatch('admin/updateProcessingStatus');
    }
  },
  created: function created() {
    var _this = this;

    if (!this.$store.state.admin.activeApp.isLoaded) {
      this.$store.dispatch('admin/getApp', this.username).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    } else if (this.username !== this.$store.state.admin.activeApp.username) {
      this.isLoading = true;
      this.$store.commit('admin/deactivateApp');
      this.$store.dispatch('admin/getApp', this.username).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    } else {
      this.isLoading = false;
    }
  }
});

/***/ }),

/***/ "cEA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header-tag":"header"}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Jury")]),_vm._v(" "),(!_vm.isLoadingList)?_c('div',{staticClass:"card-text"},[_c('p',[_vm._v("We need your help to jury the SV applications.\n      "),_c('br'),_vm._v("All applications must be juried by "),_c('strong',[_vm._v(_vm._s(_vm.juryDeadlineFormat)+".")])]),_vm._v(" "),_c('p',[_vm._v("You've been assigned "+_vm._s(_vm.assignments.length)+" applications to score.")]),_vm._v(" "),_c('p',[_vm._v("You've scored "+_vm._s(_vm.assignmentsScored.length)+" applications.")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'ListJuryApplications'}}},[_c('button',{staticClass:"btn arrow-btn-primary btn-lg btn-black",attrs:{"type":"button"}},[_vm._v("View Applications")])])],1):_c('span',[_vm._v("Loading")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d6M3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumb}}),_vm._v(" "),_c('h1',[_vm._v("Search Applications")]),_vm._v(" "),_c('b-form',{attrs:{"inline":""},on:{"submit":function($event){$event.preventDefault();return _vm.searchApps($event)}}},[_c('b-form-group',{attrs:{"label":"Select Search Criteria"}},[_c('b-form-select',{model:{value:(_vm.filterType),callback:function ($$v) {_vm.filterType=$$v},expression:"filterType"}},[_c('option',{attrs:{"value":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('option',{attrs:{"value":"firstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('option',{attrs:{"value":"lastName"}},[_vm._v("Last Name")])]),_vm._v(" "),_c('b-input',{attrs:{"id":"filter-input","placeholder":"search"},model:{value:(_vm.filterInput),callback:function ($$v) {_vm.filterInput=$$v},expression:"filterInput"}}),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.isSearching,"variant":"primary"},on:{"click":_vm.searchApps}},[_vm._v("Search")]),_vm._v(" "),(_vm.isSearching)?_c('div',{staticClass:"loader"},[_vm._v("Loading...")]):_vm._e()],1)],1),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.filteredApps},scopedSlots:_vm._u([{key:"completed",fn:function(data){return [(data.item.completed)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"})]}},{key:"teamLeader",fn:function(data){return [(data.item.teamLeader)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"})]}},{key:"financialAid",fn:function(data){return [(data.item.financialAid)?_c('i',{staticClass:"icon ion-checkmark"}):_c('i',{staticClass:"icon ion-close"})]}},{key:"view",fn:function(data){return [_c('router-link',{attrs:{"to":{ name: 'ViewApp', params: { username: data.item.username } }}},[_vm._v("\n        View App\n      ")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dCCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jury_vue__ = __webpack_require__("viJp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ceda90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jury_vue__ = __webpack_require__("60s+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jury_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ceda90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jury_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dadx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ThankYou',
  data: function data() {
    return {};
  },

  created: function created() {
    var _this = this;

    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(function () {
        if (!_this.$store.state.application.completed) {
          __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/application/' + _this.$store.state.application.step.toString());
        }
      });
    }
  }
});

/***/ }),

/***/ "dsoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Application_vue__ = __webpack_require__("91so");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c60bdd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Application_vue__ = __webpack_require__("OpFN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Application_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c60bdd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Application_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eELq":
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory"},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild"},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM"},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing"},"costexplorer":{"prefix":"ce","name":"CostExplorer"},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData"},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend"},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia"},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia"},"kinesisvideo":{"name":"KinesisVideo"},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate"},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups"},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"}}

/***/ }),

/***/ "eJlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThankYou_vue__ = __webpack_require__("dadx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ca3060_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThankYou_vue__ = __webpack_require__("iXcY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThankYou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ca3060_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThankYou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eYOA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiveAppStatus_vue__ = __webpack_require__("ud4Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f6f8a7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiveAppStatus_vue__ = __webpack_require__("gFZZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiveAppStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f6f8a7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiveAppStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f4ek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchApps',
  data: function data() {
    return {
      breadcrumb: [{
        text: 'Dashboard',
        to: { name: 'Home' }
      }, {
        text: 'Search Apps by User',
        to: { name: 'SearchApps' }
      }],
      fields: ['firstName', 'lastName', 'email', 'svId', 'completed', 'teamLeader', 'financialAid', 'view'],
      filterType: 'email',
      filterInput: '',
      isSearching: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('admin', ['filteredApps'])),
  methods: {
    searchApps: function searchApps(e) {
      var _this = this;

      this.isSearching = true;
      this.$store.dispatch('admin/searchApplications', {
        filterType: this.filterType,
        filterInput: this.filterInput
      }).then(function () {
        _this.isSearching = false;
      }).catch(function (err) {
        console.log(err);
        _this.isSearching = false;
      });
    }
  }
});

/***/ }),

/***/ "gFZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header-tag":"header"}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Application")]),_vm._v(" "),(_vm.isLoading)?_c('h3',[_vm._v("Getting your application...")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('div',{staticClass:"card-text"},[(_vm.isNewApp && !_vm.profileIncomplete && !_vm.completed)?_c('h5',[_vm._v("Welcome! Let's get started.")]):_vm._e(),_vm._v(" "),(_vm.isNewApp && _vm.profileIncomplete)?_c('h5',[_vm._v("Welcome! Fill out your profile so we can start your application")]):_vm._e(),_vm._v(" "),(_vm.completed)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"mb-2"},[_vm._v("Thank You For Applying!")]),_vm._v(" "),_c('p',[_vm._v("You have successfully applied to the SIGGRAPH Student Volunteer Program.")]),_vm._v(" "),_c('p',[_vm._v("To ensure accurate registration, make sure "),_c('router-link',{attrs:{"to":"/profile"}},[_vm._v("your profile")]),_vm._v(" is kept up to date.")],1),_vm._v(" "),_c('h3',[_vm._v("Notification of Acceptance")]),_vm._v(" "),_c('p',[_vm._v("The first group of accepted applications will be sent in late April 2024. Be sure to check your spam settings to ensure you a receiving emails from us.")])])]):_c('div',[(_vm.isNotNewApp)?_c('h5',[_vm._v("Application in Progress")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.isNotNewApp)?_c('b-progress',{staticClass:"mb-2",attrs:{"height":"2rem","value":_vm.getProgress,"show-progress":""}}):_vm._e(),_vm._v(" "),(_vm.isNotNewApp)?_c('button',{staticClass:"btn arrow-btn-primary btn-lg btn-black",attrs:{"type":"button"},on:{"click":_vm.goToApp}},[_vm._v("Continue Application")]):_vm._e(),_vm._v(" "),(_vm.isNewApp && !_vm.profileIncomplete)?_c('button',{staticClass:"btn arrow-btn-primary btn-lg btn-black",attrs:{"type":"button"},on:{"click":_vm.goToApp}},[_vm._v("Start Application")]):_vm._e(),_vm._v(" "),(_vm.isNewApp && _vm.profileIncomplete)?_c('button',{staticClass:"btn arrow-btn-primary btn-lg btn-black",attrs:{"type":"button"},on:{"click":_vm.goToProfile}},[_vm._v("Update Profile")]):_vm._e()],1)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gUjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppStepFour',
  data: function data() {
    return {
      disabled: false,
      acceptedTerms: false,
      acceptedPrivacy: false,
      mediaReleaseAgreement: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('application', ['isValid', 'invalidFields', 'isOverWordCount', 'overWordCount']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])('application', ['isLoaded', 'isLoading']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['applicationTlEndDate', 'applicationEndDate']), {
    disabledFinish: function disabledFinish() {
      return !this.acceptedTerms || !this.mediaReleaseAgreement || !this.isValid || !this.acceptedPrivacy || this.isOverWordCount;
    }
  }),
  methods: {
    formattedDate: function formattedDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).tz('UTC').format('D MMMM YYYY');
    },
    nextStep: function nextStep(e) {
      var _this = this;

      e.preventDefault();
      this.disabled = true;
      if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
      } else {
        this.$store.dispatch('application/finish').then(function () {
          _this.disabled = false;
        });
      }
    },
    previousStep: function previousStep(e) {
      var _this2 = this;

      e.preventDefault();
      this.disabled = true;
      if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
      } else {
        this.$store.commit('application/updateStep', 3);
        this.$store.dispatch('application/save').then(function () {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'stepThree' });
          _this2.disabled = false;
        }).catch(function (err) {
          console.log(err.message);
          _this2.disabled = false;
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(function () {
        if (_this3.$store.getters['pastTLAppDeadline'] && _this3.$store.state.application.teamLeader) {
          _this3.$store.commit('application/disableTeamLeader');
        }
        if (_this3.$store.state.application.completed) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
        } else if (_this3.$store.state.application.isNew) {
          _this3.$store.dispatch('application/save');
        } else if (_this3.$store.state.application.step !== 4) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/application/' + _this3.$store.state.application.step.toString());
        }
      });
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader');
    }
    if (this.$store.state.application.completed) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
    }
  }
});

/***/ }),

/***/ "gW13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListJuryApplications_vue__ = __webpack_require__("lkJq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_304c5197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListJuryApplications_vue__ = __webpack_require__("3hu/");
function injectStyle (ssrContext) {
  __webpack_require__("/rtg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListJuryApplications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_304c5197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListJuryApplications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hIjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown",attrs:{"id":"countdown"}},[_c('div',{staticClass:"countdown-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',[_vm._v("Student Volunteer Applications Open In")]),_vm._v(" "),_c('div',{staticClass:"row countdown-timing"},[_c('div',{staticClass:"col timing-group"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.countdownDays))]),_vm._v(" "),_c('p',{staticClass:"reference"},[_vm._v("Days")])]),_vm._v(" "),_c('div',{staticClass:"col timing-group"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.countdownHours))]),_vm._v(" "),_c('p',{staticClass:"reference"},[_vm._v("Hours")])]),_vm._v(" "),_c('div',{staticClass:"col timing-group"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.countdownMinutes))]),_vm._v(" "),_c('p',{staticClass:"reference"},[_vm._v(" Minutes")])]),_vm._v(" "),_c('div',{staticClass:"col timing-group"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.countdownSeconds))]),_vm._v(" "),_c('p',{staticClass:"reference"},[_vm._v(" Seconds")])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('ul',{staticClass:"social-list"},[_c('li',[_c('a',{attrs:{"href":"https://twitter.com/siggraphsv"}},[_c('i',{staticClass:"social fab fa-2x fa-twitter",attrs:{"alt":"Twitter"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/SIGGRAPHStudentVolunteers/"}},[_c('i',{staticClass:"social fab fa-2x fa-facebook",attrs:{"alt":"Facebook"}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"social fab fa-2x fa-instagram",attrs:{"alt":"Instagram"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hLnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"nav-bg container-fluid"},[_c('navigation')],1),_vm._v(" "),_c('div',{staticClass:"hero"},[_c('div',{staticClass:"container"},[(_vm.isAfterLaunchDate)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[(_vm.isBeforeDeadline)?_c('h1',{staticClass:"gradient"},[_vm._v("Applications are Open!")]):_vm._e(),_vm._v(" "),(_vm.isAfterDeadline)?_c('h1',{staticClass:"gradient"},[_vm._v("Applications are Closed")]):_vm._e(),_vm._v(" "),(_vm.isBeforeDeadline)?_c('h3',{staticClass:"info-content"},[_vm._v("Team Leader Applications Are Due "),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.formattedDate(_vm.applicationTlEndDate)))])]):_vm._e(),_vm._v(" "),(_vm.isBeforeDeadline)?_c('h3',{staticClass:"info-content"},[_vm._v("Student Volunteer Applications Are Due "),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.formattedDate(_vm.applicationEndDate)))])]):_vm._e(),_vm._v(" "),(_vm.isAfterDeadline)?_c('h3',{staticClass:"info-content"},[_vm._v("Acceptances will be sent by "),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.formattedDate(_vm.acceptanceDate)))])]):_vm._e(),_vm._v(" "),(_vm.isAfterDeadline)?_c('h1',{staticStyle:{"margin-top":"10px"}},[_vm._v("Interested in Volunteering at SIGGRAPH 2025?")]):_vm._e(),_vm._v(" "),(_vm.isAfterDeadline)?_c('h3',[_vm._v("Join the "),_c('a',{staticClass:"display-link",attrs:{"href":"https://forms.gle/Q5rjMZUEoqEJnDnc6"}},[_vm._v("2025 SV mailing list.")])]):_vm._e(),_vm._v(" "),(_vm.isAfterSchedulesOut)?_c('h1',{staticStyle:{"margin-top":"10px"}},[_vm._v("Schedules are out!")]):_vm._e(),_vm._v(" "),(_vm.isAfterSchedulesOut)?_c('h3',[_vm._v("Please "),_c('strong',[_vm._v("log in")]),_vm._v(" to see your schedule. "),_c('br'),_c('br'),_c('small',[_vm._v("If you worked more than 25 hours on pre-conference shifts you might not have a conference week schedule.")])]):_vm._e(),_vm._v(" "),(_vm.isBeforeDeadline && !_vm.isRegistering)?_c('button',{staticClass:"btn arrow-btn-large",staticStyle:{"text-align":"left"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.toggleRegister($event)}}},[_vm._v("Start New Application")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('login',{attrs:{"isRegistering":_vm.isRegistering},on:{"toggle":_vm.toggleRegister}})],1)]):_c('div',{staticClass:"row"},[_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v(_vm._s(_vm.formattedDate(_vm.applicationTlEndDate))+":")]),_vm._v(" Team Leader Applications Deadline")]),_vm._v(" "),_c('p',[_vm._v("Only open to students who have previously served as Student Volunteers. Please complete the regular Student Volunteer application and the Team Leader essays on the application by 22:00 UTC/GMT.")])])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v(_vm._s(_vm.formattedDate(_vm.applicationEndDate))+":")]),_vm._v(" Student Volunteer Application Deadline")]),_vm._v(" "),_c('p',[_vm._v("The Student Volunteer application must be completed by 22:00 UTC/GMT  (convert to your time zone).  Please note you will be required to upload proof of full-time student status (e.g., transcript, proof of enrollment, etc.). We recommend you allow ample time to gather this information from your institution before the due date. Without this documentation, your application will be marked as incomplete.")])])]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_vm._m(10)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center",staticStyle:{"display":"flex","justify-content":"center"}},[_c('h1',{staticClass:"gradient",staticStyle:{"max-width":"fit-content"}},[_vm._v("Applications will open soon!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"eligibility"}},[_c('h2',{staticStyle:{"margin-left":"15px"}},[_vm._v("Eligibility")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Age")]),_vm._v(" "),_c('p',[_vm._v("Applicants must be 18 years of age or older (on or before 15 May 2024).")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Full Time Student Status")]),_vm._v(" "),_c('p',[_vm._v("Applicants must be/have been enrolled as a full-time high school, undergraduate, or graduate students for at least one semester between June 2023 and September 2024.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"expectations"}},[_c('h2',{staticStyle:{"margin-left":"15px"}},[_vm._v("Expectations")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_vm._v("Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer Program after accepting a position.")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteers and Team Leaders will serve the conference in-person shifts (on-site at SIGGRAPH 2024 in Denver).")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteers commit to volunteering about 25 hours to provide operational support for SIGGRAPH 2024 in pre-conference shifts or the in-person conference. In exchange for their service and enthusiasm, Student Volunteers receive the highest level of registration for the conference, networking opportunities, and a number of exclusive Student Volunteer-only benefits.")]),_vm._v(" "),_c('p',[_vm._v("Team Leaders are expected to volunteer about 60 hours to provide operational and logistical support for SIGGRAPH 2024 pre-conference shifts or the in-person conference. In exchange for their service and enthusiasm, Team Leaders receive the highest level of registration for the conference, networking opportunities, and a number of exclusive Student Volunteer-only benefits.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("For In-person Volunteers")]),_vm._v(" "),_c('ul',{staticStyle:{"list-style-type":"square","padding-left":"15px"}},[_c('li',[_vm._v("You are expected to participate in SIGGRAPH 2024 all day from 28 July - 01 August 2024 in Denver.")]),_vm._v(" "),_c('li',[_vm._v("DO NOT plan to depart the Colorado Convention Center earlier than 6 pm (GMT-8) on 1 August 2024.")]),_vm._v(" "),_c('li',[_vm._v("No housing or accommodation will be provided to Team Leaders or Student Volunteers.")]),_vm._v(" "),_c('li',[_vm._v("Student Volunteers and Team Leaders can opt for financial assistance on their application form. You will be notified if you are awarded financial aid and the amount with the result of your student volunteer application.")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_vm._v("More details on what involves being a Student Volunteer will be provided during the upcoming months.")]),_vm._v(" "),_c('p',[_vm._v("If you have any questions regarding the program and processes, please email "),_c('a',{attrs:{"href":"mailto:sv-s2024@siggraph.org"}},[_vm._v("sv-s2024@siggraph.org")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Attend Mandatory Orientation")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer Program after accepting a position.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_c('b',[_vm._v("IMPORTANT.")]),_vm._v(" More details on what involves being a in-person Student Volunteer will be provided upon acceptance. We encourage you to visit our  "),_c('a',{attrs:{"href":"https://s2024.siggraph.org/program/student-volunteers/"}},[_vm._v("FAQs")]),_vm._v(" section to stay abreast of the latest updates regarding the Student Volunteer Program.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"benefits"}},[_c('h2',{staticStyle:{"margin-left":"15px"}},[_vm._v("Benefits")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Full conference Registration")]),_vm._v(" "),_c('p',[_vm._v("Enjoy all of the latest and greatest this amazing conference has to offer! SIGGRAPH offers many opportunities to explore the latest innovations when you are off-shift.")]),_vm._v(" "),_c('h3',[_vm._v("Student Volunteer Special Sessions")]),_vm._v(" "),_c('p',[_vm._v("Hear top professionals in the industry and academia (some of them former Student Volunteers) speak about tips, tricks, and job opportunities at exclusive “Student Volunteers-only” sessions before SIGGRAPH 2024!")]),_vm._v(" "),_c('h3',[_vm._v("S3 Résumé and Reel Review Sessions")]),_vm._v(" "),_c('p',[_vm._v("Polish your reel and résumé, and get some professional feedback (virtually and in-person) to land your dream job! Space is limited. This program is made possible by the SIGGRAPH Student Services Committee (S3).")]),_vm._v(" "),_c('h3',[_vm._v("Professional Development")]),_vm._v(" "),_c('p',[_vm._v("Expand your knowledge outside the classroom through leadership, mentoring, and diversity & inclusion sessions tailored specially for student volunteers.")]),_vm._v(" "),_c('h3',[_vm._v("Networking")]),_vm._v(" "),_c('p',[_vm._v("Participate in the many events and get-togethers we will organize prior to and during the conference. Meet students from all over the globe who share your passion for computer graphics and interactive techniques!")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"deadlines"}},[_c('h2',{staticStyle:{"margin-left":"15px"}},[_vm._v("Deadlines")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("Please comply with the submission deadlines and ensure you submit your application by the appropriate day and time. We will not accept any late applications or make any exceptions for students due to miscalculation of the application deadline. Thank you for your understanding.")]),_vm._v(" "),_c('p',[_vm._v("Please adjust your spam filter so messages with the ‘siggraph.org’ domain will not be placed in your junk-mail folder.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v("Mid-February 2024:")]),_vm._v(" Team Leader Acceptance Notification")]),_vm._v(" "),_c('p',[_vm._v("Team Leader application results will be sent in mid-February 2024. You will receive an email notification at the address you provided in your application. Applicants who are not accepted as Team Leaders will still be considered for Student Volunteer positions.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('strong',[_vm._v("Late April 2024:")]),_vm._v(" Student Volunteer Acceptance Notification")]),_vm._v(" "),_c('p',[_vm._v("Student Volunteer application results will be sent in late April 2024. You will receive an email notification at the address you provided in your application.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row",attrs:{"id":"questions"}},[_c('h2',{staticStyle:{"margin-left":"15px"}},[_vm._v("Questions")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('p',[_vm._v("We encourage you to visit our "),_c('a',{attrs:{"href":"https://s2024.siggraph.org/program/student-volunteers/"}},[_vm._v("FAQ")]),_vm._v(" to stay abreast of the latest updates regarding the Student Volunteer Program.")]),_vm._v(" "),_c('p',[_vm._v("If your question is not in the FAQs, send us an email to "),_c('a',{attrs:{"href":"mailto:sv-s2024@siggraph.org"}},[_vm._v("sv-s2024@siggraph.org")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-12 site-info"},[_c('p',[_vm._v("The premier conference & exhibition on computer graphics & interactive techinques")]),_vm._v(" "),_c('a',{staticClass:"gradient",attrs:{"id":"footer-privacy-policy","href":"https://www.acm.org/about-acm/privacy-policy"}},[_vm._v("Privacy Policy")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 offset-md-3 col-sm-12"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i+MZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminDashboard',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('admin', ['isLoadingStats', 'appStatistics'])),
  created: function created() {
    if (!this.$store.state.admin.appStatistics.isLoaded) {
      this.$store.dispatch('admin/getAppStatistics');
    }
  }
});

/***/ }),

/***/ "iXcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Thank You For Applying!")]),_vm._v(" "),_c('p',[_vm._v("You have successfully applied to the SIGGRAPH Student Volunteer Program.")]),_vm._v(" "),_c('h3',[_vm._v("Notification of Acceptance")]),_vm._v(" "),_c('p',[_vm._v("Based on which application you submitted, you should hear from us around the following times:")]),_vm._v(" "),_c('h3',[_vm._v("Team Leader Applications")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("February 2024")])]),_vm._v(" "),_c('h3',[_vm._v("Student Volunteer Applications")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("May 2024")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ir3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j8Rg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jury_vue__ = __webpack_require__("FGb6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be4263ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jury_vue__ = __webpack_require__("cEA5");
function injectStyle (ssrContext) {
  __webpack_require__("CwFJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be4263ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jury_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be4263ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jury_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "klTF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ed451a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("hLnF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ed451a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lV3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppStatus_vue__ = __webpack_require__("Tz0+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f0b02b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppStatus_vue__ = __webpack_require__("EyCo");
function injectStyle (ssrContext) {
  __webpack_require__("2B/m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f0b02b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f0b02b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lb81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"size":"small","variant":"secondary"},on:{"click":_vm.goBack}},[_vm._v("Back to Schedule")]),_vm._v(" "),_c('h1',[_vm._v("Shift Details")]),_vm._v(" "),(_vm.isLoaded)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v(_vm._s(_vm.shift.venue.name))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.shift.venue.location))]),_vm._v(" "),_c('h5',{staticStyle:{"font-family":"unset"}},[_vm._v(_vm._s(_vm.shift.primary_type))]),_vm._v(" "),(_vm.shift.secondary_type!='-'&&_vm.shift.seconday_type!=null)?_c('h5',{staticStyle:{"font-family":"unset"}},[_vm._v(_vm._s(_vm.shift.secondary_type))]):_vm._e(),_vm._v(" "),_c('h5',{staticStyle:{"font-family":"unset"}},[_vm._v(" "+_vm._s(_vm.shift.studentVolunteers.length)+"  /  "+_vm._s(_vm.shift.sv_slots)+" possible SVs assigned")]),_vm._v(" "),(_vm.shift.special)?_c('h3',[_vm._v(_vm._s(_vm.shift.special))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h2',[_vm._v(_vm._s(_vm.formattedDay(_vm.shift.day)))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.shift.start_time)+" - "+_vm._s(_vm.shift.end_time))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Volunteers")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","fields":_vm.fields,"items":_vm.svs},scopedSlots:_vm._u([{key:"name",fn:function(data){return [_vm._v("\n        "+_vm._s(data.item.name)+"\n        "),(data.item.start_back_to_back)?_c('em',[_c('br'),_vm._v("Arriving from a back to back shift with "+_vm._s(data.item.start_back_to_back))]):_vm._e(),_vm._v(" "),(data.item.end_back_to_back)?_c('em',[_c('br'),_vm._v("Departing to a back to back shift with "+_vm._s(data.item.end_back_to_back))]):_vm._e()]}},{key:"check_in",fn:function(data){return [_c('b-form-checkbox',{attrs:{"value":"true","unchecked-value":"false"},model:{value:(data.item.check_in),callback:function ($$v) {_vm.$set(data.item, "check_in", $$v)},expression:"data.item.check_in"}},[_vm._v("\n          Check In\n        ")])]}},{key:"check_out",fn:function(data){return [_c('b-form-checkbox',{attrs:{"value":"true","unchecked-value":"false"},model:{value:(data.item.check_out),callback:function ($$v) {_vm.$set(data.item, "check_out", $$v)},expression:"data.item.check_out"}},[_vm._v("\n          Check Out\n        ")])]}},{key:"rating",fn:function(data){return [_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.ratings,"size":"sm"},model:{value:(data.item.rating),callback:function ($$v) {_vm.$set(data.item, "rating", $$v)},expression:"data.item.rating"}})]}},{key:"notes",fn:function(row){return [_c('b-button',{staticClass:"mr-2",attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();return row.toggleDetails($event)}}},[_vm._v("\n          Write Note\n        ")])]}},{key:"row-details",fn:function(row){return [_c('b-form-textarea',{attrs:{"placeholder":"Notes about this SV","rows":3,"max-rows":6},model:{value:(row.item.notes),callback:function ($$v) {_vm.$set(row.item, "notes", $$v)},expression:"row.item.notes"}})]}}],null,false,2072279063)}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('em',[_vm._v("Last Updated: "+_vm._s(_vm.lastRefreshDate))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.refreshPage}},[_c('em',[_vm._v("Refresh")])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(!_vm.isSaving)?_c('b-button',{attrs:{"variant":"secondary"},on:{"click":_vm.savePerformanceRecords}},[_vm._v("Save and Return")]):_c('b-button',{attrs:{"disabled":"","variant":"secondary"}},[_vm._v("Saving...")])],1)])],1):_c('div',[_c('h1',[_vm._v("Loading Shift...")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lkJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListJuryApplications',
  data: function data() {
    return {
      isLoadingList: false,
      isLoadingApp: false,
      isSaving: false,
      isNotFiltered: true,
      isFilteredByScored: false,
      isFilteredByUnscored: false,
      scores: [{ value: null, text: 'Score...' }, { value: 1, text: '1' }, { value: 2, text: '2' }, { value: 3, text: '3' }, { value: 4, text: '4' }, { value: 5, text: '5' }],
      overall: [{ value: null, text: 'Select...' }, { value: 1, text: 'Yes' }, { value: 0, text: 'No' }],
      red_flag: [{ value: 0, text: 'No' }, { value: 1, text: 'Yes' }],
      showModalMessage: false,
      modalMessage: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('jury', ['listAssignments']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('jury', ['assignments', 'activeApp']), {
    listFilteredAssignments: function listFilteredAssignments() {
      if (this.isNotFiltered) {
        return this.listAssignments;
      } else {
        if (this.isFilteredByScored) {
          return this.listAssignments.filter(function (assignment) {
            return assignment.isScored;
          });
        } else {
          return this.listAssignments.filter(function (assignment) {
            return !assignment.isScored;
          });
        }
      }
    },
    numberOfScored: function numberOfScored() {
      return this.listAssignments.filter(function (assignment) {
        return assignment.isScored;
      }).length;
    },
    getTitle: function getTitle() {
      if (this.isLoadingApp) {
        return 'Loading...';
      } else {
        return 'Score Application ' + this.activeApp.i;
      }
    },
    isFirstApp: function isFirstApp() {
      return this.activeApp.i === 1;
    },
    isLastApp: function isLastApp() {
      return this.activeApp.essay1Score === null || this.assignments[this.activeApp.i - 1].essay1 !== this.activeApp.essay1Score || this.activeApp.essay2Score === null || this.assignments[this.activeApp.i - 1].essay2 !== this.activeApp.essay2Score || this.activeApp.essay3Score === null || this.assignments[this.activeApp.i - 1].essay3 !== this.activeApp.essay3Score || this.activeApp.overall === null || this.assignments[this.activeApp.i - 1].overall !== this.activeApp.overall || this.activeApp.red_flag === null || this.assignments[this.activeApp.i - 1].red_flag !== this.activeApp.red_flag || this.activeApp.i === this.assignments.length;
    }
  }),
  methods: {
    filterAssignments: function filterAssignments(filter) {
      switch (filter) {
        case 'all':
          this.isNotFiltered = true;
          this.isFilteredByScored = false;
          this.isFilteredByUnscored = false;
          break;
        case 'scored':
          this.isNotFiltered = false;
          this.isFilteredByScored = true;
          this.isFilteredByUnscored = false;
          break;
        case 'unscored':
          this.isNotFiltered = false;
          this.isFilteredByScored = false;
          this.isFilteredByUnscored = true;
          break;
      }
    },
    scoreApp: function scoreApp(svId) {
      var _this = this;

      this.isLoadingApp = true;
      this.$refs.scoreModal.show();
      this.$store.dispatch('jury/setActiveApp', svId).then(function () {
        _this.isLoadingApp = false;
      }).catch(function (err) {
        _this.isLoadingApp = false;
        console.log(err);
      });
    },
    saveScores: function saveScores() {
      var _this2 = this;

      this.isSaving = true;
      this.$store.dispatch('jury/saveScores').then(function () {
        _this2.isSaving = false;
        _this2.modalMessage = 'Scores saved successfully';
        _this2.showModalMessage = true;
        setTimeout(function () {
          _this2.showModalMessage = false;
          _this2.modalMessage = '';
        }, 3000);
      });
    },
    previousApp: function previousApp() {
      this.scoreApp(this.assignments[this.activeApp.i - 2].student_volunteer_id);
    },
    nextApp: function nextApp() {
      this.scoreApp(this.assignments[this.activeApp.i].student_volunteer_id);
    },
    closeModal: function closeModal() {
      this.$refs.scoreModal.hide();
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.$store.state.jury.assignments.length === 0) {
      this.isLoadingList = true;
      this.$store.dispatch('jury/getTLAssignments').then(function () {
        _this3.isLoadingList = false;
      }).catch(function (err) {
        console.log(err);
        _this3.isLoadingList = false;
      });
    }
  }
});

/***/ }),

/***/ "mIRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);


var jury = {
  namespaced: true,
  state: {
    assignments: [],
    activeApp: {
      i: 0,
      svId: null,
      scoreId: null,
      essay1Content: '',
      essay2Content: '',
      essay3Content: '',
      essay1Score: null,
      essay2Score: null,
      essay3Score: null,
      overall: null,
      red_flag: 0
    }
  },
  mutations: {
    setAssignments: function setAssignments(state, assignments) {
      state.assignments = assignments;
    },
    setActiveApp: function setActiveApp(state, _ref) {
      var svId = _ref.svId,
          essay1Content = _ref.essay1Content,
          essay2Content = _ref.essay2Content,
          essay3Content = _ref.essay3Content;

      var app = state.assignments.find(function (assignment) {
        return assignment.student_volunteer_id === svId;
      });
      state.activeApp.i = state.assignments.findIndex(function (assign) {
        return assign.student_volunteer_id === svId;
      }) + 1;

      state.activeApp.essay1Content = essay1Content;
      state.activeApp.essay2Content = essay2Content;
      state.activeApp.essay3Content = essay3Content;
      state.activeApp.essay1Score = app.essay1;
      state.activeApp.essay2Score = app.essay2;
      state.activeApp.essay3Score = app.essay3;
      state.activeApp.overall = app.overall;
      state.activeApp.red_flag = app.red_flag || 0;
      state.activeApp.scoreId = app.score_id;
      state.activeApp.svId = svId;
    },
    updateAssignmentListScores: function updateAssignmentListScores(state, scoreId) {
      state.assignments[state.activeApp.i - 1].essay1 = state.activeApp.essay1Score;
      state.assignments[state.activeApp.i - 1].essay2 = state.activeApp.essay2Score;
      state.assignments[state.activeApp.i - 1].essay3 = state.activeApp.essay3Score;
      state.assignments[state.activeApp.i - 1].overall = state.activeApp.overall;
      state.assignments[state.activeApp.i - 1].red_flag = state.activeApp.red_flag;
      state.assignments[state.activeApp.i - 1].score_id = scoreId;
      state.activeApp.scoreId = scoreId;
    }
  },
  getters: {
    listAssignments: function listAssignments(state) {
      return state.assignments.map(function (assignment, index) {
        assignment.i = index + 1;
        assignment.isScored = assignment.score_id !== null;
        return assignment;
      });
    }
  },
  actions: {
    getTLAssignments: function getTLAssignments(_ref2) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'jury/tl-assignments/' + rootState.user.profile.id, {
          headers: {
            'Authorization': rootState.user.session.accessToken
          }
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (response.status === 200 && payload.success) {
              commit('setAssignments', payload.data.assignments);
              resolve();
            } else {
              commit('error', { message: payload.data.message }, { root: true });
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    setActiveApp: function setActiveApp(_ref3, svId) {
      var commit = _ref3.commit,
          rootState = _ref3.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'application/' + svId, {
          headers: {
            'Authorization': rootState.user.session.accessToken
          }
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (response.status === 200 && payload.success) {
              commit('setActiveApp', {
                svId: payload.data.student_volunteer_id,
                essay1Content: payload.data.data.essay1,
                essay2Content: payload.data.data.essay2,
                essay3Content: payload.data.data.essay3
              });
              resolve();
            } else {
              commit('error', { message: 'Unable to load application' }, { root: true });
              resolve();
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    },
    saveScores: function saveScores(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state,
          rootState = _ref4.rootState;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var path = 'jury/score';
        if (state.activeApp.scoreId !== null) {
          path += '/' + state.activeApp.scoreId;
        }
        fetch('https://api.siggraphsv.org/' + path, {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            tl_id: rootState.user.profile.id,
            sv_id: state.activeApp.svId,
            essay1: state.activeApp.essay1Score,
            essay2: state.activeApp.essay2Score,
            essay3: state.activeApp.essay3Score,
            overall: state.activeApp.overall,
            red_flag: state.activeApp.red_flag
          })
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (response.status === 200 && payload.success === true) {
              var scoreId = state.activeApp.scoreId;
              if (scoreId === null) {
                scoreId = payload.data.score.score_id;
              }
              commit('updateAssignmentListScores', scoreId);
              resolve();
            } else {
              commit('error', { message: payload.data.message }, { root: true });
              reject(payload.data.error);
            }
          });
        }).catch(function (err) {
          commit('error', { message: err.message }, { root: true });
          reject(err);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (jury);

/***/ }),

/***/ "nUbs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header-tag":"header"}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Schedule")]),_vm._v(" "),(_vm.isLoading)?_c('h3',[_vm._v("Getting your schedule...")]):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('div',{staticClass:"card-text"},[_c('p',[_c('em',[_vm._v("Last Updated: "+_vm._s(_vm.lastRefreshDate))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.refreshPage}},[_c('em',[_vm._v("Refresh")])])],1),_vm._v(" "),(_vm.isTeamLeader)?_c('div',[(_vm.currentShifts.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-alert',{attrs:{"show":"","variant":"success"}},[_c('h4',[_vm._v("Current Shifts")]),_vm._v(" "),_c('b-list-group',_vm._l((_vm.currentShifts),function(cs){return _c('b-list-group-item',{key:cs.id,attrs:{"to":{ name: 'Shift', params: { id: cs.id }}}},[_vm._v("\n                "+_vm._s(cs.venue.name)),_c('br'),_vm._v("\n                "+_vm._s(_vm.nextShiftDay(cs.day))),_c('br'),_vm._v("\n                "+_vm._s(cs.start_time)+" - "+_vm._s(cs.end_time)+" "),_c('br'),_vm._v("\n                "+_vm._s(cs.special)+"\n              ")])}),1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.nextShifts.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('h4',[_vm._v("Next Shifts")]),_vm._v(" "),_c('b-list-group',_vm._l((_vm.nextShifts),function(ns){return _c('b-list-group-item',{key:ns.id,attrs:{"to":{ name: 'Shift', params: { id: ns.id }}}},[_vm._v("\n                "+_vm._s(ns.venue.name)),_c('br'),_vm._v("\n                "+_vm._s(_vm.nextShiftDay(ns.day))),_c('br'),_vm._v("\n                "+_vm._s(ns.start_time)+" - "+_vm._s(ns.end_time)+" "),_c('br'),_vm._v("\n                "+_vm._s(ns.special)+"\n              ")])}),1)],1)],1)]):_vm._e()]):_c('div',[_c('div',{staticClass:"row"},[(_vm.isScheduled && _vm.nextShift)?_c('div',{staticClass:"col"},[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('h4',[_vm._v("Next Shift: "+_vm._s(_vm.nextShiftDay(_vm.nextShift.day))+" - "+_vm._s(_vm.nextShift.start_time))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.nextShift.venue.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.nextShift.special))]),_vm._v(" "),_c('p',[_vm._v("Start: "+_vm._s(_vm.nextShift.start_time)+" "),_c('br'),_vm._v("End: "+_vm._s(_vm.nextShift.end_time))])])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":_vm.goToSchedule}},[_vm._v("View Schedule")])],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oOEi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oQUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("f4ek");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227e5baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("d6M3");
function injectStyle (ssrContext) {
  __webpack_require__("7Zsy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227e5baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oglw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__ = __webpack_require__("q2Ni");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134dffc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__ = __webpack_require__("0EqV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134dffc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p8ve":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "pM0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__ = __webpack_require__("rydV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var generateVuexSetters = function generateVuexSetters(fields) {
  var computed = {};
  fields.forEach(function (field) {
    computed[field] = {
      get: function get() {
        return this.$store.state.application.data[field];
      },
      set: function set(value) {
        this.$store.commit('application/updateField', { name: field, value: value });
      }
    };
  });
  return computed;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppStepThree',
  data: function data() {
    return {
      // svTypePreferences: svTypePreferences,
      // svTypePreferencesSecond: svTypePreferencesSecond,
      primaryTransportList: __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__["h" /* primaryTransportList */],
      financialAidSummaryWordCount: '80 words remaining',
      financialAidSummaryWordLimitClass: 'under-limit',
      financialAidExpensesWordCount: '30 words remaining',
      financialAidExpensesWordLimitClass: 'under-limit',
      teamLeaderEssay1WordCount: '250 words remaining',
      teamLeaderEssay1WordLimitClass: 'under-limit',
      teamLeaderEssay2WordCount: '250 words remaining',
      teamLeaderEssay2WordLimitClass: 'under-limit',
      disabled: false,
      // shirtSizes: shirtSizes,
      // diets: diets,
      timeZones: __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__["n" /* timeZones */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, generateVuexSetters(['financialAidSummary', 'primaryTransport', 'airportCode', 'financialAidExpenses', 'estimatedTravelCost', 'roomPreference', 'fundedTravel', 'fundedTravel', 'teamLeaderEssay1', 'teamLeaderEssay2', 'otherComments', 'firstChoice', 'secondChoice'
  // 'shirtSize',
  // 'diet',
  // 'otherDiet'
  ]), {
    financialAid: {
      get: function get() {
        return this.$store.state.application.financialAid;
      },
      set: function set(value) {
        this.$store.commit('application/updateFinancialAid', value);
      }
    },
    teamLeader: {
      get: function get() {
        return this.$store.state.application.teamLeader;
      },
      set: function set(value) {
        this.$store.commit('application/updateTeamLeader', value);
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])('application', ['isLoaded', 'isLoading']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('application', ['financialAidAndFlying', 'getVolunteerTypePrefFirst', 'getVolunteerTypePrefSecond', 'getTimeZone']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['pastTLAppDeadline']), {
    isInPerson: function isInPerson() {
      return this.firstChoice === 'In-person' || this.secondChoice === 'In-person';
    },
    isVirtual: function isVirtual() {
      return this.firstChoice === 'Virtual' || this.secondChoice === 'Virtual';
    }
  }),
  methods: {
    updateTimeZone: function updateTimeZone(value) {
      this.$store.commit('application/updateField', { name: 'timeZone', value: value });
    },
    updateFirstPreference: function updateFirstPreference(value) {
      if (this.secondChoice === value) {
        this.$store.commit('application/updateField', { name: 'secondChoice', value: '' });
      }
      this.$store.commit('application/updateField', { name: 'firstChoice', value: value });
    },
    updateSecondPreference: function updateSecondPreference(value) {
      if (this.firstChoice === value) {
        this.$store.commit('application/updateField', { name: 'firstChoice', value: '' });
      }
      this.$store.commit('application/updateField', { name: 'secondChoice', value: value });
    },
    wordCount: function wordCount(field, limit) {
      var words = this[field].trim().split(/\s+/);
      var wordCount = words.length === 1 && words[0] === '' ? 0 : words.length;
      var remaining = limit - wordCount;
      this[field + 'WordCount'] = remaining < 0 ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining';
      this[field + 'WordLimitClass'] = remaining < 0 ? 'over-limit' : 'under-limit';
    },
    nextStep: function nextStep(e) {
      var _this = this;

      e.preventDefault();
      this.disabled = true;
      if (__WEBPACK_IMPORTED_MODULE_4_moment___default()().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
      } else {
        this.$store.commit('application/updateStep', 4);
        this.$store.dispatch('application/save').then(function () {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'stepFour' });
          window.scrollTo(0, 0);
          _this.disabled = true;
        }).catch(function (err) {
          console.log(err.message);
          _this.disabled = true;
        });
      }
    },
    previousStep: function previousStep(e) {
      var _this2 = this;

      e.preventDefault();
      this.disabled = true;
      if (__WEBPACK_IMPORTED_MODULE_4_moment___default()().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
      } else {
        this.$store.commit('application/updateStep', 2);
        this.$store.dispatch('application/save').then(function () {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'stepTwo' });
          _this2.disabled = false;
        }).catch(function (err) {
          console.log(err.message);
          _this2.disabled = false;
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(function () {
        if (_this3.$store.getters['pastTLAppDeadline'] && _this3.$store.state.application.teamLeader) {
          _this3.$store.commit('application/disableTeamLeader');
        }
        if (_this3.$store.state.application.completed) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
        } else if (_this3.$store.state.application.isNew) {
          _this3.$store.dispatch('application/save');
        } else if (_this3.$store.state.application.step !== 3) {
          __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/application/' + _this3.$store.state.application.step.toString());
        }
      });
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader');
    }
    if (this.$store.state.application.completed) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/dashboard');
    }
  },
  mounted: function mounted() {
    this.wordCount('teamLeaderEssay1', 250);
    this.wordCount('teamLeaderEssay2', 250);
    this.wordCount('financialAidExpenses', 30);
    this.wordCount('financialAidSummary', 80);
  },
  components: {
    multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  }
});

/***/ }),

/***/ "pVNG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_SelectLists__ = __webpack_require__("rydV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SvSchedule',
  data: function data() {
    return {
      selectedDay: '2023-08-04',
      days: __WEBPACK_IMPORTED_MODULE_2__util_SelectLists__["c" /* days */],
      selectedShift: {
        id: 0,
        start_time: '00:00',
        end_time: '01:00',
        swappable: false,
        day: '2023-08-04',
        sv_slots: 1,
        special: '',
        venue: {
          name: '',
          location: '',
          teamLeaders: []
        }
      }
    };
  },

  methods: {
    formattedDay: function formattedDay(day) {
      return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(day).utc().format('ddd MMM Do');
      // if (day.length === 10) {
      // } else {
      // return moment(day).utc().format('ddd MMM Do')
      // }
    },
    selectShift: function selectShift(shift) {
      this.selectedShift = shift;
      this.$refs.shiftModal.show();
    },
    swapShift: function swapShift() {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'CreateShiftSwapRequest', params: { id: this.selectedShift.id } });
    },
    closeModal: function closeModal() {
      this.selectedShift = {
        start_time: '00:00',
        end_time: '01:00',
        swappable: false,
        day: '2023-08-04',
        sv_slots: 1,
        special: '',
        venue: {
          name: '',
          location: '',
          teamLeaders: []
        }
      };
      this.$refs.shiftModal.hide();
    },
    goToShiftSwapRequests: function goToShiftSwapRequests() {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/schedule/swap/list');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('schedule', ['shifts', 'isLoaded']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('schedule', ['nextShift']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage']), {
    dayShifts: function dayShifts() {
      var _this = this;

      return this.shifts.filter(function (shift) {
        return _this.selectedDay === __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(shift.day).utc().format('Y-MM-DD');
      });
    }
  }),
  created: function created() {
    if (!this.$store.state.schedule.isLoaded) {
      this.$store.dispatch('schedule/load');
    }
    if (__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.selectedDay).isBefore(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(), 'day')) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.days[this.days.length - 1].value))) {
        this.selectedDay = this.days[this.days.length - 1];
        console.log(this.selectedDay);
        console.log('if');
      } else {
        this.selectedDay = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().utc().format('Y-MM-DD');
        console.log(this.selectedDay);
        console.log('else');
      }
    }
  }
});

/***/ }),

/***/ "pkez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchAppStatus',
  data: function data() {
    return {
      breadcrumb: [{
        text: 'Dashboard',
        to: { name: 'Home' }
      }, {
        text: 'Search Apps by Status',
        to: { name: 'SearchAppStatus' }
      }],
      fields: ['firstName', 'lastName', 'email', 'svId', 'completed', 'teamLeader', 'financialAid', 'view'],
      bool: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
      page: 1,
      enableCompletedFilter: false,
      completed: true,
      enableTeamLeaderFilter: false,
      teamLeader: true,
      enableFinancialAidFilter: false,
      financialAid: true,
      isFiltering: false,
      withData: false,
      withScores: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    enabledCompletedFilter: function enabledCompletedFilter() {
      return !this.enableCompletedFilter;
    },
    enabledTeamLeaderFilter: function enabledTeamLeaderFilter() {
      return !this.enableTeamLeaderFilter;
    },
    enabledFinancialAidFilter: function enabledFinancialAidFilter() {
      return !this.enableFinancialAidFilter;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('admin', ['filteredApps', 'appPagination', 'exportData'])),
  methods: {
    filterApps: function filterApps(e) {
      var _this = this;

      this.isFiltering = true;
      this.$store.dispatch('admin/filterApps', {
        filterCompleted: this.enableCompletedFilter,
        completed: this.completed,
        filterTeamLeader: this.enableTeamLeaderFilter,
        teamLeader: this.teamLeader,
        filterFinancialAid: this.enableFinancialAidFilter,
        financialAid: this.financialAid,
        page: 1
      }).then(function () {
        _this.isFiltering = false;
        _this.page = _this.$store.state.admin.appPagination.page;
      }).catch(function (err) {
        console.log(err);
        _this.isFiltering = false;
      });
    },
    exportApps: function exportApps(e) {
      var _this2 = this;

      this.$refs.exportModal.show();
      this.$store.dispatch('admin/exportApps', {
        filterCompleted: this.enableCompletedFilter,
        completed: this.completed,
        filterTeamLeader: this.enableTeamLeaderFilter,
        teamLeader: this.teamLeader,
        filterFinancialAid: this.enableFinancialAidFilter,
        financialAid: this.financialAid,
        withData: this.withData,
        withScores: this.withScores
      }).then(function () {
        _this2.$refs.exportModal.hide();
      });
    },
    cancelDownload: function cancelDownload(e) {
      this.$store.commit('admin/cancelDownload');
    },
    changePage: function changePage(page) {
      var _this3 = this;

      this.$store.dispatch('admin/filterApps', {
        filterCompleted: this.enableCompletedFilter,
        completed: this.completed,
        filterTeamLeader: this.enableTeamLeaderFilter,
        teamLeader: this.teamLeader,
        filterFinancialAid: this.enableFinancialAidFilter,
        financialAid: this.financialAid,
        page: page
      }).then(function () {
        _this3.page = _this3.$store.state.admin.appPagination.page;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  created: function created() {
    if (this.$store.state.admin.filteredApps.length === 0) {
      this.filterApps(null);
    }
  }
});

/***/ }),

/***/ "ptwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-navbar',{staticClass:"navigation",attrs:{"type":"dark","toggleable":"md"}},[_c('b-navbar-brand',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",staticStyle:{"width":"190px","height":"45px"},attrs:{"src":__webpack_require__("EoOQ"),"alt":"Siggraph 2024 Student Volunteer Program Logo"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"color":"#FFFFFF","font-size":"13px","margin-top":"2px","font-weight":"600"}},[_vm._v("STUDENT VOLUNTEER PORTAL")])]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[(_vm.isAuthenticated)?_c('b-navbar-nav',{staticClass:"ml-auto text-right"},[_c('b-nav-item',{attrs:{"to":"/dashboard"}},[_c('div',[_vm._v("Dashboard")])]),_vm._v(" "),(_vm.isTeamLeader && _vm.isBeforeAcceptances && _vm.isAfterDeadline)?_c('b-nav-item',{attrs:{"to":"/jury/view"}},[_c('div',[_vm._v("Jury")])]):_vm._e(),_vm._v(" "),(_vm.isTeamLeader && _vm.isAfterSchedulesOut)?_c('b-nav-item',{attrs:{"to":"/schedule/tl"}},[_c('div',[_vm._v("Schedule")])]):(_vm.statusId === 2 && _vm.isAfterSchedulesOut)?_c('b-nav-item',{attrs:{"to":"/schedule/sv"}},[_c('div',[_vm._v("Schedule")])]):_vm._e(),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/profile"}},[_c('div',[_vm._v("Profile")])]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_c('div',[_vm._v("Logout")])])],1):_c('b-navbar-nav',{staticClass:"ml-auto text-right"},[_c('b-nav-item',{attrs:{"href":"#eligibility"}},[_c('div',[_vm._v("Eligibility")])]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#expectations"}},[_c('div',[_vm._v("Expectations")])]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#benefits"}},[_c('div',[_vm._v("Benefits")])]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#deadlines"}},[_c('div',[_vm._v("Deadlines")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q2Ni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__("uL8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_schedule_SvSchedule__ = __webpack_require__("P0Wh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_schedule_TlSchedule__ = __webpack_require__("xCnF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Schedule',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['isTeamLeader']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('schedule', ['lastRefreshDate'])),
  methods: {
    refreshPage: function refreshPage() {
      location.reload();
    }
  },
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_3__components_Nav__["a" /* default */],
    svSchedule: __WEBPACK_IMPORTED_MODULE_4__components_schedule_SvSchedule__["a" /* default */],
    tlSchedule: __WEBPACK_IMPORTED_MODULE_5__components_schedule_TlSchedule__["a" /* default */]
  }
});

/***/ }),

/***/ "qDLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{staticClass:"register-content",on:{"submit":_vm.handleSubmit}},[_c('h3',{style:({ marginTop: '11px'})},[_vm._v("Sign up to get started!")]),_vm._v(" "),_c('hr',{staticStyle:{"border-color":"#000302","margin-top":"15px","margin-bottom":"20px"}}),_vm._v(" "),_c('b-form-group',{attrs:{"label":"First Name","label-for":"firstName"}},[_c('b-form-input',{attrs:{"type":"text","id":"firstName","required":""},model:{value:(_vm.form.firstName),callback:function ($$v) {_vm.$set(_vm.form, "firstName", $$v)},expression:"form.firstName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Last Name","label-for":"lastName"}},[_c('b-form-input',{attrs:{"type":"text","id":"lastName","required":""},model:{value:(_vm.form.lastName),callback:function ($$v) {_vm.$set(_vm.form, "lastName", $$v)},expression:"form.lastName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"email"}},[_c('b-form-input',{attrs:{"type":"email","id":"email","placeholder":"you@example.com","required":""},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Password","label-for":"password","description":"Password must be at least 6 characters"}},[_c('b-form-input',{attrs:{"type":"password","id":"password","required":""},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"id":"acceptTerms"},model:{value:(_vm.form.accept),callback:function ($$v) {_vm.$set(_vm.form, "accept", $$v)},expression:"form.accept"}},[_vm._v("I have read and accept the terms on this page")])],1),_vm._v(" "),_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn arrow-btn-primary btn-inverse text-right",staticStyle:{"margin":"5px 15px 5px 0px"},attrs:{"disabled":_vm.disabled,"type":"submit"}},[_vm._v("Start Application")]),_vm._v(" "),(_vm.isRegistering)?_c('p',{staticClass:"text-right mt-2"},[_vm._v("Creating account...")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rF0G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListShiftSwapRequests',
  data: function data() {
    return {
      createdFields: [{ key: 'shift', label: 'Your Shift' }, { key: 'swapped_shift', label: 'Requested Shift' }, { key: 'sv', label: 'Accepted By' }, { key: 'status', label: 'Status' }, { key: 'actions', label: 'Actions' }],
      assignedFields: [{ key: 'shift', label: 'Your Shift' }, { key: 'swapped_shift', label: 'Their Shift' }, { key: 'sv', label: 'Requested By' }, { key: 'status', label: 'Status' }, { key: 'actions', label: 'Actions' }],
      openFields: [{ key: 'day', label: 'Day' }, { key: 'start_time', label: 'Start Time' }, { key: 'end_time', label: 'End Time' }, { key: 'name', label: 'Student Volunteer' }, { key: 'accept', label: 'Accept' }],
      selectedRequest: {
        shift: {
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        },
        swapped_shift: {
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        }
      },
      isDeleting: null,
      isAccepting: null,
      isDeclining: null
    };
  },

  methods: {
    formatName: function formatName(sv) {
      var name = sv.given_name + ' ' + sv.family_name;
      if (sv.nickname && sv.nickname !== '' && sv.nickname !== sv.given_name) {
        name = sv.given_name + ' "' + sv.nickname + '" ' + sv.family_name;
      }
      return name;
    },
    formatStatus: function formatStatus(status) {
      if (status === null) {
        return 'OPEN';
      }
      if (status) {
        return 'ACCEPTED';
      }
      return 'DECLINED';
    },
    formattedDay: function formattedDay(day) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).utc().format('ddd MMM Do');
    },
    deleteRequest: function deleteRequest(id) {
      this.isDeleting = id;
      this.$store.dispatch('schedule/deleteRequest', id);
    },
    resetSelectedRequest: function resetSelectedRequest() {
      this.selectedRequest = {
        shift: {
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        },
        swapped_shift: {
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        }
      };
    },
    acceptRequest: function acceptRequest(id) {
      this.resetSelectedRequest();
      this.selectedRequest = this.shiftSwapRequests.shiftRequests.find(function (request) {
        return request.id === id;
      });
      this.$refs.acceptModal.show();
    },
    confirmAcceptRequest: function confirmAcceptRequest() {
      this.isAccepting = this.selectedRequest.id;
      this.$store.dispatch('schedule/acceptRequest', {
        shift_swap_request_id: this.selectedRequest.id,
        swapped_shift_id: this.selectedRequest.swapped_shift.id
      });
    },
    declineRequest: function declineRequest(id) {
      this.isDeclining = id;
      this.$store.dispatch('schedule/declineRequest', { shift_swap_request_id: id });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('schedule', ['shiftSwapRequests', 'shiftSwapRequestsLoaded']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('schedule', ['getQualifyingOpenRequests', 'qualifyingShiftRequests'])),
  created: function created() {
    if (!this.$store.state.schedule.isLoaded) {
      this.$store.dispatch('schedule/load');
    }
    if (!this.$store.state.schedule.swapShiftsLoaded) {
      this.$store.dispatch('schedule/loadShiftSwapRequests');
    }
  }
});

/***/ }),

/***/ "rUfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Welcome! Your SV ID is: "+_vm._s(_vm.profile.svid))]),_vm._v(" "),(_vm.isConfirmedSv)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('Schedule')],1)]):_vm._e(),_vm._v(" "),(_vm.isTeamLeader)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-8"},[_c('AppStatus'),_vm._v(" "),(_vm.isAfterDeadline && _vm.isBeforeAcceptances)?_c('Jury'):_vm._e(),_vm._v(" "),(!_vm.isBeforeAcceptances)?_c('Schedule'):_vm._e()],1)]):_c('div',{staticClass:"row"},[(_vm.isAfterDeadline)?_c('div',{staticClass:"col col-md-8"},[_c('AppStatus')],1):_c('div',{staticClass:"col col-md-8"},[_c('LiveAppStatus')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rydV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return titles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return suffixes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return countries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return genderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return underrepresentedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return languageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return months; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return years; });
/* unused harmony export svTypePreferences */
/* unused harmony export svTypePreferencesSecond */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return timeZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return previousSvYears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return primaryTransportList; });
/* unused harmony export roles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return statuses; });
/* unused harmony export standard */
/* unused harmony export essayScores */
/* unused harmony export conferenceLocations */
/* unused harmony export amPm */
/* unused harmony export shiftTimes */
/* unused harmony export shirtSizes */
/* unused harmony export diets */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return startTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return shifts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return days; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TLdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return referenceTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var titles = [{ value: '', text: 'Please Select' }, { value: 'Mr.', text: 'Mr.' }, { value: 'Ms.', text: 'Ms.' }, { value: 'Mrs.', text: 'Mrs.' }, { value: 'Miss', text: 'Miss' }, { value: 'Mx.', text: 'Mx.' }, { value: 'Dr.', text: 'Dr.' }];

var suffixes = [{ value: '', text: 'Please Select' }, { value: 'Jr.', text: 'Jr.' }, { value: 'Sr.', text: 'Sr.' }, { value: 'II', text: 'II' }, { value: 'III', text: 'III' }, { value: 'IV', text: 'IV' }, { value: 'PhD', text: 'PhD' }, { value: 'MD', text: 'MD' }, { value: 'MA', text: 'MA' }, { value: 'MSc', text: 'MSc' }, { value: 'Esq', text: 'Esq' }];

var countries = [{ value: '', text: 'Please Select' }, { value: 'AF', text: 'Afghanistan' }, { value: 'AX', text: 'Åland Islands' }, { value: 'AL', text: 'Albania' }, { value: 'DZ', text: 'Algeria' }, { value: 'AS', text: 'American Samoa' }, { value: 'AD', text: 'Andorra' }, { value: 'AO', text: 'Angola' }, { value: 'AI', text: 'Anguilla' }, { value: 'AQ', text: 'Antarctica' }, { value: 'AG', text: 'Antigua and Barbuda' }, { value: 'AR', text: 'Argentina' }, { value: 'AM', text: 'Armenia' }, { value: 'AW', text: 'Aruba' }, { value: 'AU', text: 'Australia' }, { value: 'AT', text: 'Austria' }, { value: 'AZ', text: 'Azerbaijan' }, { value: 'BS', text: 'Bahamas' }, { value: 'BH', text: 'Bahrain' }, { value: 'BD', text: 'Bangladesh' }, { value: 'BB', text: 'Barbados' }, { value: 'BY', text: 'Belarus' }, { value: 'BE', text: 'Belgium' }, { value: 'BZ', text: 'Belize' }, { value: 'BJ', text: 'Benin' }, { value: 'BM', text: 'Bermuda' }, { value: 'BT', text: 'Bhutan' }, { value: 'BO', text: 'Bolivia, Plurinational State of' }, { value: 'BQ', text: 'Bonaire, Sint Eustatius and Saba' }, { value: 'BA', text: 'Bosnia and Herzegovina' }, { value: 'BW', text: 'Botswana' }, { value: 'BV', text: 'Bouvet Island' }, { value: 'BR', text: 'Brazil' }, { value: 'IO', text: 'British Indian Ocean Territory' }, { value: 'BN', text: 'Brunei Darussalam' }, { value: 'BG', text: 'Bulgaria' }, { value: 'BF', text: 'Burkina Faso' }, { value: 'BI', text: 'Burundi' }, { value: 'KH', text: 'Cambodia' }, { value: 'CM', text: 'Cameroon' }, { value: 'CA', text: 'Canada' }, { value: 'CV', text: 'Cape Verde' }, { value: 'KY', text: 'Cayman Islands' }, { value: 'CF', text: 'Central African Republic' }, { value: 'TD', text: 'Chad' }, { value: 'CL', text: 'Chile' }, { value: 'CN', text: 'China' }, { value: 'CX', text: 'Christmas Island' }, { value: 'CC', text: 'Cocos (Keeling) Islands' }, { value: 'CO', text: 'Colombia' }, { value: 'KM', text: 'Comoros' }, { value: 'CG', text: 'Congo' }, { value: 'CD', text: 'Congo, the Democratic Republic of the' }, { value: 'CK', text: 'Cook Islands' }, { value: 'CR', text: 'Costa Rica' }, { value: 'CI', text: 'Côte d\'Ivoire' }, { value: 'HR', text: 'Croatia' }, { value: 'CU', text: 'Cuba' }, { value: 'CW', text: 'Curaçao' }, { value: 'CY', text: 'Cyprus' }, { value: 'CZ', text: 'Czech Republic' }, { value: 'DK', text: 'Denmark' }, { value: 'DJ', text: 'Djibouti' }, { value: 'DM', text: 'Dominica' }, { value: 'DO', text: 'Dominican Republic' }, { value: 'EC', text: 'Ecuador' }, { value: 'EG', text: 'Egypt' }, { value: 'SV', text: 'El Salvador' }, { value: 'GQ', text: 'Equatorial Guinea' }, { value: 'ER', text: 'Eritrea' }, { value: 'EE', text: 'Estonia' }, { value: 'ET', text: 'Ethiopia' }, { value: 'FK', text: 'Falkland Islands (Malvinas)' }, { value: 'FO', text: 'Faroe Islands' }, { value: 'FJ', text: 'Fiji' }, { value: 'FI', text: 'Finland' }, { value: 'FR', text: 'France' }, { value: 'GF', text: 'French Guiana' }, { value: 'PF', text: 'French Polynesia' }, { value: 'TF', text: 'French Southern Territories' }, { value: 'GA', text: 'Gabon' }, { value: 'GM', text: 'Gambia' }, { value: 'GE', text: 'Georgia' }, { value: 'DE', text: 'Germany' }, { value: 'GH', text: 'Ghana' }, { value: 'GI', text: 'Gibraltar' }, { value: 'GR', text: 'Greece' }, { value: 'GL', text: 'Greenland' }, { value: 'GD', text: 'Grenada' }, { value: 'GP', text: 'Guadeloupe' }, { value: 'GU', text: 'Guam' }, { value: 'GT', text: 'Guatemala' }, { value: 'GG', text: 'Guernsey' }, { value: 'GN', text: 'Guinea' }, { value: 'GW', text: 'Guinea-Bissau' }, { value: 'GY', text: 'Guyana' }, { value: 'HT', text: 'Haiti' }, { value: 'HM', text: 'Heard Island and McDonald Islands' }, { value: 'VA', text: 'Holy See (Vatican City State)' }, { value: 'HN', text: 'Honduras' }, { value: 'HK', text: 'Hong Kong' }, { value: 'HU', text: 'Hungary' }, { value: 'IS', text: 'Iceland' }, { value: 'IN', text: 'India' }, { value: 'ID', text: 'Indonesia' }, { value: 'IR', text: 'Iran, Islamic Republic of' }, { value: 'IQ', text: 'Iraq' }, { value: 'IE', text: 'Ireland' }, { value: 'IM', text: 'Isle of Man' }, { value: 'IL', text: 'Israel' }, { value: 'IT', text: 'Italy' }, { value: 'JM', text: 'Jamaica' }, { value: 'JP', text: 'Japan' }, { value: 'JE', text: 'Jersey' }, { value: 'JO', text: 'Jordan' }, { value: 'KZ', text: 'Kazakhstan' }, { value: 'KE', text: 'Kenya' }, { value: 'KI', text: 'Kiribati' }, { value: 'KP', text: 'Korea, Democratic People\'s Republic of' }, { value: 'KR', text: 'Korea, Republic of' }, { value: 'KW', text: 'Kuwait' }, { value: 'KG', text: 'Kyrgyzstan' }, { value: 'LA', text: 'Lao People\'s Democratic Republic' }, { value: 'LV', text: 'Latvia' }, { value: 'LB', text: 'Lebanon' }, { value: 'LS', text: 'Lesotho' }, { value: 'LR', text: 'Liberia' }, { value: 'LY', text: 'Libya' }, { value: 'LI', text: 'Liechtenstein' }, { value: 'LT', text: 'Lithuania' }, { value: 'LU', text: 'Luxembourg' }, { value: 'MO', text: 'Macao' }, { value: 'MK', text: 'Macedonia, the former Yugoslav Republic of' }, { value: 'MG', text: 'Madagascar' }, { value: 'MW', text: 'Malawi' }, { value: 'MY', text: 'Malaysia' }, { value: 'MV', text: 'Maldives' }, { value: 'ML', text: 'Mali' }, { value: 'MT', text: 'Malta' }, { value: 'MH', text: 'Marshall Islands' }, { value: 'MQ', text: 'Martinique' }, { value: 'MR', text: 'Mauritania' }, { value: 'MU', text: 'Mauritius' }, { value: 'YT', text: 'Mayotte' }, { value: 'MX', text: 'Mexico' }, { value: 'FM', text: 'Micronesia, Federated States of' }, { value: 'MD', text: 'Moldova, Republic of' }, { value: 'MC', text: 'Monaco' }, { value: 'MN', text: 'Mongolia' }, { value: 'ME', text: 'Montenegro' }, { value: 'MS', text: 'Montserrat' }, { value: 'MA', text: 'Morocco' }, { value: 'MZ', text: 'Mozambique' }, { value: 'MM', text: 'Myanmar' }, { value: 'NA', text: 'Namibia' }, { value: 'NR', text: 'Nauru' }, { value: 'NP', text: 'Nepal' }, { value: 'NL', text: 'Netherlands' }, { value: 'NC', text: 'New Caledonia' }, { value: 'NZ', text: 'New Zealand' }, { value: 'NI', text: 'Nicaragua' }, { value: 'NE', text: 'Niger' }, { value: 'NG', text: 'Nigeria' }, { value: 'NU', text: 'Niue' }, { value: 'NF', text: 'Norfolk Island' }, { value: 'MP', text: 'Northern Mariana Islands' }, { value: 'NO', text: 'Norway' }, { value: 'OM', text: 'Oman' }, { value: 'PK', text: 'Pakistan' }, { value: 'PW', text: 'Palau' }, { value: 'PS', text: 'Palestinian Territory, Occupied' }, { value: 'PA', text: 'Panama' }, { value: 'PG', text: 'Papua New Guinea' }, { value: 'PY', text: 'Paraguay' }, { value: 'PE', text: 'Peru' }, { value: 'PH', text: 'Philippines' }, { value: 'PN', text: 'Pitcairn' }, { value: 'PL', text: 'Poland' }, { value: 'PT', text: 'Portugal' }, { value: 'PR', text: 'Puerto Rico' }, { value: 'QA', text: 'Qatar' }, { value: 'RE', text: 'Réunion' }, { value: 'RO', text: 'Romania' }, { value: 'RU', text: 'Russian Federation' }, { value: 'RW', text: 'Rwanda' }, { value: 'BL', text: 'Saint Barthélemy' }, { value: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha' }, { value: 'KN', text: 'Saint Kitts and Nevis' }, { value: 'LC', text: 'Saint Lucia' }, { value: 'MF', text: 'Saint Martin (French part)' }, { value: 'PM', text: 'Saint Pierre and Miquelon' }, { value: 'VC', text: 'Saint Vincent and the Grenadines' }, { value: 'WS', text: 'Samoa' }, { value: 'SM', text: 'San Marino' }, { value: 'ST', text: 'Sao Tome and Principe' }, { value: 'SA', text: 'Saudi Arabia' }, { value: 'SN', text: 'Senegal' }, { value: 'RS', text: 'Serbia' }, { value: 'SC', text: 'Seychelles' }, { value: 'SL', text: 'Sierra Leone' }, { value: 'SG', text: 'Singapore' }, { value: 'SX', text: 'Sint Maarten (Dutch part)' }, { value: 'SK', text: 'Slovakia' }, { value: 'SI', text: 'Slovenia' }, { value: 'SB', text: 'Solomon Islands' }, { value: 'SO', text: 'Somalia' }, { value: 'ZA', text: 'South Africa' }, { value: 'GS', text: 'South Georgia and the South Sandwich Islands' }, { value: 'SS', text: 'South Sudan' }, { value: 'ES', text: 'Spain' }, { value: 'LK', text: 'Sri Lanka' }, { value: 'SD', text: 'Sudan' }, { value: 'SR', text: 'Suriname' }, { value: 'SJ', text: 'Svalbard and Jan Mayen' }, { value: 'SZ', text: 'Swaziland' }, { value: 'SE', text: 'Sweden' }, { value: 'CH', text: 'Switzerland' }, { value: 'SY', text: 'Syrian Arab Republic' }, { value: 'TW', text: 'Taiwan, Province of China' }, { value: 'TJ', text: 'Tajikistan' }, { value: 'TZ', text: 'Tanzania, United Republic of' }, { value: 'TH', text: 'Thailand' }, { value: 'TL', text: 'Timor-Leste' }, { value: 'TG', text: 'Togo' }, { value: 'TK', text: 'Tokelau' }, { value: 'TO', text: 'Tonga' }, { value: 'TT', text: 'Trinidad and Tobago' }, { value: 'TN', text: 'Tunisia' }, { value: 'TR', text: 'Turkey' }, { value: 'TM', text: 'Turkmenistan' }, { value: 'TC', text: 'Turks and Caicos Islands' }, { value: 'TV', text: 'Tuvalu' }, { value: 'UG', text: 'Uganda' }, { value: 'UA', text: 'Ukraine' }, { value: 'AE', text: 'United Arab Emirates' }, { value: 'GB', text: 'United Kingdom' }, { value: 'US', text: 'United States' }, { value: 'UM', text: 'United States Minor Outlying Islands' }, { value: 'UY', text: 'Uruguay' }, { value: 'UZ', text: 'Uzbekistan' }, { value: 'VU', text: 'Vanuatu' }, { value: 'VE', text: 'Venezuela, Bolivarian Republic of' }, { value: 'VN', text: 'Viet Nam' }, { value: 'VG', text: 'Virgin Islands, British' }, { value: 'VI', text: 'Virgin Islands, U.S.' }, { value: 'WF', text: 'Wallis and Futuna' }, { value: 'EH', text: 'Western Sahara' }, { value: 'YE', text: 'Yemen' }, { value: 'ZM', text: 'Zambia' }, { value: 'ZW', text: 'Zimbabwe' }];

var genderList = [{ text: 'Male', value: 'male' }, { text: 'Female', value: 'female' }, { text: 'Non-binary', value: 'nonBinary' }, { text: 'Transgender', value: 'transgender' }, { text: 'Genderqueer', value: 'genderqueer' }, { text: 'Nonconforming', value: 'nonconforming' }, { text: 'Prefer not to say', value: 'unspecified' }, { text: 'Other', value: 'other' }];

var underrepresentedList = [{ value: 'eastAsian', text: 'East Asian (China, Japan, Korea, Mongolia, Taiwan, etc.)' }, { value: 'southeastAsian', text: 'Southeast Asian (Thailand, Philippines, Indonesia, Singapore, Vietnam, etc.)' }, { value: 'southAsian', text: 'South Asian (India, Pakistan, Bangladesh, Sri Lanka, etc.)' }, { value: 'centralAsian', text: 'Central Asian (Kazakhstan, Kyrgyzstan, Tajikistan, Uzbekistan, Turkmenistan, Mongolia, Afghanistan, and northern Pakistan)' }, { value: 'northAsian', text: 'North Asian (Asian part of Russia)' }, { value: 'westAsian', text: 'West Asian (Middle Eastern, Arab, Iranian, Turkish, Kurdish, etc.)' }, { value: 'white', text: 'White/Caucasian/North American/South American/European' }, { value: 'african', text: 'African/African American/Afro-Caribbean/Afro-Latinx/Black' }, { value: 'northAfrican', text: 'North African (Algeria, Egypt, Morocco, Tunisia, Libya, etc)' }, { value: 'hispanicLatinx', text: 'Hispanic/Latinx (Mexico, Central America, the Caribbean including Puerto Rico and Haiti, South America including Brazil)' }, { value: 'indigenous', text: 'First Peoples/Indigenous (Aboriginal, Alaska Native, Inuit, Native American, or other original peoples)' }, { value: 'pacificIslander', text: 'Native Hawaiian/Pacific Islander (Maori, Samoan, and others)' }, { value: 'unspecified', text: 'Prefer not to say' }, { value: 'other', text: 'Other' }];

var languageList = [{ value: 'Abkhazian', text: 'Abkhazian' }, { value: 'Afar', text: 'Afar' }, { value: 'Afrikaans', text: 'AfrikaansJr' }, { value: 'Albanian', text: 'Albanian' }, { value: 'American Sign Language', text: 'American Sign Language (ASL)' }, { value: 'Amharic', text: 'Amharic' }, { value: 'Arabic', text: 'Arabic' }, { value: 'Aragonese', text: 'Aragonese' }, { value: 'Armenian', text: 'Armenian' }, { value: 'Assamese', text: 'Assamese' }, { value: 'Aymara', text: 'Aymara' }, { value: 'Azerbaijani', text: 'Azerbaijani' }, { value: 'Bashkir', text: 'Bashkir' }, { value: 'Basque', text: 'Basque' }, { value: 'Bengali', text: 'Bengali' }, { value: 'Bhutani', text: 'Bhutani' }, { value: 'Bihari', text: 'Bihari' }, { value: 'Bislama', text: 'Bislama' }, { value: 'Breton', text: 'Breton' }, { value: 'Bulgarian', text: 'Bulgarian' }, { value: 'Burmese', text: 'Burmese' }, { value: 'Byelorussian', text: 'Byelorussian' }, { value: 'Cambodian', text: 'Cambodian' }, { value: 'Catalan', text: 'Catalan' }, { value: 'Cherokee', text: 'Cherokee' }, { value: 'Chewa', text: 'Chewa' }, { value: 'Chinese', text: 'Chinese' }, { value: 'Corsican', text: 'Corsican' }, { value: 'Croatian', text: 'Croatian' }, { value: 'Czech', text: 'CzechJr' }, { value: 'Danish', text: 'Danish' }, { value: 'Divehi', text: 'Divehi' }, { value: 'Dutch', text: 'Dutch' }, { value: 'Edo', text: 'Edo' }, { value: 'English', text: 'English' }, { value: 'Esperanto', text: 'Esperanto' }, { value: 'Estonian', text: 'Estonian' }, { value: 'Faeroese', text: 'Faeroese' }, { value: 'Farsi', text: 'Farsi' }, { value: 'Fiji', text: 'Fiji' }, { value: 'Finnish', text: 'Finnish' }, { value: 'Flemish', text: 'Flemish' }, { value: 'French', text: 'French' }, { value: 'Frisian', text: 'Frisian' }, { value: 'Fulfulde', text: 'Fulfulde' }, { value: 'Galician', text: 'Galician' }, { value: 'Gaelic', text: 'Gaelic' }, { value: 'Georgian', text: 'Georgian' }, { value: 'German', text: 'German' }, { value: 'Greek', text: 'Greek' }, { value: 'Greenlandic', text: 'Greenlandic' }, { value: 'Guarani', text: 'Guarani' }, { value: 'Gujarati', text: 'Gujarati' }, { value: 'Haitian Creole', text: 'Haitian Creole' }, { value: 'Hausa', text: 'Hausa' }, { value: 'Hawaiian', text: 'Hawaiian' }, { value: 'Hebrew', text: 'Hebrew' }, { value: 'Hindi', text: 'Hindi' }, { value: 'Hungarian', text: 'Hungarian' }, { value: 'Ibibio', text: 'Ibibio' }, { value: 'Icelandic', text: 'Icelandic' }, { value: 'Ido', text: 'Ido' }, { value: 'Igbo', text: 'Igbo' }, { value: 'Indonesian', text: 'IndonesianJr' }, { value: 'Interlingua', text: 'Interlingua' }, { value: 'Interlingue', text: 'Interlingue' }, { value: 'Inuktitut', text: 'Inuktitut' }, { value: 'Inupiak', text: 'Inupiak' }, { value: 'Irish', text: 'Irish' }, { value: 'Italian', text: 'Italian' }, { value: 'Japanese', text: 'Japanese' }, { value: 'Kannada', text: 'Kannada' }, { value: 'Kanuri', text: 'Kanuri' }, { value: 'Kashmiri', text: 'Kashmiri' }, { value: 'Kazakh', text: 'Kazakh' }, { value: 'Kinyarwanda', text: 'Kinyarwanda' }, { value: 'Kirghiz', text: 'Kirghiz' }, { value: 'Kirundi', text: 'Kirundi' }, { value: 'Konkani', text: 'Konkani' }, { value: 'Korean', text: 'Korean' }, { value: 'Kurdish', text: 'Kurdish' }, { value: 'Laothian', text: 'Laothian' }, { value: 'Latin', text: 'Latin' }, { value: 'Latvian', text: 'Latvian' }, { value: 'Limburgish', text: 'Limburgish' }, { value: 'Lingala', text: 'Lingala' }, { value: 'Lithuanian', text: 'Lithuanian' }, { value: 'Macedonian', text: 'Macedonian' }, { value: 'Malagasy', text: 'Malagasy' }, { value: 'Malay', text: 'Malay' }, { value: 'Malayalam', text: 'Malayalam' }, { value: 'Maltese', text: 'Maltese' }, { value: 'Maori', text: 'Maori' }, { value: 'Marathi', text: 'Marathi' }, { value: 'Moldavian', text: 'Moldavian' }, { value: 'Mongolian', text: 'Mongolian' }, { value: 'Nauru', text: 'Nauru' }, { value: 'Nepali', text: 'Nepali' }, { value: 'Norwegian', text: 'Norwegian' }, { value: 'Occitan', text: 'Occitan' }, { value: 'Oriya', text: 'Oriya' }, { value: 'Oromo', text: 'Oromo' }, { value: 'Papiamentu', text: 'Papiamentu' }, { value: 'Pashto', text: 'Pashto' }, { value: 'Polish', text: 'Polish' }, { value: 'Portuguese', text: 'Portuguese' }, { value: 'Punjabi', text: 'Punjabi' }, { value: 'Quechua', text: 'Quechua' }, { value: 'Rhaeto-Romance', text: 'Rhaeto-Romance' }, { value: 'Romanian', text: 'Romanian' }, { value: 'Russian', text: 'Russian' }, { value: 'Sami', text: 'Sami' }, { value: 'Samoan', text: 'Samoan' }, { value: 'Sangro', text: 'Sangro' }, { value: 'Sanskrit', text: 'Sanskrit' }, { value: 'Serbian', text: 'Serbian' }, { value: 'Sesotho', text: 'Sesotho' }, { value: 'Setswana', text: 'Setswana' }, { value: 'Shona', text: 'Shona' }, { value: 'Sichuan Yi', text: 'Sichuan Yi' }, { value: 'Sindhi', text: 'Sindhi' }, { value: 'Sinhalese', text: 'Sinhalese' }, { value: 'Siswati', text: 'Siswati' }, { value: 'Slovak', text: 'Slovak' }, { value: 'Slovenian', text: 'Slovenian' }, { value: 'Somali', text: 'Somali' }, { value: 'Spanish', text: 'Spanish' }, { value: 'Sundanese', text: 'Sundanese' }, { value: 'Swahili', text: 'Swahili' }, { value: 'Swedish', text: 'Swedish' }, { value: 'Syriac', text: 'Syriac' }, { value: 'Tagalog', text: 'Tagalog' }, { value: 'Tajik', text: 'Tajik' }, { value: 'Tamazight', text: 'Tamazight' }, { value: 'Tamil', text: 'Tamil' }, { value: 'Tatar', text: 'Tatar' }, { value: 'Telugu', text: 'Telugu' }, { value: 'Thai', text: 'Thai' }, { value: 'Tibetan', text: 'Tibetan' }, { value: 'Tigrinya', text: 'TigrinyaJr' }, { value: 'Tonga', text: 'Tonga' }, { value: 'Tsonga', text: 'Tsonga' }, { value: 'Turkish', text: 'Turkish' }, { value: 'Turkmen', text: 'Turkmen' }, { value: 'Twi', text: 'Twi' }, { value: 'Uighur', text: 'Uighur' }, { value: 'Ukrainian', text: 'Ukrainian' }, { value: 'Urdu', text: 'Urdu' }, { value: 'Uzbek', text: 'Uzbek' }, { value: 'Venda', text: 'Venda' }, { value: 'Vietnamese', text: 'Vietnamese' }, { value: 'Volapük', text: 'Volapük' }, { value: 'Wallon', text: 'Wallon' }, { value: 'Welsh', text: 'Welsh' }, { value: 'Wolof', text: 'Wolof' }, { value: 'Xhosa', text: 'Xhosa' }, { value: 'Yi', text: 'Yi' }, { value: 'Yoruba', text: 'Yoruba' }, { value: 'Zulu', text: 'Zulu' }];

var months = [{ value: '1', text: 'January' }, { value: '2', text: 'February' }, { value: '3', text: 'March' }, { value: '4', text: 'April' }, { value: '5', text: 'May' }, { value: '6', text: 'June' }, { value: '7', text: 'July' }, { value: '8', text: 'August' }, { value: '9', text: 'September' }, { value: '10', text: 'October' }, { value: '11', text: 'November' }, { value: '12', text: 'December' }];

var years = [__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'y').format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'y').format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(2, 'y').format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(3, 'y').format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(4, 'y').format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(5, 'y').format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(6, 'y').format('YYYY'), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(7, 'y').format('YYYY')];

var svTypePreferences = ['In-person', 'Virtual'];

var svTypePreferencesSecond = ['In-person', 'Virtual', 'None'];

var timeZones = ['Western North America', 'South America and Eastern North America', 'Europe and Western Africa', 'Western/Central Asia and East Africa', 'East Asia and Oceania'];

var previousSvYears = ['2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008', '2007', '2006', '2005', '2004', '2003', '2002', '2001'];

var primaryTransportList = [{ value: '', text: 'Please Select' }, { value: 'plane', text: 'Airplane' }, { value: 'car', text: 'Car' }, { value: 'train', text: 'Train' }];

var roles = [{ value: '1', text: 'Administrator' }, { value: '2', text: 'Team Leader' }, { value: '3', text: 'Student Volunteer' }, { value: '4', text: 'Neutral' }];

var statuses = [{ value: null, text: 'Submitted' }, { value: '1', text: 'Offered' }, { value: '2', text: 'Waitlist' }, { value: '3', text: 'Rejected' }, { value: '4', text: 'Team Leader' }, { value: '5', text: 'Student Volunteer' }, { value: '6', text: 'SV - Housing' }, { value: '7', text: 'SV - Travel' }, { value: '8', text: 'Declined' }];

var standard = [{ value: '0', text: 'No' }, { value: '1', text: 'Maybe' }, { value: '2', text: 'Yes' }];

var essayScores = [{ value: '1', text: '1' }, { value: '2', text: '2' }, { value: '3', text: '3' }, { value: '4', text: '4' }, { value: '5', text: '5' }];

var conferenceLocations = [{ value: '303 A-C', text: '303 A-C' }, { value: '304 A-B', text: '304 A-B' }, { value: 'Ballroom A', text: 'Ballroom A' }, { value: 'Ballroom B', text: 'Ballroom B' }, { value: 'Ballroom C', text: 'Ballroom C' }, { value: 'Ballroom D', text: 'Ballroom D' }, { value: 'Ballroom E', text: 'Ballroom E' }, { value: 'Foyer', text: 'Foyer' }, { value: 'Hall B', text: 'Hall B' }, { value: 'Hall C/Experience Hall', text: 'Hall C/Experience Hall' }];

var amPm = [{ value: 'AM', text: 'AM' }, { value: 'PM', text: 'PM' }];

var shiftTimes = [{ value: '07:00', text: '7:00 AM' }, { value: '07:15', text: '7:15 AM' }, { value: '07:30', text: '7:30 AM' }, { value: '07:45', text: '7:45 AM' }, { value: '08:00', text: '8:00 AM' }, { value: '08:15', text: '8:15 AM' }, { value: '08:30', text: '8:30 AM' }, { value: '08:45', text: '8:45 AM' }, { value: '09:00', text: '9:00 AM' }, { value: '09:15', text: '9:15 AM' }, { value: '09:30', text: '9:30 AM' }, { value: '09:45', text: '9:45 AM' }, { value: '10:00', text: '10:00 AM' }, { value: '10:15', text: '10:15 AM' }, { value: '10:30', text: '10:30 AM' }, { value: '10:45', text: '10:45 AM' }, { value: '11:00', text: '11:00 AM' }, { value: '11:15', text: '11:15 AM' }, { value: '11:30', text: '11:30 AM' }, { value: '11:45', text: '11:45 AM' }, { value: '12:00', text: '12:00 PM' }, { value: '12:15', text: '12:15 PM' }, { value: '12:30', text: '12:30 PM' }, { value: '12:45', text: '12:45 PM' }, { value: '13:00', text: '1:00 PM' }, { value: '13:15', text: '1:15 PM' }, { value: '13:30', text: '1:30 PM' }, { value: '13:45', text: '1:45 PM' }, { value: '14:00', text: '2:00 PM' }, { value: '14:15', text: '2:15 PM' }, { value: '14:30', text: '2:30 PM' }, { value: '14:45', text: '2:45 PM' }, { value: '15:00', text: '3:00 PM' }, { value: '15:15', text: '3:15 PM' }, { value: '15:30', text: '3:30 PM' }, { value: '15:45', text: '3:45 PM' }, { value: '16:00', text: '4:00 PM' }, { value: '16:15', text: '4:15 PM' }, { value: '16:30', text: '4:30 PM' }, { value: '16:45', text: '4:45 PM' }, { value: '17:00', text: '5:00 PM' }, { value: '17:15', text: '5:15 PM' }, { value: '17:30', text: '5:30 PM' }, { value: '17:45', text: '5:45 PM' }, { value: '18:00', text: '6:00 PM' }, { value: '18:15', text: '6:15 PM' }, { value: '18:30', text: '6:30 PM' }, { value: '18:45', text: '6:45 PM' }, { value: '19:00', text: '7:00 PM' }, { value: '19:15', text: '7:15 PM' }, { value: '19:30', text: '7:30 PM' }, { value: '19:45', text: '7:45 PM' }, { value: '20:00', text: '8:00 PM' }];

var shirtSizes = [{ value: '', text: 'Select...' }, { value: 'xs', text: 'XS (Extra Small)' }, { value: 's', text: 'S (Small)' }, { value: 'm', text: 'M (Medium)' }, { value: 'l', text: 'L (Large)' }, { value: 'xl', text: 'XL (Extra Large)' }, { value: 'xxl', text: 'XXL (Double Extra Large)' }, { value: 'xxxl', text: 'XXXL (Triple Extra Large)' }];

var diets = [{ value: 'vegetarian', text: 'Vegetarian' }, { value: 'pescatarian', text: 'Pescatarian' }, { value: 'paleo', text: 'Paleo' }, { value: 'kosher', text: 'Kosher' }, { value: 'glutenFree', text: 'Gluten-free' }, { value: 'dairyFree', text: 'Dairy-free' }, { value: 'seafoodAllergy', text: 'Seafood allergy' }, { value: 'nutAllergy', text: 'Nut allergy' }, { value: 'other', text: 'Other' }];

var startTimes = [{ value: '07:00', text: '7:00 AM' }, { value: '07:30', text: '7:30 AM' }, { value: '08:00', text: '8:00 AM' }, { value: '08:30', text: '8:30 AM' }, { value: '09:00', text: '9:00 AM' }, { value: '09:30', text: '9:30 AM' }, { value: '10:00', text: '10:00 AM' }, { value: '10:30', text: '10:30 AM' }, { value: '11:00', text: '11:00 AM' }, { value: '11:30', text: '11:30 AM' }, { value: '12:00', text: '12:00 PM' }, { value: '12:30', text: '12:30 PM' }, { value: '13:00', text: '1:00 PM' }, { value: '13:30', text: '1:30 PM' }, { value: '14:00', text: '2:00 PM' }, { value: '14:30', text: '2:30 PM' }, { value: '15:00', text: '3:00 PM' }, { value: '15:30', text: '3:30 PM' }, { value: '16:00', text: '4:00 PM' }, { value: '16:30', text: '4:30 PM' }, { value: '17:00', text: '5:00 PM' }, { value: '17:30', text: '5:30 PM' }, { value: '18:00', text: '6:00 PM' }, { value: '18:30', text: '6:30 PM' }, { value: '19:00', text: '7:00 PM' }];

var shifts = [{ value: 'none', text: 'No Preference' }, { value: 'artGallery', text: 'Art Gallery' }, { value: 'etech', text: 'E-Tech' }, { value: 'greeter', text: 'Attendee Service' }, { value: 'vrtheater', text: 'Virtual Reality' }, { value: 'pavillion', text: 'Immersive Pavillion' }, { value: 'labs', text: 'Labs' }];

var days = [{ value: '2023-08-04', text: '04 August 2023' }, { value: '2023-08-05', text: '05 August 2023' }, { value: '2023-08-06', text: '06 August 2023' }, { value: '2023-08-07', text: '07 August 2023' }, { value: '2023-08-08', text: '08 August 2023' }, { value: '2023-08-09', text: '09 August 2023' }, { value: '2023-08-10', text: '10 August 2023' }];

var TLdays = [{ value: '2023-08-05', text: '05 August 2023' }, { value: '2023-08-06', text: '06 August 2023' }, { value: '2023-08-07', text: '07 August 2023' }, { value: '2023-08-08', text: '08 August 2023' }, { value: '2023-08-09', text: '09 August 2023' }, { value: '2023-08-10', text: '10 August 2023' }];

var referenceTypes = [{ value: '', text: 'Select...' }, { value: 'Professor/Teacher', text: 'Professor/Teacher' }, { value: 'Academic Advisor', text: 'Academic Advisor' }, { value: 'Professional Mentor', text: 'Professional Mentor' }, { value: 'Work Supervisor', text: 'Work Supervisor' }, { value: 'Coworker', text: 'Coworker' }, { value: 'Other', text: 'Other' }];

/***/ }),

/***/ "uCti":
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"output":{"shape":"Sg"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sr"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sg"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sw"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"LoginsToRemove":{"shape":"Ss"}}}},"UpdateIdentityPool":{"input":{"shape":"Sg"},"output":{"shape":"Sg"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"Sr":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Ss"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Ss":{"type":"list","member":{}},"Sw":{"type":"map","key":{},"value":{}},"S18":{"type":"map","key":{},"value":{}},"S1a":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),

/***/ "uL8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__("Q6FB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a57ffde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__("ptwS");
function injectStyle (ssrContext) {
  __webpack_require__("ZkVZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a57ffde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ud4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SvLiveAppStatus',
  data: function data() {
    return {
      appBtnDisabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('application', ['getProgress', 'isNewApp', 'isNotNewApp']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['profileIncomplete']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('application', ['isLoaded', 'isLoading', 'completed', 'teamLeader'])),
  methods: {
    goToApp: function goToApp(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/application/' + this.$store.state.application.step.toString());
    },
    goToProfile: function goToProfile(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/profile');
    }
  },
  created: function created() {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load');
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vcbH":
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),

/***/ "viJp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__("uL8o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Jury',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage'])),
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    navigation: __WEBPACK_IMPORTED_MODULE_3__components_Nav__["a" /* default */]
  }
});

/***/ }),

/***/ "vpE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Alert__ = __webpack_require__("yL53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_Register__ = __webpack_require__("VjfW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  props: {
    isRegistering: Boolean
  },
  data: function data() {
    return {
      isLoggingIn: false,
      isSendingEmail: false,
      forgotPasswordForm: false,
      form: {
        email: '',
        password: '',
        retypePassword: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage', 'isBeforeDeadline']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('user', ['forgotPassword']), {
    disabled: function disabled() {
      if (this.form.email === '' || this.form.password === '' || this.isLoggingIn) {
        return true;
      }
      return false;
    },
    isSamePassword: function isSamePassword() {
      return this.form.password !== '' && this.form.retypePassword !== '' && this.form.password === this.form.retypePassword;
    }
  }),
  methods: {
    signUpToggle: function signUpToggle() {
      this.$emit('toggle');
    },
    handleSubmit: function handleSubmit(e) {
      var _this = this;

      e.preventDefault();
      this.isLoggingIn = true;
      this.$store.dispatch('user/login', this.form).then(function () {
        _this.isLoggingIn = false;
      }).catch(function (err) {
        _this.isLoggingIn = false;
        console.log(err.message);
      });
    },
    handleForgotPasswordSubmit: function handleForgotPasswordSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      this.isSendingEmail = true;
      this.$store.dispatch('user/forgotPassword', this.form.email).then(function () {
        _this2.forgotPassword = false;
        _this2.isSendingEmail = false;
      }).catch(function (err) {
        console.log(err.message);
        _this2.forgotPassword = false;
        _this2.isSendingEmail = true;
      });
    },
    handleChangePasswordSubmit: function handleChangePasswordSubmit(e) {
      var _this3 = this;

      e.preventDefault();
      this.isLoggingIn = true;
      this.$store.dispatch('user/changePassword', { password: this.form.password, retypePassword: this.form.retypePassword }).then(function () {
        _this3.isLoggingIn = false;
      }).catch(function (err) {
        _this3.isLoggingIn = false;
        console.log(err.message);
      });
    },

    toggleForgotPassword: function toggleForgotPassword() {
      this.forgotPassword = !this.forgotPassword;
    },
    toggleForgotPasswordForm: function toggleForgotPasswordForm() {
      this.forgotPasswordForm = !this.forgotPasswordForm;
    }
  },
  components: {
    alert: __WEBPACK_IMPORTED_MODULE_2__components_Alert__["a" /* default */],
    register: __WEBPACK_IMPORTED_MODULE_3__components_user_Register__["a" /* default */]
  },
  created: function created() {
    if (this.$store.state.user.changedPassword) {
      this.$store.commit('message', {
        message: 'Password successfully changed.'
      });
      // This will reinitialize all user data
      this.$store.commit('user/logout');
    }
  }
});

/***/ }),

/***/ "wMq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__ = __webpack_require__("2DBr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__ = __webpack_require__("rydV");








var jwtDecode = __webpack_require__("ytdl");

var userPool = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["c" /* CognitoUserPool */]({
  UserPoolId: 'us-east-1_0U1GDdrNq',
  ClientId: '52aaqrovrh2m9setbud72thkcp'
});

function HEXID() {
  // Returns a random 5-digit hex hash
  return Math.floor((1 + Math.random()) * 0x100000).toString(16).substring(1);
};

var attributeNames = {
  id: 'id',
  given_name: 'firstName',
  family_name: 'lastName',
  nickname: 'nickname',
  address: 'address',
  birthdate: 'birthdate',
  gender: 'gender',
  gender_identity: 'genderIdentity',
  underrepresented: 'underrepresented',
  underrepresented_group: 'underrepresentedGroup',
  disability: 'disability',
  disability_type: 'disabilityType',
  phone_number: 'phoneNumber',
  sv_id: 'svid',
  can_call: 'canCall',
  can_text: 'canText',
  languages: 'languages',
  email: 'email'
};

var initState = function initState() {
  return {
    isAuthenticated: false,
    confirmRegistration: false,
    forgotPassword: false,
    changedPassword: false,
    passwordResetToken: '',
    loadingAttributes: false,
    loadedAttributes: false,
    isAdmin: false,
    isTeamLeader: false,
    session: {
      accessToken: null
    },
    profile: {
      id: 0,
      svid: '',
      email: '',
      firstName: '',
      lastName: '',
      nickname: '',
      birthdate: '',
      gender: [],
      genderIdentity: '',
      underrepresented: [],
      underrepresentedGroup: '',
      disability: '',
      disabilityType: '',
      address: {
        address1: '',
        address2: '',
        city: '',
        region: '',
        country: '',
        postalCode: ''
      },
      languages: [],
      phoneNumber: '',
      canText: '',
      canCall: ''
    }
  };
};

var user = {
  namespaced: true,
  state: initState(),
  mutations: {
    setSession: function setSession(state, accessToken) {
      state.session.accessToken = accessToken;
    },
    logout: function logout(state) {
      var init = initState();
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(init).forEach(function (key) {
        state[key] = init[key];
      });
    },
    authenticateSuccess: function authenticateSuccess(state, _ref) {
      var user = _ref.user,
          session = _ref.session;

      state.isAuthenticated = true;
      state.isVerified = true;
      state.session.accessToken = session.access_token;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(attributeNames).forEach(function (att) {
        if (att === 'address') {
          if (user.address !== null) {
            // Parse JSON string
            state.profile.address = user[att];
          }
        } else if (att === 'languages' && user.languages !== null) {
          if (user.languages !== '') {
            // Split comma separated list and map them to language options
            var lang = user.languages.split(',');
            lang = lang.map(function (v) {
              return __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["e" /* languageList */].find(function (o) {
                return o.value === v;
              });
            });
            state.profile.languages = lang;
          } else {
            state.profile.languages = [];
          }
        } else if (att === 'gender' && user.gender !== null) {
          if (user.gender !== '') {
            // Split comma separated list and map them to gender options
            var gender = user.gender.split(/\{?"(,")?\}?/);
            gender = gender.filter(function (v) {
              return __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["d" /* genderList */].find(function (o) {
                return o.value === v;
              });
            });
            state.profile.gender = gender;
          } else {
            state.profile.gender = [];
          }
        } else if (att === 'underrepresented' && user.underrepresented !== null) {
          if (user.underrepresented !== '') {
            // Split comma separated list and map them to race options
            var underrepresented = user.underrepresented.split(/\{?"(,")?\}?/);
            underrepresented = underrepresented.filter(function (v) {
              return __WEBPACK_IMPORTED_MODULE_6__util_SelectLists__["p" /* underrepresentedList */].find(function (o) {
                return o.value === v;
              });
            });
            state.profile.underrepresented = underrepresented;
          } else {
            state.profile.underrepresented = [];
          }
        } else {
          state.profile[attributeNames[att]] = user[att];
        }
      });
      state.loadedAttributes = true;
      var token = jwtDecode(session.access_token);
      if (token.rol === 'Team-Leader') {
        state.isTeamLeader = true;
      }
    },
    authenticateFailure: function authenticateFailure(state) {
      state.isAuthenticated = false;
    },
    registerSuccess: function registerSuccess(state, _ref2) {
      var user = _ref2.user;

      state.username = user.username;
      state.session = user.session;
      state.isVerified = user.userConfirmed;
      state.confirmRegistration = true;
    },
    setForgottenPasswordToken: function setForgottenPasswordToken(state, token) {
      state.passwordResetToken = token;
      state.forgotPassword = true;
    },
    changedPassword: function changedPassword(state) {
      state.passwordResetToken = '';
      state.forgotPassword = false;
    },
    confirmRegistration: function confirmRegistration(state) {
      state.confirmRegistration = false;
      state.isVerified = true;
    },
    verifySuccess: function verifySuccess(state) {
      state.isVerified = true;
    },
    updateProfile: function updateProfile(state, _ref3) {
      var name = _ref3.name,
          value = _ref3.value;

      state.profile[name] = value;
    },
    updateProfileAddress: function updateProfileAddress(state, _ref4) {
      var name = _ref4.name,
          value = _ref4.value;

      state.profile.address[name] = value;
    },
    updateProfileEmergencyContact: function updateProfileEmergencyContact(state, _ref5) {
      var name = _ref5.name,
          value = _ref5.value;

      state.profile.emergencyContact[name] = value;
    },
    loadProfile: function loadProfile(state, attributes) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(attributes).forEach(function (att) {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(attributes[att]) === 'object') {
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(attributes[att]).forEach(function (subAtt) {
            state.profile[att][subAtt] = attributes[att][subAtt];
          });
        }
        state.profile[att] = attributes[att];
      });
      state.loadingAttributes = false;
      state.loadedAttributes = true;
    },
    isLoadingProfile: function isLoadingProfile(state) {
      state.loadingAttributes = true;
    },
    needsVerification: function needsVerification(state) {
      state.isVerified = false;
    },
    forgotPassword: function forgotPassword(state, email) {
      state.forgotPassword = true;
      state.profile.email = email;
    }
  },
  getters: {
    getGenders: function getGenders(state) {
      return state.profile.gender;
    },
    getEthnicity: function getEthnicity(state) {
      return state.profile.underrepresented;
    },
    getLanguages: function getLanguages(state) {
      return state.profile.languages;
    },
    isConfirmedSv: function isConfirmedSv(state, getters, rootState, rootGetters) {
      return rootGetters.isAfterDeadline && rootState.application.statusId === 5;
    },
    profileIncomplete: function profileIncomplete(state) {
      if (!state.profile.birthdate || !state.profile.gender || !state.profile.underrepresented || !state.profile.disability || !state.profile.firstName || !state.profile.lastName || !state.profile.phoneNumber || !state.profile.address.address1 || !state.profile.address.city || !state.profile.address.region || !state.profile.address.country || !state.profile.address.postalCode) {
        return true;
      }
      return false;
    }
  },
  actions: {
    login: function login(_ref6, _ref7) {
      var commit = _ref6.commit;
      var email = _ref7.email,
          password = _ref7.password;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'users/login', {
          method: 'POST',
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            email: email,
            password: password
          })
        }).then(function (response) {
          response.json().then(function (payload) {
            if (payload.success) {
              commit('authenticateSuccess', payload.data);
              localStorage.setItem('accessToken', payload.data.session.access_token);
              __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/dashboard');
              resolve();
            } else {
              commit('authenticateFailure');
              commit('error', payload.data, { root: true });
              reject(payload.data.err);
            }
          });
        }).catch(function (err) {
          commit('authenticateFailure');
          commit('error', err, { root: true });
          reject(err);
        });
      });
    },
    logout: function logout(_ref8) {
      var commit = _ref8.commit;
      var verify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      commit('logout');
      commit('application/appClearData', null, { root: true });
      commit('schedule/clearSchedule', null, { root: true });
      localStorage.removeItem('accessToken');
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/');
    },
    register: function register(_ref9, _ref10) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;
      var firstName = _ref10.firstName,
          lastName = _ref10.lastName,
          email = _ref10.email,
          password = _ref10.password;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'users/register', {
          method: 'POST',
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            first_name: firstName,
            last_name: lastName,
            email: email,
            password: password,
            svid: HEXID()
          })
        }).then(function (response) {
          response.json().then(function (payload) {
            if (payload.success) {
              // Now we attempt to login the newly registered user
              dispatch('login', { email: email, password: password });
              resolve();
            } else {
              if (payload.data.error.code === 'EMESSAGE') {
                // User is created, but email was not able to be sent
                dispatch('login', { email: email, password: password });
                resolve();
              } else {
                commit('error', payload.data, { root: true });
                reject(payload.data.err);
              }
            }
          });
        }).catch(function (err) {
          commit('error', err, { root: true });
          reject(err);
        });
      });
    },
    forgotPassword: function forgotPassword(_ref11, email) {
      var commit = _ref11.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'users/forgot-password', {
          method: 'POST',
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ email: email })
        }).then(function (response) {
          response.json().then(function (payload) {
            if (payload.success) {
              commit('message', { message: 'Check your email for a link to reset your password.' }, { root: true });
              resolve();
            } else {
              commit('error', payload.data, { root: true });
              reject(payload.data.err);
            }
          });
        }).catch(function (err) {
          commit('error', err, { root: true });
          reject(err);
        });
      });
    },
    changePassword: function changePassword(_ref12, _ref13) {
      var commit = _ref12.commit,
          state = _ref12.state;
      var password = _ref13.password,
          retypePassword = _ref13.retypePassword;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (password !== retypePassword) {
          var error = { message: 'Passwords do not match', error: {} };
          commit('error', error, { root: true });
          reject(error);
        }

        fetch('https://api.siggraphsv.org/' + 'users/change-password', {
          method: 'POST',
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ token: state.passwordResetToken, password: password })
        }).then(function (response) {
          response.json().then(function (payload) {
            if (payload.success) {
              commit('message', { message: 'Successfully changed password' }, { root: true });
              commit('changedPassword');
              resolve();
            } else {
              commit('error', payload.data, { root: true });
              reject(payload.data.err);
            }
          });
        }).catch(function (err) {
          console.log(err);
          commit('error', err, { root: true });
          reject(err);
        });
      });
    },
    loadAttributes: function loadAttributes(_ref14) {
      var commit = _ref14.commit,
          state = _ref14.state;

      commit('isLoadingProfile');
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'users/profile', {
          headers: {
            'Authorization': state.session.accessToken
          }
        }).then(function (response) {
          response.json().then(function (payload) {
            if (payload.success) {
              commit('authenticateSuccess', payload.data);
              resolve();
            } else {
              commit('error', payload.data, { root: true });
              reject(payload.data.err);
            }
          });
        }).catch(function (err) {
          console.log(err);
          commit('error', err, { root: true });
          reject(err);
        });
      });
    },
    saveAttributes: function saveAttributes(_ref15) {
      var commit = _ref15.commit,
          state = _ref15.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'users/profile', {
          method: 'POST',
          headers: {
            'Authorization': state.session.accessToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.profile)
        }).then(function (response) {
          response.json().then(function (payload) {
            if (payload.success) {
              commit('message', { message: 'Profile Updated' }, { root: true });
              resolve();
            } else {
              commit('error', payload.data, { root: true });
              reject(payload.data.err);
            }
          });
        }).catch(function (err) {
          commit('error', err, { root: true });
          reject(err);
        });
      });
    },
    updateEmail: function updateEmail(_ref16, email) {
      var commit = _ref16.commit,
          state = _ref16.state,
          dispatch = _ref16.dispatch;

      var cognitoUser = userPool.getCurrentUser();
      cognitoUser.signInUserSession = state.session;
      cognitoUser.updateAttributes([new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["b" /* CognitoUserAttribute */]({
        Name: 'email',
        Value: email
      })], function (err, result) {
        if (err) {
          commit('error', err, { root: true });
        } else {
          dispatch('logout', true);
        }
      });
    },
    sendForgotPasswordEmail: function sendForgotPasswordEmail(_ref17, email) {
      var commit = _ref17.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var cognitoUser = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["a" /* CognitoUser */]({
          Username: email,
          Pool: userPool
        });
        cognitoUser.forgotPassword({
          onSuccess: function onSuccess(data) {
            commit('forgotPassword', email);
            resolve();
          },
          onFailure: function onFailure(err) {
            commit('error', err, { root: true });
            reject(err);
          }
        });
      });
    },
    confirmRegistration: function confirmRegistration(_ref18, _ref19) {
      var commit = _ref18.commit,
          state = _ref18.state,
          dispatch = _ref18.dispatch;
      var email = _ref19.email,
          password = _ref19.password,
          verificationCode = _ref19.verificationCode;

      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["a" /* CognitoUser */]({
        Username: email,
        Pool: userPool
      });
      cognitoUser.confirmRegistration(verificationCode, true, function (err, result) {
        if (err) {
          commit('error', err, { root: true });
        } else {
          commit('confirmRegistration');
          dispatch('login', { email: email, password: password });
        }
      });
    },
    submitConfirmation: function submitConfirmation(_ref20, _ref21) {
      var commit = _ref20.commit,
          state = _ref20.state;
      var data = _ref21.data;

      // Add profile data to confirmation submission
      data.sv_id = state.profile.id;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'users/confirm', {
          method: 'POST',
          headers: {
            'Authorization': state.session.accessToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              resolve();
            } else {
              commit('error', payload.err, { root: true });
              reject(payload.err);
            }
          });
        });
      });
    },
    declineAcceptance: function declineAcceptance(_ref22) {
      var commit = _ref22.commit,
          state = _ref22.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fetch('https://api.siggraphsv.org/' + 'users/decline', {
          method: 'POST',
          headers: {
            'Authorization': state.session.accessToken
          },
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ sv_id: state.profile.id })
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (payload.success) {
              resolve();
            } else {
              commit('error', payload.err, { root: true });
              reject(payload.err);
            }
          });
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "xCnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TlSchedule_vue__ = __webpack_require__("zZ2y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f2cdb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TlSchedule_vue__ = __webpack_require__("UMBx");
function injectStyle (ssrContext) {
  __webpack_require__("Cwdy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TlSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f2cdb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TlSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "yL53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__("zvUr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df1bc48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__("QD3X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df1bc48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ylCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("a0rH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6af43f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("4MzS");
function injectStyle (ssrContext) {
  __webpack_require__("ztXG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6af43f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yniD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_SelectLists__ = __webpack_require__("rydV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreateShiftSwapRequest',
  props: ['id'],
  data: function data() {
    return {
      selectedDay: 'none',
      days: __WEBPACK_IMPORTED_MODULE_4__util_SelectLists__["c" /* days */],
      shift: {
        day: '2019-07-26',
        start_time: '',
        end_time: '',
        venue: {
          name: '',
          location: ''
        }
      },
      fields: [{ key: 'day', label: 'Day' }, { key: 'start_time', label: 'Start Time' }, { key: 'end_time', label: 'End Time' }, { key: 'name', label: 'Student Volunteer' }, { key: 'accept', label: 'Accept' }],
      shiftFields: [{ key: 'day', label: 'Day' }, { key: 'start_time', label: 'Start Time' }, { key: 'end_time', label: 'End Time' }, { key: 'venue', label: 'Venue' }, { key: 'select', label: 'Select' }],
      selectedRequest: {
        shift: {
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        }
      },
      loadingShifts: false,
      shiftsLoaded: false,
      searchedShifts: [],
      selectedVenue: 'none',
      selectedShift: {
        id: null,
        day: '2019-07-26',
        start_time: '',
        end_time: '',
        venue: {
          name: '',
          location: ''
        }
      },
      selectedVolunteer: {
        id: null,
        given_name: '',
        nickname: '',
        family_name: ''
      },
      isCreating: null
    };
  },

  methods: {
    goBack: function goBack() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/schedule/sv');
    },
    formattedDay: function formattedDay(day) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).utc().format('ddd MMM Do');
    },
    acceptRequest: function acceptRequest(requestId) {
      var request = this.shiftSwapRequests.openRequests.find(function (r) {
        return r.id === requestId;
      });
      this.selectedRequest.shift = request.shift;
      this.$refs.acceptModal.show();
    },
    getShifts: function getShifts() {
      var _this = this;

      this.selectedVenue = 'none';
      if (this.selectedDay === 'none') {
        this.searchedShifts = [];
        this.shiftsLoaded = false;
      } else {
        this.shiftsLoaded = false;
        this.loadingShifts = true;
        this.$store.dispatch('schedule/getShiftsByDay', this.selectedDay).then(function (shifts) {
          _this.searchedShifts = shifts;
          _this.shiftsLoaded = true;
          _this.loadingShifts = false;
        }).catch(function (err) {
          console.log(err);
          _this.loadingShifts = false;
        });
      }
    },
    formatName: function formatName(sv) {
      var name = sv.given_name + ' ' + sv.family_name;
      if (sv.nickname && sv.nickname !== '' && sv.nickname !== sv.given_name) {
        name = sv.given_name + ' "' + sv.nickname + '" ' + sv.family_name;
      }
      return name;
    },
    resetShiftSelect: function resetShiftSelect() {
      this.selectedShift = {
        id: null,
        day: '2019-07-26',
        start_time: '',
        end_time: '',
        venue: {
          name: '',
          location: ''
        }
      };
      this.selectedVolunteer = {
        id: null,
        given_name: '',
        nickname: '',
        family_name: ''
      };
    },
    createRequest: function createRequest(shiftId, svid) {
      this.resetShiftSelect();
      if (shiftId !== null) {
        this.selectedShift = this.searchedShifts.find(function (shift) {
          return shift.id === shiftId;
        });
      }
      if (svid !== null) {
        this.selectedVolunteer = this.selectedShift.student_volunteers.find(function (sv) {
          return sv.id === svid;
        });
      }
      this.$refs.createModal.show();
    },
    createOpenRequest: function createOpenRequest() {
      this.resetShiftSelect();
      this.$refs.createOpenModal.show();
    },
    confirmCreateRequest: function confirmCreateRequest() {
      var _this2 = this;

      this.isCreating = this.selectedShift.id;
      var request = {
        shift_id: this.id,
        swapped_shift_id: this.selectedShift.id,
        swapped_svid: this.selectedVolunteer.username
      };
      this.$store.dispatch('schedule/createRequest', request).then(function () {
        _this2.goBack();
      });
    },
    confirmAcceptRequest: function confirmAcceptRequest() {
      var _this3 = this;

      var request = {
        shift_swap_request_id: this.selectedRequest.id,
        swapped_shift_id: this.id
      };
      this.$store.dispatch('schedule/acceptRequest', request).then(function () {
        _this3.goBack();
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('schedule', ['getShift', 'hasOpenRequests', 'getQualifyingOpenRequests']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('schedule', ['isLoaded', 'shiftSwapRequestsLoaded', 'shiftSwapRequests', 'shifts']), {
    daySelected: function daySelected() {
      return this.selectedDay !== 'none';
    },
    venues: function venues() {
      var venues = [{ value: 'none', text: 'Choose a venue' }];
      this.searchedShifts.forEach(function (s) {
        var index = venues.findIndex(function (v) {
          return v.value === s.venue.name;
        });
        if (index === -1) {
          venues.push({ value: s.venue.name, text: s.venue.name });
        }
      });
      return venues;
    },
    qualifyingShifts: function qualifyingShifts() {
      var _this4 = this;

      return this.searchedShifts.filter(function (shift) {
        // No unswappable shifts
        var swappable = shift.swappable;

        // No shifts that this user is already assigned to
        var isAssigned = _this4.shifts.find(function (s) {
          return s.id === shift.id;
        });

        // No shifts that conflict
        var start = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc();
        var end = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment___default()(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc();
        var overlap = _this4.shifts.find(function (s) {
          var shiftStart = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment___default()(s.day).utc().format('Y-MM-DD') + ' ' + s.start_time, 'America/Los_Angeles').utc();
          var shiftEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(__WEBPACK_IMPORTED_MODULE_2_moment___default()(s.day).utc().format('Y-MM-DD') + ' ' + s.end_time, 'America/Los_Angeles').utc();
          if (start.isBefore(shiftStart) && end.isAfter(shiftStart)) {
            return true;
          }
          if (start.isAfter(shiftStart) && start.isBefore(shiftEnd)) {
            return true;
          }
          return false;
        });

        // No shifts from the past
        var inPast = __WEBPACK_IMPORTED_MODULE_2_moment___default()().isAfter(start);

        if (!swappable || isAssigned !== undefined || overlap !== undefined || inPast) {
          return false;
        }
        return true;
      });
    }
  }),
  created: function created() {
    var _this5 = this;

    if (!this.$store.state.schedule.isLoaded) {
      this.$store.dispatch('schedule/load').then(function () {
        _this5.shift = _this5.getShift(_this5.id);
      });
    } else {
      this.shift = this.getShift(this.id);
    }
    if (this.days[0].value !== 'none') {
      this.days.unshift({ value: 'none', text: 'Choose a Day' });
    }
    if (!this.$store.state.schedule.swapShiftsLoaded) {
      this.$store.dispatch('schedule/loadShiftSwapRequests');
    }
  }
});

/***/ }),

/***/ "z9Kd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__ = __webpack_require__("rydV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__("9BHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var generateVuexSetters = function generateVuexSetters(fields) {
  var computed = {};
  fields.forEach(function (field) {
    computed[field] = {
      get: function get() {
        return this.$store.state.application.data[field];
      },
      set: function set(value) {
        this.$store.commit('application/updateField', { name: field, value: value });
      }
    };
  });
  return computed;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppStepOne',
  data: function data() {
    var _this = this;

    return {
      countries: __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__["b" /* countries */],
      months: __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__["f" /* months */],
      years: __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__["q" /* years */],
      previousSvYears: __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__["g" /* previousSvYears */],
      referenceTypes: __WEBPACK_IMPORTED_MODULE_1__util_SelectLists__["i" /* referenceTypes */],
      dropzoneOptions: {
        acceptedFileTypes: ['image/jpg', 'image/jpeg', 'application/pdf'],
        url: 'changeme',
        maxFiles: 1,
        method: 'PUT',
        autoProcessQueue: false,
        renameFile: function renameFile(file) {
          var filename = _this.$store.state.user.profile.svid + '.' + file.type.substring(file.type.indexOf('/') + 1);
          return filename;
        }
      },
      wordCountText: '25 words remaining',
      wordLimitClass: 'under-limit',
      disabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, generateVuexSetters(['schoolName', 'schoolCity', 'schoolState', 'schoolCountry', 'closeProximity', 'expectedGraduationMonth', 'expectedGraduationYear', 'interestAnimation', 'interestProductionDesign', 'interestTechnical', 'interestWeb', 'interestDesign', 'interestMarketing', 'interestGaming', 'otherInterests', 'haveNotAttended', 'haveAttended', 'haveVolunteered', 'yearsVolunteered', 'haveAttendedAsia', 'haveVolunteeredAsia', 'yearsVolunteeredAsia', 'firstReferenceType', 'firstReferenceFirstName', 'firstReferenceLastName', 'firstReferenceEmail', 'secondReferenceType', 'secondReferenceFirstName', 'secondReferenceLastName', 'secondReferenceEmail', 'knowledgeFinalCutPro', 'knowledgeAdobePremiere', 'knowledgeAdobeAfterEffects', 'knowledgeAdobePhotoshop', 'knowledgeAdobeIllustrator', 'knowledgeCanva', 'knowledgeClosedCaptioningVideos']), {
    proofOfEnrollment: {
      get: function get() {
        return this.$store.state.application.data.proofOfEnrollment;
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('application', ['proofOfEnrollmentExists', 'proofOfEnrollmentFileSize', 'getDataURL', 'getExpectedGraduationMonth', 'getExpectedGraduationYear', 'getYearsVolunteered', 'getYearsVolunteeredAsia']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])('application', ['isLoaded', 'isLoading'])),
  methods: {
    addedFile: function addedFile(file) {
      var _this2 = this;

      if (file.size < 4000000) {
        this.$store.dispatch('application/getSignedUrl', { fileType: file.type }).then(function (url) {
          _this2.$refs.proofOfEnrollment.setOption('url', url);
          _this2.$refs.proofOfEnrollment.processQueue();
        });
      } else {
        // File is too big
        this.$refs.proofOfEnrollment.removeFile(file);
      }
    },
    removedFile: function removedFile(file) {
      if (file.size > 4000000) {
        this.$store.commit('error', { message: 'File size is too large. Please keep uploads under 4 MB' });
      }
    },
    sendingEvent: function sendingEvent(file, xhr) {
      var _send = xhr.send;
      xhr.send = function () {
        _send.call(xhr, file);
      };
    },
    uploadSuccessful: function uploadSuccessful(file, response) {
      if (file.type === 'application/pdf') {
        file.dataURL = '';
      }
      this.$store.commit('application/fileUploaded', {
        name: file.upload.filename,
        type: file.type,
        dataURL: file.dataURL,
        size: file.size
      });
      this.$store.dispatch('application/save');
    },
    removeProofOfEnrollment: function removeProofOfEnrollment(e) {
      this.$store.commit('application/removeProofOfEnrollment');
    },
    updateExpectedGraduationMonth: function updateExpectedGraduationMonth(value) {
      this.$store.commit('application/updateField', { name: 'expectedGraduationMonth', value: value.value });
    },
    updateExpectedGraduationYear: function updateExpectedGraduationYear(value) {
      this.$store.commit('application/updateField', { name: 'expectedGraduationYear', value: value });
    },
    updateYearsVolunteered: function updateYearsVolunteered(value) {
      this.$store.commit('application/updateField', { name: 'yearsVolunteered', value: value });
    },
    updateYearsVolunteeredAsia: function updateYearsVolunteeredAsia(value) {
      this.$store.commit('application/updateField', { name: 'yearsVolunteeredAsia', value: value });
    },
    wordCount: function wordCount(limit) {
      var wordCount = this.otherInterests.split(/\s+/).length - 1;
      var remaining = limit - wordCount;
      this.wordCountText = remaining < 0 ? (remaining * -1).toString() + ' words over the limit' : remaining.toString() + ' words remaining';
      this.wordLimitClass = remaining < 0 ? 'over-limit' : 'under-limit';
    },
    nextStep: function nextStep(e) {
      var _this3 = this;

      e.preventDefault();
      this.disabled = true;
      if (__WEBPACK_IMPORTED_MODULE_7_moment___default()().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/dashboard');
      } else {
        this.$store.commit('application/updateStep', 2);
        this.$store.dispatch('application/save').then(function () {
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'stepTwo' });
          _this3.disabled = false;
        }).catch(function (err) {
          console.log(err.message);
          _this3.disabled = false;
        });
      }
    }
  },
  created: function created() {
    var _this4 = this;

    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(function () {
        if (_this4.$store.getters['pastTLAppDeadline'] && _this4.$store.state.application.teamLeader) {
          _this4.$store.commit('application/disableTeamLeader');
        }
        if (_this4.$store.state.application.completed) {
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/dashboard');
        } else if (_this4.$store.state.application.isNew) {
          _this4.$store.dispatch('application/save');
        } else if (_this4.$store.state.application.step !== 1) {
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/application/' + _this4.$store.state.application.step.toString());
        }
      });
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader');
    }
    if (this.$store.state.application.completed) {
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/dashboard');
    }
  },
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  }
});

/***/ }),

/***/ "zZ2y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_SelectLists__ = __webpack_require__("rydV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TlSchedule',
  data: function data() {
    return {
      selectedDay: '2023-08-05',
      selectedVenue: 'all',
      days: __WEBPACK_IMPORTED_MODULE_2__util_SelectLists__["a" /* TLdays */],
      startTimes: __WEBPACK_IMPORTED_MODULE_2__util_SelectLists__["k" /* startTimes */],
      selectedShift: {
        start_time: '00:00',
        end_time: '01:00',
        swappable: false,
        day: '2023-08-05',
        sv_slots: 1,
        special: '',
        venue: {
          name: '',
          location: '',
          teamLeaders: []
        }
      }
    };
  },

  methods: {
    formattedDay: function formattedDay(day) {
      return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(day).utc().format('ddd MMM Do');
    },
    selectShift: function selectShift(shift) {
      this.selectedShift = shift;
      this.$refs.shiftModal.show();
    },
    goToShift: function goToShift(id) {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/schedule/shift/' + id);
    },
    closeModal: function closeModal() {
      this.selectedShift = {
        start_time: '00:00',
        end_time: '01:00',
        swappable: false,
        day: '2023-08-06',
        sv_slots: 1,
        special: '',
        venue: {
          name: '',
          location: '',
          teamLeaders: []
        }
      };
      this.$refs.shiftModal.hide();
    },
    getVenueWidth: function getVenueWidth(venues) {
      var width = 100;
      // if (this.$mq !== 'mobile') {
      //   width = 100 / venues
      // }
      return 'width: ' + width + '%;';
    },
    getLocation: function getLocation(shift) {
      // let start = this.getTimestamp(shift.start_time)
      // let duration = this.getTimestamp(shift.end_time) - start
      // let top = 50 * (start - this.getTimestamp(this.startTimes[0].value)) / 1800
      // let height = 50 * duration / 1800
      if (this.$mq !== 'mobile') {
        // return 'top: ' + top + 'px; height: ' + height + 'px;'
        return 'top: ' + top + 'px; height: 100px; margin-top: 5px; margin-bottom: 5px;';
      } else {
        // return 'top: ' + top + 'px; height: 100px;'
        return 'top: ' + top + 'px; height: 190px;';
      }
    },
    getTimelineHeight: function getTimelineHeight() {
      // if (this.$mq === 'mobile') {
      return 'height: 100%;';
      // }
      // let sections = (this.startTimes.length * 50)
      // return 'height: ' + sections + 'px;'
    },
    getTimestamp: function getTimestamp(time) {
      var timeArray = time.split(':');
      return parseInt(timeArray[0] * 60 * 60 + parseInt(timeArray[1]) * 60);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('schedule', ['shifts', 'isLoaded']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('schedule', ['nextShift']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['isError', 'isMessage']), {
    dayShifts: function dayShifts() {
      var _this = this;

      return this.shifts.filter(function (shift) {
        return _this.selectedDay === __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(shift.day).utc().format('Y-MM-DD');
      });
    },
    venueSelect: function venueSelect() {
      var venueSelect = [{ value: 'all', text: 'Show All' }];
      this.shifts.forEach(function (s) {
        var existingVenue = venueSelect.findIndex(function (v) {
          return v.value === s.venue.name || s.venue.name.includes('History') && v.value === 'History';
        });
        if (existingVenue === -1) {
          if (s.venue.name.includes('History')) {
            venueSelect.push({
              value: 'History',
              text: 'History'
            });
          } else {
            venueSelect.push({
              value: s.venue.name,
              // text: s.venue.name + ' - ' + s.venue.location
              text: s.venue.name
            });
          }
        }
      });
      return venueSelect;
    },
    dayVenues: function dayVenues() {
      var _this2 = this;

      var venues = [];
      this.shifts.forEach(function (s) {
        var existingVenue = venues.findIndex(function (v) {
          return v.name === s.venue.name || s.venue.name.includes('History') && v.name === 'History';
        });
        if (existingVenue !== -1) {
          if (_this2.selectedDay === __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(s.day).utc().format('Y-MM-DD')) {
            if (s.venue.name.includes('History')) {
              var split = s.venue.name.split(', ');
              if (split.length > 1) {
                s.venue.location = split[1] + ': ' + s.venue.location;
              }
            }
            venues[existingVenue].shifts.push(s);
          }
        } else {
          var venue = s.venue;
          venue.shifts = [];
          if (_this2.selectedDay === __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(s.day).utc().format('Y-MM-DD')) {
            if (s.venue.name.includes('History')) {
              venue.name = 'History';
              var _split = s.venue.name.split(', ');
              if (_split.length > 1) {
                s.venue.location = _split[1] + ': ' + s.venue.location;
              }
            }
            venue.shifts.push(s);
            venues.push(venue);
          }
        }
      });
      if (this.selectedVenue !== 'all') {
        return venues.filter(function (v) {
          return v.name === _this2.selectedVenue;
        });
      } else {
        return venues;
      }
    }
  }),
  created: function created() {
    if (!this.$store.state.schedule.isLoaded) {
      this.$store.dispatch('schedule/load');
    }
    if (__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.selectedDay).isBefore(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(), 'day')) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.days[this.days.length - 1].value))) {
        this.selectedDay = this.days[this.days.length - 1].value;
      } else {
        this.selectedDay = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().format('Y-MM-DD');
      }
    }
  }
});

/***/ }),

/***/ "ztXG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zvUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Alert',
  data: function data() {
    return {
      alert: 'alert',
      alertType: 'alert-' + this.type,
      alertDismissible: 'alert-dismissable'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['error', 'message']), {
    isError: function isError() {
      return this.type === 'danger';
    },
    isMessage: function isMessage() {
      return this.type === 'primary';
    }
  }),
  props: ['type'],
  methods: {
    dismiss: function dismiss(e) {
      if (this.type === 'danger') {
        this.$store.commit('clearError');
      }
      if (this.type === 'primary') {
        this.$store.commit('clearMessage');
      }
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fed1fae89221b090e282.js